// Import vendor modules.
// packages/alpinejs/src/scheduler.js
var $0712aa0f43f6aa4b$var$flushPending = false;
var $0712aa0f43f6aa4b$var$flushing = false;
var $0712aa0f43f6aa4b$var$queue = [];
var $0712aa0f43f6aa4b$var$lastFlushedIndex = -1;
var $0712aa0f43f6aa4b$var$queueNeedsSort = false;
var $0712aa0f43f6aa4b$var$transactionActive = false;
function $0712aa0f43f6aa4b$var$scheduler(callback) {
    $0712aa0f43f6aa4b$var$queueJob(callback);
}
function $0712aa0f43f6aa4b$var$startTransaction() {
    $0712aa0f43f6aa4b$var$transactionActive = true;
}
function $0712aa0f43f6aa4b$var$commitTransaction() {
    $0712aa0f43f6aa4b$var$transactionActive = false;
    $0712aa0f43f6aa4b$var$queueFlush();
}
function $0712aa0f43f6aa4b$var$queueJob(job) {
    if (!$0712aa0f43f6aa4b$var$queue.includes(job)) {
        $0712aa0f43f6aa4b$var$queue.push(job);
        if (job._x_schedulerPriority !== void 0) $0712aa0f43f6aa4b$var$queueNeedsSort = true;
    }
    $0712aa0f43f6aa4b$var$queueFlush();
}
function $0712aa0f43f6aa4b$var$dequeueJob(job) {
    let index = $0712aa0f43f6aa4b$var$queue.indexOf(job);
    if (index !== -1 && index > $0712aa0f43f6aa4b$var$lastFlushedIndex) $0712aa0f43f6aa4b$var$queue.splice(index, 1);
}
function $0712aa0f43f6aa4b$var$queueFlush() {
    if (!$0712aa0f43f6aa4b$var$flushing && !$0712aa0f43f6aa4b$var$flushPending) {
        if ($0712aa0f43f6aa4b$var$transactionActive) return;
        $0712aa0f43f6aa4b$var$flushPending = true;
        queueMicrotask($0712aa0f43f6aa4b$var$flushJobs);
    }
}
function $0712aa0f43f6aa4b$var$flushJobs() {
    $0712aa0f43f6aa4b$var$flushPending = false;
    $0712aa0f43f6aa4b$var$flushing = true;
    for(let i = 0; i < $0712aa0f43f6aa4b$var$queue.length; i++){
        if ($0712aa0f43f6aa4b$var$queueNeedsSort) $0712aa0f43f6aa4b$var$sortPendingJobs(i);
        $0712aa0f43f6aa4b$var$queue[i]();
        $0712aa0f43f6aa4b$var$lastFlushedIndex = i;
    }
    $0712aa0f43f6aa4b$var$queue.length = 0;
    $0712aa0f43f6aa4b$var$lastFlushedIndex = -1;
    $0712aa0f43f6aa4b$var$queueNeedsSort = false;
    $0712aa0f43f6aa4b$var$flushing = false;
}
function $0712aa0f43f6aa4b$var$sortPendingJobs(start2) {
    let depths = /* @__PURE__ */ new Map();
    let sorted = $0712aa0f43f6aa4b$var$queue.slice(start2).sort((a, b)=>$0712aa0f43f6aa4b$var$compareJobs(a, b, depths));
    for(let i = 0; i < sorted.length; i++)$0712aa0f43f6aa4b$var$queue[start2 + i] = sorted[i];
    $0712aa0f43f6aa4b$var$queueNeedsSort = false;
}
function $0712aa0f43f6aa4b$var$compareJobs(a, b, depths) {
    if (!$0712aa0f43f6aa4b$var$isStructural(a)) return $0712aa0f43f6aa4b$var$isStructural(b) ? 1 : 0;
    if (!$0712aa0f43f6aa4b$var$isStructural(b)) return -1;
    let depthDifference = $0712aa0f43f6aa4b$var$getElementDepth(a._x_schedulerPriority.el, depths) - $0712aa0f43f6aa4b$var$getElementDepth(b._x_schedulerPriority.el, depths);
    return depthDifference || a._x_schedulerPriority.order - b._x_schedulerPriority.order;
}
function $0712aa0f43f6aa4b$var$isStructural(job) {
    return job._x_schedulerPriority !== void 0;
}
function $0712aa0f43f6aa4b$var$getElementDepth(el, depths) {
    if (depths.has(el)) return depths.get(el);
    let depth = 0;
    let owner = el;
    while(el){
        depth++;
        if (el._x_teleportBack) el = el._x_teleportBack;
        else if (typeof ShadowRoot === "function" && el.parentNode instanceof ShadowRoot) el = el.parentNode.host;
        else el = el.parentElement;
    }
    depths.set(owner, depth);
    return depth;
}
// packages/alpinejs/src/reactivity.js
var $0712aa0f43f6aa4b$var$reactive;
var $0712aa0f43f6aa4b$var$effect;
var $0712aa0f43f6aa4b$var$release;
var $0712aa0f43f6aa4b$var$raw;
var $0712aa0f43f6aa4b$var$nextStructuralEffectOrder = 0;
var $0712aa0f43f6aa4b$var$shouldSchedule = true;
function $0712aa0f43f6aa4b$var$disableEffectScheduling(callback) {
    $0712aa0f43f6aa4b$var$shouldSchedule = false;
    callback();
    $0712aa0f43f6aa4b$var$shouldSchedule = true;
}
function $0712aa0f43f6aa4b$var$setReactivityEngine(engine) {
    $0712aa0f43f6aa4b$var$reactive = engine.reactive;
    $0712aa0f43f6aa4b$var$release = engine.release;
    $0712aa0f43f6aa4b$var$effect = (callback)=>engine.effect(callback, {
            scheduler: (task)=>{
                if ($0712aa0f43f6aa4b$var$shouldSchedule) $0712aa0f43f6aa4b$var$scheduler(task);
                else task();
            }
        });
    $0712aa0f43f6aa4b$var$raw = engine.raw;
}
function $0712aa0f43f6aa4b$var$overrideEffect(override) {
    $0712aa0f43f6aa4b$var$effect = override;
}
function $0712aa0f43f6aa4b$var$elementBoundEffect(el) {
    let cleanup = ()=>{};
    let wrappedEffect = (callback, options)=>{
        let priority = options?.priority === "structural" ? $0712aa0f43f6aa4b$var$nextStructuralEffectOrder++ : void 0;
        let effectReference = $0712aa0f43f6aa4b$var$effect(callback);
        if (priority !== void 0 && effectReference !== void 0) effectReference._x_schedulerPriority = {
            el: el,
            order: priority
        };
        if (!el._x_effects) {
            el._x_effects = /* @__PURE__ */ new Set();
            el._x_runEffects = ()=>{
                el._x_effects.forEach((i)=>i());
            };
        }
        el._x_effects.add(effectReference);
        cleanup = ()=>{
            if (effectReference === void 0) return;
            el._x_effects.delete(effectReference);
            $0712aa0f43f6aa4b$var$release(effectReference);
        };
        return effectReference;
    };
    return [
        wrappedEffect,
        ()=>{
            cleanup();
        }
    ];
}
function $0712aa0f43f6aa4b$var$watch(getter, callback) {
    let firstTime = true;
    let oldValue;
    let oldValueJSON;
    let effectReference = $0712aa0f43f6aa4b$var$effect(()=>{
        let value = getter();
        let newJSON = JSON.stringify(value);
        if (!firstTime) {
            if (typeof value === "object" || value !== oldValue) {
                let previousValue = typeof oldValue === "object" ? JSON.parse(oldValueJSON) : oldValue;
                queueMicrotask(()=>{
                    callback(value, previousValue);
                });
            }
        }
        oldValue = value;
        oldValueJSON = newJSON;
        firstTime = false;
    });
    return ()=>{
        $0712aa0f43f6aa4b$var$dequeueJob(effectReference);
        $0712aa0f43f6aa4b$var$release(effectReference);
    };
}
async function $0712aa0f43f6aa4b$var$transaction(callback) {
    $0712aa0f43f6aa4b$var$startTransaction();
    try {
        await callback();
        await Promise.resolve();
    } finally{
        $0712aa0f43f6aa4b$var$commitTransaction();
    }
}
// packages/alpinejs/src/mutation.js
var $0712aa0f43f6aa4b$var$onAttributeAddeds = [];
var $0712aa0f43f6aa4b$var$onElRemoveds = [];
var $0712aa0f43f6aa4b$var$onElAddeds = [];
function $0712aa0f43f6aa4b$var$onElAdded(callback) {
    $0712aa0f43f6aa4b$var$onElAddeds.push(callback);
}
function $0712aa0f43f6aa4b$var$onElRemoved(el, callback) {
    if (typeof callback === "function") {
        if (!el._x_cleanups) el._x_cleanups = [];
        el._x_cleanups.push(callback);
    } else {
        callback = el;
        $0712aa0f43f6aa4b$var$onElRemoveds.push(callback);
    }
}
function $0712aa0f43f6aa4b$var$onAttributesAdded(callback) {
    $0712aa0f43f6aa4b$var$onAttributeAddeds.push(callback);
}
function $0712aa0f43f6aa4b$var$onAttributeRemoved(el, name, callback) {
    if (!el._x_attributeCleanups) el._x_attributeCleanups = {};
    if (!el._x_attributeCleanups[name]) el._x_attributeCleanups[name] = [];
    el._x_attributeCleanups[name].push(callback);
}
function $0712aa0f43f6aa4b$var$cleanupAttributes(el, names) {
    if (!el._x_attributeCleanups) return;
    Object.entries(el._x_attributeCleanups).forEach(([name, value])=>{
        if (names === void 0 || names.includes(name)) {
            value.forEach((i)=>i());
            delete el._x_attributeCleanups[name];
        }
    });
}
function $0712aa0f43f6aa4b$var$cleanupElement(el) {
    el._x_effects?.forEach($0712aa0f43f6aa4b$var$dequeueJob);
    while(el._x_cleanups?.length)el._x_cleanups.pop()();
}
var $0712aa0f43f6aa4b$var$observer = new MutationObserver($0712aa0f43f6aa4b$var$onMutate);
var $0712aa0f43f6aa4b$var$currentlyObserving = false;
function $0712aa0f43f6aa4b$var$startObservingMutations() {
    $0712aa0f43f6aa4b$var$observer.observe(document, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeOldValue: true
    });
    $0712aa0f43f6aa4b$var$currentlyObserving = true;
}
function $0712aa0f43f6aa4b$var$stopObservingMutations() {
    $0712aa0f43f6aa4b$var$flushObserver();
    $0712aa0f43f6aa4b$var$observer.disconnect();
    $0712aa0f43f6aa4b$var$currentlyObserving = false;
}
var $0712aa0f43f6aa4b$var$queuedMutations = [];
function $0712aa0f43f6aa4b$var$flushObserver() {
    let records = $0712aa0f43f6aa4b$var$observer.takeRecords();
    $0712aa0f43f6aa4b$var$queuedMutations.push(()=>records.length > 0 && $0712aa0f43f6aa4b$var$onMutate(records));
    let queueLengthWhenTriggered = $0712aa0f43f6aa4b$var$queuedMutations.length;
    queueMicrotask(()=>{
        if ($0712aa0f43f6aa4b$var$queuedMutations.length === queueLengthWhenTriggered) while($0712aa0f43f6aa4b$var$queuedMutations.length > 0)$0712aa0f43f6aa4b$var$queuedMutations.shift()();
    });
}
function $0712aa0f43f6aa4b$var$flushPendingMutations() {
    while($0712aa0f43f6aa4b$var$queuedMutations.length > 0)$0712aa0f43f6aa4b$var$queuedMutations.shift()();
    let records = $0712aa0f43f6aa4b$var$observer.takeRecords();
    if (records.length > 0) $0712aa0f43f6aa4b$var$onMutate(records);
}
function $0712aa0f43f6aa4b$var$mutateDom(callback) {
    if (!$0712aa0f43f6aa4b$var$currentlyObserving) return callback();
    $0712aa0f43f6aa4b$var$stopObservingMutations();
    try {
        return callback();
    } finally{
        $0712aa0f43f6aa4b$var$startObservingMutations();
    }
}
var $0712aa0f43f6aa4b$var$isCollecting = false;
var $0712aa0f43f6aa4b$var$deferredMutations = [];
function $0712aa0f43f6aa4b$var$deferMutations() {
    $0712aa0f43f6aa4b$var$isCollecting = true;
}
function $0712aa0f43f6aa4b$var$flushAndStopDeferringMutations() {
    $0712aa0f43f6aa4b$var$isCollecting = false;
    $0712aa0f43f6aa4b$var$onMutate($0712aa0f43f6aa4b$var$deferredMutations);
    $0712aa0f43f6aa4b$var$deferredMutations = [];
}
function $0712aa0f43f6aa4b$var$onMutate(mutations) {
    if ($0712aa0f43f6aa4b$var$isCollecting) {
        $0712aa0f43f6aa4b$var$deferredMutations = $0712aa0f43f6aa4b$var$deferredMutations.concat(mutations);
        return;
    }
    let addedNodes = [];
    let removedNodes = /* @__PURE__ */ new Set();
    let addedAttributes = /* @__PURE__ */ new Map();
    let removedAttributes = /* @__PURE__ */ new Map();
    for(let i = 0; i < mutations.length; i++){
        if (mutations[i].target._x_ignoreMutationObserver) continue;
        if (mutations[i].type === "childList") {
            mutations[i].removedNodes.forEach((node)=>{
                if (node.nodeType !== 1) return;
                if (!node._x_marker) return;
                removedNodes.add(node);
            });
            mutations[i].addedNodes.forEach((node)=>{
                if (node.nodeType !== 1) return;
                if (removedNodes.has(node)) {
                    removedNodes.delete(node);
                    return;
                }
                if (node._x_marker) return;
                addedNodes.push(node);
            });
        }
        if (mutations[i].type === "attributes") {
            let el = mutations[i].target;
            let name = mutations[i].attributeName;
            let oldValue = mutations[i].oldValue;
            let add = ()=>{
                if (!addedAttributes.has(el)) addedAttributes.set(el, []);
                addedAttributes.get(el).push({
                    name: name,
                    value: el.getAttribute(name)
                });
            };
            let remove2 = ()=>{
                if (!removedAttributes.has(el)) removedAttributes.set(el, []);
                removedAttributes.get(el).push(name);
            };
            if (el.hasAttribute(name) && oldValue === null) add();
            else if (el.hasAttribute(name)) {
                remove2();
                add();
            } else remove2();
        }
    }
    removedAttributes.forEach((attrs, el)=>{
        $0712aa0f43f6aa4b$var$cleanupAttributes(el, attrs);
    });
    addedAttributes.forEach((attrs, el)=>{
        $0712aa0f43f6aa4b$var$onAttributeAddeds.forEach((i)=>i(el, attrs));
    });
    for (let node of removedNodes){
        if (addedNodes.some((i)=>i.contains(node))) continue;
        $0712aa0f43f6aa4b$var$onElRemoveds.forEach((i)=>i(node));
    }
    for (let node of addedNodes){
        if (!node.isConnected) continue;
        $0712aa0f43f6aa4b$var$onElAddeds.forEach((i)=>i(node));
    }
    addedNodes = null;
    removedNodes = null;
    addedAttributes = null;
    removedAttributes = null;
}
// packages/alpinejs/src/scope.js
function $0712aa0f43f6aa4b$var$scope(node) {
    return $0712aa0f43f6aa4b$var$mergeProxies($0712aa0f43f6aa4b$var$closestDataStack(node));
}
function $0712aa0f43f6aa4b$var$addScopeToNode(node, data2, referenceNode) {
    node._x_dataStack = [
        data2,
        ...$0712aa0f43f6aa4b$var$closestDataStack(referenceNode || node)
    ];
    return ()=>{
        node._x_dataStack = node._x_dataStack.filter((i)=>i !== data2);
    };
}
function $0712aa0f43f6aa4b$var$closestDataStack(node) {
    if (node._x_dataStack) return node._x_dataStack;
    if (typeof ShadowRoot === "function" && node instanceof ShadowRoot) return $0712aa0f43f6aa4b$var$closestDataStack(node.host);
    if (!node.parentNode) return [];
    return $0712aa0f43f6aa4b$var$closestDataStack(node.parentNode);
}
function $0712aa0f43f6aa4b$var$mergeProxies(objects) {
    return new Proxy({
        objects: objects
    }, $0712aa0f43f6aa4b$var$mergeProxyTrap);
}
function $0712aa0f43f6aa4b$var$keyInPrototypeChain(obj, key) {
    if (obj === null || obj === Object.prototype) return null;
    if (Object.prototype.hasOwnProperty.call(obj, key)) return obj;
    return $0712aa0f43f6aa4b$var$keyInPrototypeChain(Object.getPrototypeOf(obj), key);
}
var $0712aa0f43f6aa4b$var$mergeProxyTrap = {
    ownKeys ({ objects: objects }) {
        return Array.from(new Set(objects.flatMap((i)=>Object.keys(i))));
    },
    has ({ objects: objects }, name) {
        if (name == Symbol.unscopables) return false;
        return objects.some((obj)=>Object.prototype.hasOwnProperty.call(obj, name) || Reflect.has(obj, name));
    },
    get ({ objects: objects }, name, thisProxy) {
        if (name == "toJSON") return $0712aa0f43f6aa4b$var$collapseProxies;
        return Reflect.get(objects.find((obj)=>Reflect.has(obj, name)) || {}, name, thisProxy);
    },
    set ({ objects: objects }, name, value, thisProxy) {
        let target;
        for (const obj of objects){
            target = $0712aa0f43f6aa4b$var$keyInPrototypeChain(obj, name);
            if (target) break;
        }
        if (!target) target = objects[objects.length - 1];
        const descriptor = Object.getOwnPropertyDescriptor(target, name);
        if (descriptor?.set && descriptor?.get) return descriptor.set.call(thisProxy, value) || true;
        return Reflect.set(target, name, value);
    }
};
function $0712aa0f43f6aa4b$var$collapseProxies() {
    let keys = Reflect.ownKeys(this);
    return keys.reduce((acc, key)=>{
        acc[key] = Reflect.get(this, key);
        return acc;
    }, {});
}
// packages/alpinejs/src/interceptor.js
function $0712aa0f43f6aa4b$var$initInterceptors(data2, cleanup = ()=>{}) {
    let isObject3 = (val)=>typeof val === "object" && !Array.isArray(val) && val !== null;
    let recurse = (obj, basePath = "")=>{
        Object.entries(Object.getOwnPropertyDescriptors(obj)).forEach(([key, { value: value, enumerable: enumerable }])=>{
            if (enumerable === false || value === void 0) return;
            if (typeof value === "object" && value !== null && value.__v_skip) return;
            let path = basePath === "" ? key : `${basePath}.${key}`;
            if (typeof value === "object" && value !== null && value._x_interceptor) obj[key] = value.initialize(data2, path, key, cleanup);
            else if (isObject3(value) && value !== obj && !(value instanceof Element)) recurse(value, path);
        });
    };
    return recurse(data2);
}
function $0712aa0f43f6aa4b$var$interceptor(callback, mutateObj = ()=>{}) {
    let obj = {
        initialValue: void 0,
        _x_interceptor: true,
        initialize (data2, path, key, cleanup) {
            return callback(this.initialValue, ()=>$0712aa0f43f6aa4b$var$get(data2, path), (value)=>$0712aa0f43f6aa4b$var$set(data2, path, value), path, key, cleanup);
        }
    };
    mutateObj(obj);
    return (initialValue)=>{
        if (typeof initialValue === "object" && initialValue !== null && initialValue._x_interceptor) {
            let initialize = obj.initialize.bind(obj);
            obj.initialize = (data2, path, key, cleanup)=>{
                let innerValue = initialValue.initialize(data2, path, key, cleanup);
                obj.initialValue = innerValue;
                return initialize(data2, path, key, cleanup);
            };
        } else obj.initialValue = initialValue;
        return obj;
    };
}
function $0712aa0f43f6aa4b$var$get(obj, path) {
    return path.split(".").reduce((carry, segment)=>carry[segment], obj);
}
function $0712aa0f43f6aa4b$var$set(obj, path, value) {
    if (typeof path === "string") path = path.split(".");
    if (path.length === 1) obj[path[0]] = value;
    else if (path.length === 0) throw error;
    else {
        if (obj[path[0]]) return $0712aa0f43f6aa4b$var$set(obj[path[0]], path.slice(1), value);
        else {
            obj[path[0]] = {};
            return $0712aa0f43f6aa4b$var$set(obj[path[0]], path.slice(1), value);
        }
    }
}
// packages/alpinejs/src/magics.js
var $0712aa0f43f6aa4b$var$magics = {};
function $0712aa0f43f6aa4b$var$magic(name, callback) {
    $0712aa0f43f6aa4b$var$magics[name] = callback;
}
function $0712aa0f43f6aa4b$var$injectMagics(obj, el) {
    let memoizedUtilities = $0712aa0f43f6aa4b$var$getUtilities(el);
    Object.entries($0712aa0f43f6aa4b$var$magics).forEach(([name, callback])=>{
        Object.defineProperty(obj, `$${name}`, {
            get () {
                return callback(el, memoizedUtilities);
            },
            enumerable: false
        });
    });
    return obj;
}
function $0712aa0f43f6aa4b$var$getUtilities(el) {
    let [utilities, cleanup] = $0712aa0f43f6aa4b$var$getElementBoundUtilities(el);
    let utils = {
        interceptor: $0712aa0f43f6aa4b$var$interceptor,
        ...utilities
    };
    $0712aa0f43f6aa4b$var$onElRemoved(el, cleanup);
    return utils;
}
// packages/alpinejs/src/utils/error.js
function $0712aa0f43f6aa4b$var$tryCatch(el, expression, callback, ...args) {
    try {
        return callback(...args);
    } catch (e) {
        $0712aa0f43f6aa4b$var$handleError(e, el, expression);
    }
}
function $0712aa0f43f6aa4b$var$handleError(...args) {
    return $0712aa0f43f6aa4b$var$errorHandler(...args);
}
var $0712aa0f43f6aa4b$var$errorHandler = $0712aa0f43f6aa4b$var$normalErrorHandler;
function $0712aa0f43f6aa4b$var$setErrorHandler(handler4) {
    $0712aa0f43f6aa4b$var$errorHandler = handler4;
}
function $0712aa0f43f6aa4b$var$normalErrorHandler(error2, el, expression) {
    error2 = Object.assign(error2 ?? {
        message: "No error message given."
    }, {
        el: el,
        expression: expression
    });
    console.warn(`Alpine Expression Error: ${error2.message}

${expression ? 'Expression: "' + expression + '"\n\n' : ""}`, el);
    setTimeout(()=>{
        throw error2;
    }, 0);
}
// packages/alpinejs/src/evaluator.js
var $0712aa0f43f6aa4b$var$shouldAutoEvaluateFunctions = true;
function $0712aa0f43f6aa4b$var$dontAutoEvaluateFunctions(callback) {
    let cache = $0712aa0f43f6aa4b$var$shouldAutoEvaluateFunctions;
    $0712aa0f43f6aa4b$var$shouldAutoEvaluateFunctions = false;
    let result = callback();
    $0712aa0f43f6aa4b$var$shouldAutoEvaluateFunctions = cache;
    return result;
}
function $0712aa0f43f6aa4b$var$evaluate(el, expression, extras = {}) {
    let result;
    $0712aa0f43f6aa4b$var$evaluateLater(el, expression)((value)=>result = value, extras);
    return result;
}
function $0712aa0f43f6aa4b$var$evaluateLater(...args) {
    return $0712aa0f43f6aa4b$var$theEvaluatorFunction(...args);
}
var $0712aa0f43f6aa4b$var$theEvaluatorFunction = ()=>{};
function $0712aa0f43f6aa4b$var$setEvaluator(newEvaluator) {
    $0712aa0f43f6aa4b$var$theEvaluatorFunction = newEvaluator;
}
var $0712aa0f43f6aa4b$var$theRawEvaluatorFunction;
function $0712aa0f43f6aa4b$var$setRawEvaluator(newEvaluator) {
    $0712aa0f43f6aa4b$var$theRawEvaluatorFunction = newEvaluator;
}
function $0712aa0f43f6aa4b$var$generateEvaluatorFromFunction(dataStack, func) {
    return (receiver = ()=>{}, { scope: scope2 = {}, params: params = [], context: context } = {})=>{
        if (!$0712aa0f43f6aa4b$var$shouldAutoEvaluateFunctions) {
            $0712aa0f43f6aa4b$var$runIfTypeOfFunction(receiver, func, $0712aa0f43f6aa4b$var$mergeProxies([
                scope2,
                ...dataStack
            ]), params);
            return;
        }
        let result = func.apply($0712aa0f43f6aa4b$var$mergeProxies([
            scope2,
            ...dataStack
        ]), params);
        $0712aa0f43f6aa4b$var$runIfTypeOfFunction(receiver, result);
    };
}
function $0712aa0f43f6aa4b$var$runIfTypeOfFunction(receiver, value, scope2, params, el) {
    if ($0712aa0f43f6aa4b$var$shouldAutoEvaluateFunctions && typeof value === "function") {
        let result = value.apply(scope2, params);
        if (result instanceof Promise) result.then((i)=>$0712aa0f43f6aa4b$var$runIfTypeOfFunction(receiver, i, scope2, params)).catch((error2)=>$0712aa0f43f6aa4b$var$handleError(error2, el, value));
        else receiver(result);
    } else if (typeof value === "object" && value instanceof Promise) value.then((i)=>receiver(i));
    else receiver(value);
}
function $0712aa0f43f6aa4b$var$evaluateRaw(...args) {
    return $0712aa0f43f6aa4b$var$theRawEvaluatorFunction(...args);
}
// packages/alpinejs/src/directives.js
var $0712aa0f43f6aa4b$var$prefixAsString = "x-";
function $0712aa0f43f6aa4b$var$prefix(subject = "") {
    return $0712aa0f43f6aa4b$var$prefixAsString + subject;
}
function $0712aa0f43f6aa4b$var$setPrefix(newPrefix) {
    $0712aa0f43f6aa4b$var$prefixAsString = newPrefix;
}
var $0712aa0f43f6aa4b$var$directiveHandlers = {};
function $0712aa0f43f6aa4b$var$directive(name, callback) {
    $0712aa0f43f6aa4b$var$directiveHandlers[name] = callback;
    return {
        before (directive2) {
            if (!$0712aa0f43f6aa4b$var$directiveHandlers[directive2]) {
                console.warn(String.raw`Cannot find directive \`${directive2}\`. \`${name}\` will use the default order of execution`);
                return;
            }
            const pos = $0712aa0f43f6aa4b$var$directiveOrder.indexOf(directive2);
            $0712aa0f43f6aa4b$var$directiveOrder.splice(pos >= 0 ? pos : $0712aa0f43f6aa4b$var$directiveOrder.indexOf("DEFAULT"), 0, name);
        }
    };
}
function $0712aa0f43f6aa4b$var$directiveExists(name) {
    return Object.keys($0712aa0f43f6aa4b$var$directiveHandlers).includes(name);
}
function $0712aa0f43f6aa4b$var$directives(el, attributes, originalAttributeOverride) {
    attributes = Array.from(attributes);
    if (el._x_virtualDirectives) {
        let vAttributes = Object.entries(el._x_virtualDirectives).map(([name, value])=>({
                name: name,
                value: value
            }));
        let staticAttributes = $0712aa0f43f6aa4b$var$attributesOnly(vAttributes);
        vAttributes = vAttributes.map((attribute)=>{
            if (staticAttributes.find((attr)=>attr.name === attribute.name)) return {
                name: `x-bind:${attribute.name}`,
                value: `"${attribute.value}"`
            };
            return attribute;
        });
        attributes = attributes.concat(vAttributes);
    }
    let transformedAttributeMap = {};
    let directives2 = attributes.map($0712aa0f43f6aa4b$var$toTransformedAttributes((newName, oldName)=>transformedAttributeMap[newName] = oldName)).filter($0712aa0f43f6aa4b$var$outNonAlpineAttributes).map($0712aa0f43f6aa4b$var$toParsedDirectives(transformedAttributeMap, originalAttributeOverride)).sort($0712aa0f43f6aa4b$var$byPriority);
    return directives2.map((directive2)=>{
        return $0712aa0f43f6aa4b$var$getDirectiveHandler(el, directive2);
    });
}
function $0712aa0f43f6aa4b$var$attributesOnly(attributes) {
    return Array.from(attributes).map($0712aa0f43f6aa4b$var$toTransformedAttributes()).filter((attr)=>!$0712aa0f43f6aa4b$var$outNonAlpineAttributes(attr));
}
var $0712aa0f43f6aa4b$var$isDeferringHandlers = false;
var $0712aa0f43f6aa4b$var$directiveHandlerStacks = /* @__PURE__ */ new Map();
var $0712aa0f43f6aa4b$var$currentHandlerStackKey = Symbol();
function $0712aa0f43f6aa4b$var$deferHandlingDirectives(callback) {
    $0712aa0f43f6aa4b$var$isDeferringHandlers = true;
    let key = Symbol();
    $0712aa0f43f6aa4b$var$currentHandlerStackKey = key;
    $0712aa0f43f6aa4b$var$directiveHandlerStacks.set(key, []);
    let flushHandlers = ()=>{
        while($0712aa0f43f6aa4b$var$directiveHandlerStacks.get(key).length)$0712aa0f43f6aa4b$var$directiveHandlerStacks.get(key).shift()();
        $0712aa0f43f6aa4b$var$directiveHandlerStacks.delete(key);
    };
    let stopDeferring = ()=>{
        $0712aa0f43f6aa4b$var$isDeferringHandlers = false;
        flushHandlers();
    };
    callback(flushHandlers);
    stopDeferring();
}
function $0712aa0f43f6aa4b$var$getElementBoundUtilities(el) {
    let cleanups = [];
    let cleanup = (callback)=>cleanups.push(callback);
    let [effect3, cleanupEffect2] = $0712aa0f43f6aa4b$var$elementBoundEffect(el);
    cleanups.push(cleanupEffect2);
    let utilities = {
        Alpine: $0712aa0f43f6aa4b$var$alpine_default,
        effect: effect3,
        cleanup: cleanup,
        evaluateLater: $0712aa0f43f6aa4b$var$evaluateLater.bind($0712aa0f43f6aa4b$var$evaluateLater, el),
        evaluate: $0712aa0f43f6aa4b$var$evaluate.bind($0712aa0f43f6aa4b$var$evaluate, el)
    };
    let doCleanup = ()=>cleanups.forEach((i)=>i());
    return [
        utilities,
        doCleanup
    ];
}
function $0712aa0f43f6aa4b$var$getDirectiveHandler(el, directive2) {
    let noop = ()=>{};
    let handler4 = $0712aa0f43f6aa4b$var$directiveHandlers[directive2.type] || noop;
    let [utilities, cleanup] = $0712aa0f43f6aa4b$var$getElementBoundUtilities(el);
    $0712aa0f43f6aa4b$var$onAttributeRemoved(el, directive2.original, cleanup);
    let fullHandler = ()=>{
        if (el._x_ignore || el._x_ignoreSelf) return;
        handler4.inline && handler4.inline(el, directive2, utilities);
        handler4 = handler4.bind(handler4, el, directive2, utilities);
        $0712aa0f43f6aa4b$var$isDeferringHandlers ? $0712aa0f43f6aa4b$var$directiveHandlerStacks.get($0712aa0f43f6aa4b$var$currentHandlerStackKey).push(handler4) : handler4();
    };
    fullHandler.runCleanups = cleanup;
    return fullHandler;
}
var $0712aa0f43f6aa4b$var$startingWith = (subject, replacement)=>({ name: name, value: value })=>{
        if (name.startsWith(subject)) name = name.replace(subject, replacement);
        return {
            name: name,
            value: value
        };
    };
var $0712aa0f43f6aa4b$var$into = (i)=>i;
function $0712aa0f43f6aa4b$var$toTransformedAttributes(callback = ()=>{}) {
    return ({ name: name, value: value })=>{
        let { name: newName, value: newValue } = $0712aa0f43f6aa4b$var$attributeTransformers.reduce((carry, transform)=>{
            return transform(carry);
        }, {
            name: name,
            value: value
        });
        if (newName !== name) callback(newName, name);
        return {
            name: newName,
            value: newValue
        };
    };
}
var $0712aa0f43f6aa4b$var$attributeTransformers = [];
function $0712aa0f43f6aa4b$var$mapAttributes(callback) {
    $0712aa0f43f6aa4b$var$attributeTransformers.push(callback);
}
function $0712aa0f43f6aa4b$var$outNonAlpineAttributes({ name: name }) {
    return $0712aa0f43f6aa4b$var$alpineAttributeRegex().test(name);
}
var $0712aa0f43f6aa4b$var$alpineAttributeRegex = ()=>new RegExp(`^${$0712aa0f43f6aa4b$var$prefixAsString}([^:^.]+)\\b`);
function $0712aa0f43f6aa4b$var$toParsedDirectives(transformedAttributeMap, originalAttributeOverride) {
    return ({ name: name, value: value })=>{
        if (name === value) value = "";
        let typeMatch = name.match($0712aa0f43f6aa4b$var$alpineAttributeRegex());
        let valueMatch = name.match(/:([a-zA-Z0-9\-_:]+)/);
        let modifiers = name.match(/\.[^.\]]+(?=[^\]]*$)/g) || [];
        let original = originalAttributeOverride || transformedAttributeMap[name] || name;
        return {
            type: typeMatch ? typeMatch[1] : null,
            value: valueMatch ? valueMatch[1] : null,
            modifiers: modifiers.map((i)=>i.replace(".", "")),
            expression: value,
            original: original
        };
    };
}
var $0712aa0f43f6aa4b$var$DEFAULT = "DEFAULT";
var $0712aa0f43f6aa4b$var$directiveOrder = [
    "ignore",
    "ref",
    "id",
    "data",
    "anchor",
    "bind",
    "init",
    "for",
    "model",
    "modelable",
    "transition",
    "show",
    "if",
    $0712aa0f43f6aa4b$var$DEFAULT,
    "teleport"
];
function $0712aa0f43f6aa4b$var$byPriority(a, b) {
    let typeA = $0712aa0f43f6aa4b$var$directiveOrder.indexOf(a.type) === -1 ? $0712aa0f43f6aa4b$var$DEFAULT : a.type;
    let typeB = $0712aa0f43f6aa4b$var$directiveOrder.indexOf(b.type) === -1 ? $0712aa0f43f6aa4b$var$DEFAULT : b.type;
    return $0712aa0f43f6aa4b$var$directiveOrder.indexOf(typeA) - $0712aa0f43f6aa4b$var$directiveOrder.indexOf(typeB);
}
// packages/alpinejs/src/utils/walk.js
function $0712aa0f43f6aa4b$var$walk(el, callback) {
    if (typeof ShadowRoot === "function" && el instanceof ShadowRoot) {
        Array.from(el.children).forEach((el2)=>$0712aa0f43f6aa4b$var$walk(el2, callback));
        return;
    }
    let skip = false;
    callback(el, ()=>skip = true);
    if (skip) return;
    let node = el.firstElementChild;
    while(node){
        $0712aa0f43f6aa4b$var$walk(node, callback, false);
        node = node.nextElementSibling;
    }
}
// packages/alpinejs/src/clone.js
var $0712aa0f43f6aa4b$var$isCloning = false;
function $0712aa0f43f6aa4b$var$skipDuringClone(callback, fallback = ()=>{}) {
    return (...args)=>$0712aa0f43f6aa4b$var$isCloning ? fallback(...args) : callback(...args);
}
function $0712aa0f43f6aa4b$var$onlyDuringClone(callback) {
    return (...args)=>$0712aa0f43f6aa4b$var$isCloning && callback(...args);
}
var $0712aa0f43f6aa4b$var$interceptors = [];
function $0712aa0f43f6aa4b$var$interceptClone(callback) {
    $0712aa0f43f6aa4b$var$interceptors.push(callback);
}
function $0712aa0f43f6aa4b$var$cloneNode(from, to) {
    $0712aa0f43f6aa4b$var$interceptors.forEach((i)=>i(from, to));
    $0712aa0f43f6aa4b$var$isCloning = true;
    $0712aa0f43f6aa4b$var$dontRegisterReactiveSideEffects(()=>{
        $0712aa0f43f6aa4b$var$initTree(to, (el, callback)=>{
            callback(el, ()=>{});
        });
    });
    $0712aa0f43f6aa4b$var$isCloning = false;
}
var $0712aa0f43f6aa4b$var$isCloningLegacy = false;
function $0712aa0f43f6aa4b$var$clone(oldEl, newEl) {
    if (!newEl._x_dataStack) newEl._x_dataStack = oldEl._x_dataStack;
    $0712aa0f43f6aa4b$var$isCloning = true;
    $0712aa0f43f6aa4b$var$isCloningLegacy = true;
    $0712aa0f43f6aa4b$var$dontRegisterReactiveSideEffects(()=>{
        $0712aa0f43f6aa4b$var$cloneTree(newEl);
    });
    $0712aa0f43f6aa4b$var$isCloning = false;
    $0712aa0f43f6aa4b$var$isCloningLegacy = false;
}
function $0712aa0f43f6aa4b$var$cloneTree(el) {
    let hasRunThroughFirstEl = false;
    let shallowWalker = (el2, callback)=>{
        $0712aa0f43f6aa4b$var$walk(el2, (el3, skip)=>{
            if (hasRunThroughFirstEl && $0712aa0f43f6aa4b$var$isRoot(el3)) return skip();
            hasRunThroughFirstEl = true;
            callback(el3, skip);
        });
    };
    $0712aa0f43f6aa4b$var$initTree(el, shallowWalker);
}
function $0712aa0f43f6aa4b$var$dontRegisterReactiveSideEffects(callback) {
    let cache = $0712aa0f43f6aa4b$var$effect;
    $0712aa0f43f6aa4b$var$overrideEffect((callback2, el)=>{
        let storedEffect = cache(callback2);
        $0712aa0f43f6aa4b$var$release(storedEffect);
        return ()=>{};
    });
    callback();
    $0712aa0f43f6aa4b$var$overrideEffect(cache);
}
// packages/alpinejs/src/deferInit.js
var $0712aa0f43f6aa4b$var$activeDefers = 0;
function $0712aa0f43f6aa4b$var$deferInit(el, promise) {
    let record = el._x_deferInit;
    if (!record) {
        record = el._x_deferInit = {
            pending: 0,
            ownsIgnore: !el._x_ignore,
            queuedAttributes: /* @__PURE__ */ new Map()
        };
        if (record.ownsIgnore) el._x_ignore = true;
        $0712aa0f43f6aa4b$var$activeDefers++;
    }
    record.pending++;
    Promise.resolve(promise).catch((error2)=>{
        try {
            $0712aa0f43f6aa4b$var$handleError(error2, el);
        } catch (error3) {
            setTimeout(()=>{
                throw error3;
            }, 0);
        }
    }).then(()=>$0712aa0f43f6aa4b$var$settle(el, record));
}
function $0712aa0f43f6aa4b$var$settle(el, record) {
    record.pending--;
    if (record.pending > 0) return;
    $0712aa0f43f6aa4b$var$flushPendingMutations();
    if (record.pending > 0) return;
    if (el._x_deferInit !== record) return;
    delete el._x_deferInit;
    if (record.ownsIgnore) delete el._x_ignore;
    $0712aa0f43f6aa4b$var$activeDefers--;
    if (!el.isConnected) return;
    $0712aa0f43f6aa4b$var$replayQueuedAttributes(record);
    $0712aa0f43f6aa4b$var$initTree(el);
}
function $0712aa0f43f6aa4b$var$queueAttributesForDeferredTree(el, attrs) {
    if ($0712aa0f43f6aa4b$var$activeDefers === 0) return false;
    let root = $0712aa0f43f6aa4b$var$findClosest(el, (i)=>i._x_deferInit);
    if (!root) return false;
    $0712aa0f43f6aa4b$var$queueInto(root._x_deferInit, el, attrs.map(({ name: name })=>name));
    return true;
}
function $0712aa0f43f6aa4b$var$queueInto(record, el, names) {
    let entry = record.queuedAttributes.get(el);
    if (!entry || entry.marker !== el._x_marker) {
        entry = {
            marker: el._x_marker,
            names: /* @__PURE__ */ new Set()
        };
        record.queuedAttributes.set(el, entry);
    }
    names.forEach((name)=>entry.names.add(name));
}
function $0712aa0f43f6aa4b$var$replayQueuedAttributes(record) {
    record.queuedAttributes.forEach((entry, el)=>{
        if (!el.isConnected) return;
        if (!el._x_marker) return;
        if (el._x_marker !== entry.marker) return;
        let suspendedAncestor = $0712aa0f43f6aa4b$var$findClosest(el, (i)=>i._x_deferInit);
        if (suspendedAncestor) {
            $0712aa0f43f6aa4b$var$queueInto(suspendedAncestor._x_deferInit, el, Array.from(entry.names));
            return;
        }
        let attrs = Array.from(entry.names).filter((name)=>el.hasAttribute(name)).map((name)=>({
                name: name,
                value: el.getAttribute(name)
            }));
        if (attrs.length === 0) return;
        $0712aa0f43f6aa4b$var$directives(el, attrs).forEach((handle)=>handle());
    });
}
$0712aa0f43f6aa4b$var$interceptClone((from, to)=>{
    if ($0712aa0f43f6aa4b$var$activeDefers === 0) return;
    if (!from || from.nodeType !== 1 || !to || to.nodeType !== 1) return;
    if ($0712aa0f43f6aa4b$var$findClosest(from, (i)=>i._x_deferInit)) to._x_ignore = true;
});
// packages/alpinejs/src/utils/dispatch.js
function $0712aa0f43f6aa4b$var$dispatch(el, name, detail = {}, options = {}) {
    return el.dispatchEvent(new CustomEvent(name, {
        detail: detail,
        bubbles: true,
        // Allows events to pass the shadow DOM barrier.
        composed: true,
        cancelable: true,
        // Allows overriding the default event options.
        ...options
    }));
}
// packages/alpinejs/src/utils/warn.js
function $0712aa0f43f6aa4b$var$warn(message, ...args) {
    console.warn(`Alpine Warning: ${message}`, ...args);
}
// packages/alpinejs/src/lifecycle.js
var $0712aa0f43f6aa4b$var$started = false;
function $0712aa0f43f6aa4b$var$start() {
    if ($0712aa0f43f6aa4b$var$started) $0712aa0f43f6aa4b$var$warn("Alpine has already been initialized on this page. Calling Alpine.start() more than once can cause problems.");
    $0712aa0f43f6aa4b$var$started = true;
    if (!document.body) $0712aa0f43f6aa4b$var$warn("Unable to initialize. Trying to load Alpine before `<body>` is available. Did you forget to add `defer` in Alpine's `<script>` tag?");
    $0712aa0f43f6aa4b$var$dispatch(document, "alpine:init");
    $0712aa0f43f6aa4b$var$dispatch(document, "alpine:initializing");
    $0712aa0f43f6aa4b$var$startObservingMutations();
    $0712aa0f43f6aa4b$var$onElAdded((el)=>$0712aa0f43f6aa4b$var$initTree(el, $0712aa0f43f6aa4b$var$walk));
    $0712aa0f43f6aa4b$var$onElRemoved((el)=>$0712aa0f43f6aa4b$var$destroyTree(el));
    $0712aa0f43f6aa4b$var$onAttributesAdded((el, attrs)=>{
        if ($0712aa0f43f6aa4b$var$queueAttributesForDeferredTree(el, attrs)) return;
        $0712aa0f43f6aa4b$var$directives(el, attrs).forEach((handle)=>handle());
    });
    let outNestedComponents = (el)=>!$0712aa0f43f6aa4b$var$closestRoot(el.parentElement, true);
    Array.from(document.querySelectorAll($0712aa0f43f6aa4b$var$allSelectors().join(","))).filter(outNestedComponents).forEach((el)=>{
        $0712aa0f43f6aa4b$var$initTree(el);
    });
    $0712aa0f43f6aa4b$var$dispatch(document, "alpine:initialized");
    setTimeout(()=>{
        $0712aa0f43f6aa4b$var$warnAboutMissingPlugins();
    });
}
var $0712aa0f43f6aa4b$var$rootSelectorCallbacks = [];
var $0712aa0f43f6aa4b$var$initSelectorCallbacks = [];
function $0712aa0f43f6aa4b$var$rootSelectors() {
    return $0712aa0f43f6aa4b$var$rootSelectorCallbacks.map((fn)=>fn());
}
function $0712aa0f43f6aa4b$var$allSelectors() {
    return $0712aa0f43f6aa4b$var$rootSelectorCallbacks.concat($0712aa0f43f6aa4b$var$initSelectorCallbacks).map((fn)=>fn());
}
function $0712aa0f43f6aa4b$var$addRootSelector(selectorCallback) {
    $0712aa0f43f6aa4b$var$rootSelectorCallbacks.push(selectorCallback);
}
function $0712aa0f43f6aa4b$var$addInitSelector(selectorCallback) {
    $0712aa0f43f6aa4b$var$initSelectorCallbacks.push(selectorCallback);
}
function $0712aa0f43f6aa4b$var$closestRoot(el, includeInitSelectors = false) {
    return $0712aa0f43f6aa4b$var$findClosest(el, (element)=>{
        const selectors = includeInitSelectors ? $0712aa0f43f6aa4b$var$allSelectors() : $0712aa0f43f6aa4b$var$rootSelectors();
        if (selectors.some((selector)=>element.matches(selector))) return true;
    });
}
function $0712aa0f43f6aa4b$var$findClosest(el, callback) {
    if (!el) return;
    if (callback(el)) return el;
    if (el._x_teleportBack) return $0712aa0f43f6aa4b$var$findClosest(el._x_teleportBack, callback);
    if (el.parentNode instanceof ShadowRoot) return $0712aa0f43f6aa4b$var$findClosest(el.parentNode.host, callback);
    if (!el.parentElement) return;
    return $0712aa0f43f6aa4b$var$findClosest(el.parentElement, callback);
}
function $0712aa0f43f6aa4b$var$isRoot(el) {
    return $0712aa0f43f6aa4b$var$rootSelectors().some((selector)=>el.matches(selector));
}
var $0712aa0f43f6aa4b$var$initInterceptors2 = [];
function $0712aa0f43f6aa4b$var$interceptInit(callback) {
    $0712aa0f43f6aa4b$var$initInterceptors2.push(callback);
}
var $0712aa0f43f6aa4b$var$markerDispenser = 1;
function $0712aa0f43f6aa4b$var$initTree(el, walker = $0712aa0f43f6aa4b$var$walk, intercept = ()=>{}) {
    if ($0712aa0f43f6aa4b$var$findClosest(el, (i)=>i._x_ignore)) return;
    $0712aa0f43f6aa4b$var$deferHandlingDirectives(()=>{
        walker(el, (el2, skip)=>{
            if (el2._x_marker) return;
            intercept(el2, skip);
            $0712aa0f43f6aa4b$var$initInterceptors2.forEach((i)=>i(el2, skip));
            $0712aa0f43f6aa4b$var$directives(el2, el2.attributes).forEach((handle)=>handle());
            if (!el2._x_ignore) el2._x_marker = $0712aa0f43f6aa4b$var$markerDispenser++;
            el2._x_ignore && skip();
        });
    });
}
function $0712aa0f43f6aa4b$var$destroyTree(root, walker = $0712aa0f43f6aa4b$var$walk) {
    walker(root, (el)=>{
        $0712aa0f43f6aa4b$var$cleanupElement(el);
        $0712aa0f43f6aa4b$var$cleanupAttributes(el);
        delete el._x_marker;
    });
}
function $0712aa0f43f6aa4b$var$warnAboutMissingPlugins() {
    let pluginDirectives = [
        [
            "ui",
            "dialog",
            [
                "[x-dialog], [x-popover]"
            ]
        ],
        [
            "anchor",
            "anchor",
            [
                "[x-anchor]"
            ]
        ],
        [
            "sort",
            "sort",
            [
                "[x-sort]"
            ]
        ]
    ];
    pluginDirectives.forEach(([plugin2, directive2, selectors])=>{
        if ($0712aa0f43f6aa4b$var$directiveExists(directive2)) return;
        selectors.some((selector)=>{
            if (document.querySelector(selector)) {
                $0712aa0f43f6aa4b$var$warn(`found "${selector}", but missing ${plugin2} plugin`);
                return true;
            }
        });
    });
}
// packages/alpinejs/src/nextTick.js
var $0712aa0f43f6aa4b$var$tickStack = [];
var $0712aa0f43f6aa4b$var$isHolding = false;
function $0712aa0f43f6aa4b$var$nextTick(callback = ()=>{}) {
    queueMicrotask(()=>{
        $0712aa0f43f6aa4b$var$isHolding || setTimeout(()=>{
            $0712aa0f43f6aa4b$var$releaseNextTicks();
        });
    });
    return new Promise((res)=>{
        $0712aa0f43f6aa4b$var$tickStack.push(()=>{
            callback();
            res();
        });
    });
}
function $0712aa0f43f6aa4b$var$releaseNextTicks() {
    $0712aa0f43f6aa4b$var$isHolding = false;
    while($0712aa0f43f6aa4b$var$tickStack.length)$0712aa0f43f6aa4b$var$tickStack.shift()();
}
function $0712aa0f43f6aa4b$var$holdNextTicks() {
    $0712aa0f43f6aa4b$var$isHolding = true;
}
// packages/alpinejs/src/utils/classes.js
function $0712aa0f43f6aa4b$var$setClasses(el, value) {
    if (Array.isArray(value)) return $0712aa0f43f6aa4b$var$setClassesFromString(el, value.join(" "));
    else if (typeof value === "object" && value !== null) return $0712aa0f43f6aa4b$var$setClassesFromObject(el, value);
    else if (typeof value === "function") return $0712aa0f43f6aa4b$var$setClasses(el, value());
    return $0712aa0f43f6aa4b$var$setClassesFromString(el, value);
}
function $0712aa0f43f6aa4b$var$splitClasses(classString) {
    return classString.split(/\s/).filter(Boolean);
}
function $0712aa0f43f6aa4b$var$setClassesFromString(el, classString) {
    let missingClasses = (classString2)=>$0712aa0f43f6aa4b$var$splitClasses(classString2).filter((i)=>!el.classList.contains(i)).filter(Boolean);
    let addClassesAndReturnUndo = (classes)=>{
        el.classList.add(...classes);
        return ()=>{
            el.classList.remove(...classes);
        };
    };
    classString = classString === true ? classString = "" : classString || "";
    return addClassesAndReturnUndo(missingClasses(classString));
}
function $0712aa0f43f6aa4b$var$setClassesFromObject(el, classObject) {
    let forAdd = Object.entries(classObject).flatMap(([classString, bool])=>bool ? $0712aa0f43f6aa4b$var$splitClasses(classString) : false).filter(Boolean);
    let forRemove = Object.entries(classObject).flatMap(([classString, bool])=>!bool ? $0712aa0f43f6aa4b$var$splitClasses(classString) : false).filter(Boolean);
    let added = [];
    let removed = [];
    forRemove.forEach((i)=>{
        if (el.classList.contains(i)) {
            el.classList.remove(i);
            removed.push(i);
        }
    });
    forAdd.forEach((i)=>{
        if (!el.classList.contains(i)) {
            el.classList.add(i);
            added.push(i);
        }
    });
    return ()=>{
        removed.forEach((i)=>el.classList.add(i));
        added.forEach((i)=>el.classList.remove(i));
    };
}
// packages/alpinejs/src/utils/styles.js
function $0712aa0f43f6aa4b$var$setStyles(el, value) {
    if (typeof value === "object" && value !== null) return $0712aa0f43f6aa4b$var$setStylesFromObject(el, value);
    return $0712aa0f43f6aa4b$var$setStylesFromString(el, value);
}
function $0712aa0f43f6aa4b$var$setStylesFromObject(el, value) {
    let previousStyles = {};
    Object.entries(value).forEach(([key, value2])=>{
        previousStyles[key] = el.style[key];
        if (!key.startsWith("--")) key = $0712aa0f43f6aa4b$var$kebabCase(key);
        el.style.setProperty(key, value2);
    });
    setTimeout(()=>{
        if (el.style.length === 0) el.removeAttribute("style");
    });
    return ()=>{
        $0712aa0f43f6aa4b$var$setStyles(el, previousStyles);
    };
}
function $0712aa0f43f6aa4b$var$setStylesFromString(el, value) {
    let cache = el.getAttribute("style", value);
    el.setAttribute("style", value);
    return ()=>{
        el.setAttribute("style", cache || "");
    };
}
function $0712aa0f43f6aa4b$var$kebabCase(subject) {
    return subject.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}
// packages/alpinejs/src/utils/once.js
function $0712aa0f43f6aa4b$var$once(callback, fallback = ()=>{}) {
    let called = false;
    return function() {
        if (!called) {
            called = true;
            callback.apply(this, arguments);
        } else fallback.apply(this, arguments);
    };
}
// packages/alpinejs/src/directives/x-transition.js
$0712aa0f43f6aa4b$var$directive("transition", (el, { value: value, modifiers: modifiers, expression: expression }, { evaluate: evaluate2 })=>{
    if (typeof expression === "function") expression = evaluate2(expression);
    if (expression === false) return;
    if (!expression || typeof expression === "boolean") $0712aa0f43f6aa4b$var$registerTransitionsFromHelper(el, modifiers, value);
    else $0712aa0f43f6aa4b$var$registerTransitionsFromClassString(el, expression, value);
});
function $0712aa0f43f6aa4b$var$registerTransitionsFromClassString(el, classString, stage) {
    $0712aa0f43f6aa4b$var$registerTransitionObject(el, $0712aa0f43f6aa4b$var$setClasses, "");
    let directiveStorageMap = {
        "enter": (classes)=>{
            el._x_transition.enter.during = classes;
        },
        "enter-start": (classes)=>{
            el._x_transition.enter.start = classes;
        },
        "enter-end": (classes)=>{
            el._x_transition.enter.end = classes;
        },
        "leave": (classes)=>{
            el._x_transition.leave.during = classes;
        },
        "leave-start": (classes)=>{
            el._x_transition.leave.start = classes;
        },
        "leave-end": (classes)=>{
            el._x_transition.leave.end = classes;
        }
    };
    directiveStorageMap[stage](classString);
}
function $0712aa0f43f6aa4b$var$registerTransitionsFromHelper(el, modifiers, stage) {
    $0712aa0f43f6aa4b$var$registerTransitionObject(el, $0712aa0f43f6aa4b$var$setStyles);
    let doesntSpecify = !modifiers.includes("in") && !modifiers.includes("out") && !stage;
    let transitioningIn = doesntSpecify || modifiers.includes("in") || [
        "enter"
    ].includes(stage);
    let transitioningOut = doesntSpecify || modifiers.includes("out") || [
        "leave"
    ].includes(stage);
    if (modifiers.includes("in") && !doesntSpecify) modifiers = modifiers.filter((i, index)=>index < modifiers.indexOf("out"));
    if (modifiers.includes("out") && !doesntSpecify) modifiers = modifiers.filter((i, index)=>index > modifiers.indexOf("out"));
    let wantsAll = !modifiers.includes("opacity") && !modifiers.includes("scale");
    let wantsOpacity = wantsAll || modifiers.includes("opacity");
    let wantsScale = wantsAll || modifiers.includes("scale");
    let opacityValue = wantsOpacity ? 0 : 1;
    let scaleValue = wantsScale ? $0712aa0f43f6aa4b$var$modifierValue(modifiers, "scale", 95) / 100 : 1;
    let delay = $0712aa0f43f6aa4b$var$modifierValue(modifiers, "delay", 0) / 1e3;
    let origin = $0712aa0f43f6aa4b$var$modifierValue(modifiers, "origin", "center");
    let property = "opacity, transform";
    let durationIn = $0712aa0f43f6aa4b$var$modifierValue(modifiers, "duration", 150) / 1e3;
    let durationOut = $0712aa0f43f6aa4b$var$modifierValue(modifiers, "duration", 75) / 1e3;
    let easing = `cubic-bezier(0.4, 0.0, 0.2, 1)`;
    if (transitioningIn) {
        el._x_transition.enter.during = {
            transformOrigin: origin,
            transitionDelay: `${delay}s`,
            transitionProperty: property,
            transitionDuration: `${durationIn}s`,
            transitionTimingFunction: easing
        };
        el._x_transition.enter.start = {
            opacity: opacityValue,
            transform: `scale(${scaleValue})`
        };
        el._x_transition.enter.end = {
            opacity: 1,
            transform: `scale(1)`
        };
    }
    if (transitioningOut) {
        el._x_transition.leave.during = {
            transformOrigin: origin,
            transitionDelay: `${delay}s`,
            transitionProperty: property,
            transitionDuration: `${durationOut}s`,
            transitionTimingFunction: easing
        };
        el._x_transition.leave.start = {
            opacity: 1,
            transform: `scale(1)`
        };
        el._x_transition.leave.end = {
            opacity: opacityValue,
            transform: `scale(${scaleValue})`
        };
    }
}
function $0712aa0f43f6aa4b$var$registerTransitionObject(el, setFunction, defaultValue = {}) {
    if (!el._x_transition) el._x_transition = {
        enter: {
            during: defaultValue,
            start: defaultValue,
            end: defaultValue
        },
        leave: {
            during: defaultValue,
            start: defaultValue,
            end: defaultValue
        },
        in (before = ()=>{}, after = ()=>{}) {
            $0712aa0f43f6aa4b$var$transition(el, setFunction, {
                during: this.enter.during,
                start: this.enter.start,
                end: this.enter.end
            }, before, after);
        },
        out (before = ()=>{}, after = ()=>{}) {
            $0712aa0f43f6aa4b$var$transition(el, setFunction, {
                during: this.leave.during,
                start: this.leave.start,
                end: this.leave.end
            }, before, after);
        }
    };
}
window.Element.prototype._x_toggleAndCascadeWithTransitions = function(el, value, show, hide) {
    const nextTick2 = document.visibilityState === "visible" ? requestAnimationFrame : setTimeout;
    let clickAwayCompatibleShow = ()=>nextTick2(show);
    if (value) {
        if (el._x_transition && (el._x_transition.enter || el._x_transition.leave)) el._x_transition.enter && (Object.entries(el._x_transition.enter.during).length || Object.entries(el._x_transition.enter.start).length || Object.entries(el._x_transition.enter.end).length) ? el._x_transition.in(show) : clickAwayCompatibleShow();
        else el._x_transition ? el._x_transition.in(show) : clickAwayCompatibleShow();
        return;
    }
    el._x_hidePromise = el._x_transition ? new Promise((resolve, reject)=>{
        el._x_transition.out(()=>{}, ()=>resolve(hide));
        el._x_transitioning && el._x_transitioning.beforeCancel(()=>reject({
                isFromCancelledTransition: true
            }));
    }) : Promise.resolve(hide);
    queueMicrotask(()=>{
        let closest = $0712aa0f43f6aa4b$var$closestHide(el);
        if (closest) {
            if (!closest._x_hideChildren) closest._x_hideChildren = [];
            closest._x_hideChildren.push(el);
        } else nextTick2(()=>{
            let hideAfterChildren = (el2)=>{
                let carry = Promise.all([
                    el2._x_hidePromise,
                    ...(el2._x_hideChildren || []).map(hideAfterChildren)
                ]).then(([i])=>i?.());
                delete el2._x_hidePromise;
                delete el2._x_hideChildren;
                return carry;
            };
            hideAfterChildren(el).catch((e)=>{
                if (!e.isFromCancelledTransition) throw e;
            });
        });
    });
};
function $0712aa0f43f6aa4b$var$closestHide(el) {
    let parent = el.parentNode;
    if (!parent) return;
    return parent._x_hidePromise ? parent : $0712aa0f43f6aa4b$var$closestHide(parent);
}
function $0712aa0f43f6aa4b$var$transition(el, setFunction, { during: during, start: start2, end: end } = {}, before = ()=>{}, after = ()=>{}) {
    if (el._x_transitioning) el._x_transitioning.cancel();
    if (Object.keys(during).length === 0 && Object.keys(start2).length === 0 && Object.keys(end).length === 0) {
        before();
        after();
        return;
    }
    let undoStart, undoDuring, undoEnd;
    $0712aa0f43f6aa4b$var$performTransition(el, {
        start () {
            undoStart = setFunction(el, start2);
        },
        during () {
            undoDuring = setFunction(el, during);
        },
        before: before,
        end () {
            undoStart();
            undoEnd = setFunction(el, end);
        },
        after: after,
        cleanup () {
            undoDuring();
            undoEnd();
        }
    });
}
function $0712aa0f43f6aa4b$var$performTransition(el, stages) {
    let interrupted, reachedBefore, reachedEnd;
    let finish = $0712aa0f43f6aa4b$var$once(()=>{
        $0712aa0f43f6aa4b$var$mutateDom(()=>{
            interrupted = true;
            if (!reachedBefore) stages.before();
            if (!reachedEnd) {
                stages.end();
                $0712aa0f43f6aa4b$var$releaseNextTicks();
            }
            stages.after();
            if (el.isConnected) stages.cleanup();
            delete el._x_transitioning;
        });
    });
    el._x_transitioning = {
        beforeCancels: [],
        beforeCancel (callback) {
            this.beforeCancels.push(callback);
        },
        cancel: $0712aa0f43f6aa4b$var$once(function() {
            while(this.beforeCancels.length)this.beforeCancels.shift()();
            finish();
        }),
        finish: finish
    };
    $0712aa0f43f6aa4b$var$mutateDom(()=>{
        stages.start();
        stages.during();
    });
    $0712aa0f43f6aa4b$var$holdNextTicks();
    requestAnimationFrame(()=>{
        if (interrupted) return;
        let duration = Number(getComputedStyle(el).transitionDuration.replace(/,.*/, "").replace("s", "")) * 1e3;
        let delay = Number(getComputedStyle(el).transitionDelay.replace(/,.*/, "").replace("s", "")) * 1e3;
        if (duration === 0) duration = Number(getComputedStyle(el).animationDuration.replace("s", "")) * 1e3;
        $0712aa0f43f6aa4b$var$mutateDom(()=>{
            stages.before();
        });
        reachedBefore = true;
        requestAnimationFrame(()=>{
            if (interrupted) return;
            $0712aa0f43f6aa4b$var$mutateDom(()=>{
                stages.end();
            });
            $0712aa0f43f6aa4b$var$releaseNextTicks();
            setTimeout(el._x_transitioning.finish, duration + delay);
            reachedEnd = true;
        });
    });
}
function $0712aa0f43f6aa4b$var$modifierValue(modifiers, key, fallback) {
    if (modifiers.indexOf(key) === -1) return fallback;
    const rawValue = modifiers[modifiers.indexOf(key) + 1];
    if (!rawValue) return fallback;
    if (key === "scale") {
        if (isNaN(rawValue)) return fallback;
    }
    if (key === "duration" || key === "delay") {
        let match = rawValue.match(/([0-9]+)ms/);
        if (match) return match[1];
    }
    if (key === "origin") {
        if ([
            "top",
            "right",
            "left",
            "center",
            "bottom"
        ].includes(modifiers[modifiers.indexOf(key) + 2])) return [
            rawValue,
            modifiers[modifiers.indexOf(key) + 2]
        ].join(" ");
    }
    return rawValue;
}
// packages/alpinejs/src/utils/bind.js
function $0712aa0f43f6aa4b$var$bind(el, name, value, modifiers = []) {
    if (!el._x_bindings) el._x_bindings = $0712aa0f43f6aa4b$var$reactive({});
    el._x_bindings[name] = value;
    name = modifiers.includes("camel") ? $0712aa0f43f6aa4b$var$camelCase(name) : name;
    switch(name){
        case "value":
            $0712aa0f43f6aa4b$var$bindInputValue(el, value);
            break;
        case "style":
            $0712aa0f43f6aa4b$var$bindStyles(el, value);
            break;
        case "class":
            $0712aa0f43f6aa4b$var$bindClasses(el, value);
            break;
        case "selected":
        case "checked":
            $0712aa0f43f6aa4b$var$bindAttributeAndProperty(el, name, value);
            break;
        default:
            $0712aa0f43f6aa4b$var$bindAttribute(el, name, value);
            break;
    }
}
function $0712aa0f43f6aa4b$var$bindInputValue(el, value) {
    if ($0712aa0f43f6aa4b$var$isRadio(el)) {
        if (el.attributes.value === void 0) el.value = value;
    } else if ($0712aa0f43f6aa4b$var$isCheckbox(el)) {
        if (Number.isInteger(value)) el.value = value;
        else if (!Array.isArray(value) && typeof value !== "boolean" && ![
            null,
            void 0
        ].includes(value)) el.value = String(value);
        else if (Array.isArray(value)) el.checked = value.some((val)=>$0712aa0f43f6aa4b$var$checkedAttrLooseCompare(val, el.value));
        else el.checked = !!value;
    } else if (el.tagName === "SELECT") $0712aa0f43f6aa4b$var$updateSelect(el, value);
    else if (el.tagName === "OPTION") $0712aa0f43f6aa4b$var$bindAttribute(el, "value", value);
    else {
        if (el.value === value && (typeof value !== "object" || value === null)) return;
        el.value = value === void 0 ? "" : value;
    }
}
function $0712aa0f43f6aa4b$var$bindClasses(el, value) {
    if (el._x_undoAddedClasses) el._x_undoAddedClasses();
    el._x_undoAddedClasses = $0712aa0f43f6aa4b$var$setClasses(el, value);
}
function $0712aa0f43f6aa4b$var$bindStyles(el, value) {
    if (el._x_undoAddedStyles) el._x_undoAddedStyles();
    el._x_undoAddedStyles = $0712aa0f43f6aa4b$var$setStyles(el, value);
}
function $0712aa0f43f6aa4b$var$bindAttributeAndProperty(el, name, value) {
    $0712aa0f43f6aa4b$var$bindAttribute(el, name, value);
    $0712aa0f43f6aa4b$var$setPropertyIfChanged(el, name, value);
}
function $0712aa0f43f6aa4b$var$bindAttribute(el, name, value) {
    if ([
        null,
        void 0,
        false
    ].includes(value) && $0712aa0f43f6aa4b$var$attributeShouldntBePreservedIfFalsy(name)) el.removeAttribute(name);
    else {
        if ($0712aa0f43f6aa4b$var$isBooleanAttr(name)) value = name;
        if ($0712aa0f43f6aa4b$var$isObjectAttr(value)) value = JSON.stringify(value);
        $0712aa0f43f6aa4b$var$setIfChanged(el, name, value);
    }
}
function $0712aa0f43f6aa4b$var$setIfChanged(el, attrName, value) {
    if (el.getAttribute(attrName) != value) el.setAttribute(attrName, value);
}
function $0712aa0f43f6aa4b$var$setPropertyIfChanged(el, propName, value) {
    if (el[propName] !== value) el[propName] = value;
}
function $0712aa0f43f6aa4b$var$updateSelect(el, value) {
    const arrayWrappedValue = [].concat(value).map((value2)=>{
        return value2 + "";
    });
    Array.from(el.options).forEach((option)=>{
        option.selected = arrayWrappedValue.includes(option.value);
    });
}
function $0712aa0f43f6aa4b$var$camelCase(subject) {
    return subject.toLowerCase().replace(/-(\w)/g, (match, char)=>char.toUpperCase());
}
function $0712aa0f43f6aa4b$var$checkedAttrLooseCompare(valueA, valueB) {
    return valueA == valueB;
}
function $0712aa0f43f6aa4b$var$safeParseBoolean(rawValue) {
    if ([
        1,
        "1",
        "true",
        "on",
        "yes",
        true
    ].includes(rawValue)) return true;
    if ([
        0,
        "0",
        "false",
        "off",
        "no",
        false
    ].includes(rawValue)) return false;
    return rawValue ? Boolean(rawValue) : null;
}
var $0712aa0f43f6aa4b$var$booleanAttributes = /* @__PURE__ */ new Set([
    "allowfullscreen",
    "async",
    "autofocus",
    "autoplay",
    "checked",
    "controls",
    "default",
    "defer",
    "disabled",
    "formnovalidate",
    "inert",
    "ismap",
    "itemscope",
    "loop",
    "multiple",
    "muted",
    "nomodule",
    "novalidate",
    "open",
    "playsinline",
    "readonly",
    "required",
    "reversed",
    "selected",
    "shadowrootclonable",
    "shadowrootdelegatesfocus",
    "shadowrootserializable"
]);
function $0712aa0f43f6aa4b$var$isBooleanAttr(attrName) {
    return $0712aa0f43f6aa4b$var$booleanAttributes.has(attrName);
}
function $0712aa0f43f6aa4b$var$attributeShouldntBePreservedIfFalsy(name) {
    return ![
        "aria-pressed",
        "aria-checked",
        "aria-expanded",
        "aria-selected"
    ].includes(name);
}
function $0712aa0f43f6aa4b$var$isObjectAttr(value) {
    return typeof value === "object" && value !== null;
}
function $0712aa0f43f6aa4b$var$getBinding(el, name, fallback) {
    if (el._x_bindings && el._x_bindings[name] !== void 0) return el._x_bindings[name];
    return $0712aa0f43f6aa4b$var$getAttributeBinding(el, name, fallback);
}
function $0712aa0f43f6aa4b$var$extractProp(el, name, fallback, extract = true) {
    if (el._x_bindings && el._x_bindings[name] !== void 0) return el._x_bindings[name];
    if (el._x_inlineBindings && el._x_inlineBindings[name] !== void 0) {
        let binding = el._x_inlineBindings[name];
        binding.extract = extract;
        return $0712aa0f43f6aa4b$var$dontAutoEvaluateFunctions(()=>{
            return $0712aa0f43f6aa4b$var$evaluate(el, binding.expression);
        });
    }
    return $0712aa0f43f6aa4b$var$getAttributeBinding(el, name, fallback);
}
function $0712aa0f43f6aa4b$var$getAttributeBinding(el, name, fallback) {
    let attr = el.getAttribute(name);
    if (attr === null) return typeof fallback === "function" ? fallback() : fallback;
    if (attr === "") return true;
    if ($0712aa0f43f6aa4b$var$isBooleanAttr(name)) return !![
        name,
        "true"
    ].includes(attr);
    return attr;
}
function $0712aa0f43f6aa4b$var$isCheckbox(el) {
    return el.type === "checkbox" || el.localName === "ui-checkbox" || el.localName === "ui-switch";
}
function $0712aa0f43f6aa4b$var$isRadio(el) {
    return el.type === "radio" || el.localName === "ui-radio";
}
// packages/alpinejs/src/utils/debounce.js
function $0712aa0f43f6aa4b$var$debounce(func, wait) {
    let timeout;
    return function() {
        const context = this, args = arguments;
        const later = function() {
            timeout = null;
            func.apply(context, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}
// packages/alpinejs/src/utils/throttle.js
function $0712aa0f43f6aa4b$var$throttle(func, limit) {
    let inThrottle;
    return function() {
        let context = this, args = arguments;
        if (!inThrottle) {
            func.apply(context, args);
            inThrottle = true;
            setTimeout(()=>inThrottle = false, limit);
        }
    };
}
// packages/alpinejs/src/entangle.js
function $0712aa0f43f6aa4b$var$entangle({ get: outerGet, set: outerSet }, { get: innerGet, set: innerSet }) {
    let firstRun = true;
    let outerHash;
    let innerHash;
    let reference = $0712aa0f43f6aa4b$var$effect(()=>{
        let outer = outerGet();
        let inner = innerGet();
        if (firstRun) {
            innerSet($0712aa0f43f6aa4b$var$cloneIfObject(outer));
            firstRun = false;
        } else {
            let outerHashLatest = JSON.stringify(outer);
            let innerHashLatest = JSON.stringify(inner);
            if (outerHashLatest !== outerHash) innerSet($0712aa0f43f6aa4b$var$cloneIfObject(outer));
            else if (outerHashLatest !== innerHashLatest) outerSet($0712aa0f43f6aa4b$var$cloneIfObject(inner));
        }
        outerHash = JSON.stringify(outerGet());
        innerHash = JSON.stringify(innerGet());
    });
    return ()=>{
        $0712aa0f43f6aa4b$var$dequeueJob(reference);
        $0712aa0f43f6aa4b$var$release(reference);
    };
}
function $0712aa0f43f6aa4b$var$cloneIfObject(value) {
    return typeof value === "object" ? JSON.parse(JSON.stringify(value)) : value;
}
// packages/alpinejs/src/plugin.js
function $0712aa0f43f6aa4b$var$plugin(callback) {
    let callbacks = Array.isArray(callback) ? callback : [
        callback
    ];
    callbacks.forEach((i)=>i($0712aa0f43f6aa4b$var$alpine_default));
}
// packages/alpinejs/src/store.js
var $0712aa0f43f6aa4b$var$stores = {};
var $0712aa0f43f6aa4b$var$isReactive = false;
function $0712aa0f43f6aa4b$var$store(name, value) {
    if (!$0712aa0f43f6aa4b$var$isReactive) {
        $0712aa0f43f6aa4b$var$stores = $0712aa0f43f6aa4b$var$reactive($0712aa0f43f6aa4b$var$stores);
        $0712aa0f43f6aa4b$var$isReactive = true;
    }
    if (value === void 0) return $0712aa0f43f6aa4b$var$stores[name];
    $0712aa0f43f6aa4b$var$stores[name] = value;
    if (typeof value === "object" && value !== null && value._x_interceptor) $0712aa0f43f6aa4b$var$stores[name] = value.initialize($0712aa0f43f6aa4b$var$stores, name, name, ()=>{});
    else $0712aa0f43f6aa4b$var$initInterceptors($0712aa0f43f6aa4b$var$stores[name]);
    if (typeof value === "object" && value !== null && value.hasOwnProperty("init") && typeof value.init === "function") $0712aa0f43f6aa4b$var$stores[name].init();
}
function $0712aa0f43f6aa4b$var$getStores() {
    return $0712aa0f43f6aa4b$var$stores;
}
// packages/alpinejs/src/binds.js
var $0712aa0f43f6aa4b$var$binds = {};
function $0712aa0f43f6aa4b$var$bind2(name, bindings) {
    let getBindings = typeof bindings !== "function" ? ()=>bindings : bindings;
    if (name instanceof Element) return $0712aa0f43f6aa4b$var$applyBindingsObject(name, getBindings());
    else $0712aa0f43f6aa4b$var$binds[name] = getBindings;
    return ()=>{};
}
function $0712aa0f43f6aa4b$var$injectBindingProviders(obj) {
    Object.entries($0712aa0f43f6aa4b$var$binds).forEach(([name, callback])=>{
        Object.defineProperty(obj, name, {
            get () {
                return (...args)=>{
                    return callback(...args);
                };
            }
        });
    });
    return obj;
}
function $0712aa0f43f6aa4b$var$applyBindingsObject(el, obj, original) {
    let cleanupRunners = [];
    while(cleanupRunners.length)cleanupRunners.pop()();
    let attributes = Object.entries(obj).map(([name, value])=>({
            name: name,
            value: value
        }));
    let staticAttributes = $0712aa0f43f6aa4b$var$attributesOnly(attributes);
    attributes = attributes.map((attribute)=>{
        if (staticAttributes.find((attr)=>attr.name === attribute.name)) return {
            name: `x-bind:${attribute.name}`,
            value: `"${attribute.value}"`
        };
        return attribute;
    });
    $0712aa0f43f6aa4b$var$directives(el, attributes, original).map((handle)=>{
        cleanupRunners.push(handle.runCleanups);
        handle();
    });
    return ()=>{
        while(cleanupRunners.length)cleanupRunners.pop()();
    };
}
// packages/alpinejs/src/datas.js
var $0712aa0f43f6aa4b$var$datas = {};
function $0712aa0f43f6aa4b$var$data(name, callback) {
    $0712aa0f43f6aa4b$var$datas[name] = callback;
}
function $0712aa0f43f6aa4b$var$injectDataProviders(obj, context) {
    Object.entries($0712aa0f43f6aa4b$var$datas).forEach(([name, callback])=>{
        Object.defineProperty(obj, name, {
            get () {
                return (...args)=>{
                    return callback.bind(context)(...args);
                };
            },
            enumerable: false
        });
    });
    return obj;
}
// packages/alpinejs/src/alpine.js
var $0712aa0f43f6aa4b$var$Alpine = {
    get reactive () {
        return $0712aa0f43f6aa4b$var$reactive;
    },
    get release () {
        return $0712aa0f43f6aa4b$var$release;
    },
    get effect () {
        return $0712aa0f43f6aa4b$var$effect;
    },
    get raw () {
        return $0712aa0f43f6aa4b$var$raw;
    },
    get transaction () {
        return $0712aa0f43f6aa4b$var$transaction;
    },
    version: "3.17.4",
    flushAndStopDeferringMutations: $0712aa0f43f6aa4b$var$flushAndStopDeferringMutations,
    dontAutoEvaluateFunctions: $0712aa0f43f6aa4b$var$dontAutoEvaluateFunctions,
    disableEffectScheduling: $0712aa0f43f6aa4b$var$disableEffectScheduling,
    startObservingMutations: $0712aa0f43f6aa4b$var$startObservingMutations,
    stopObservingMutations: $0712aa0f43f6aa4b$var$stopObservingMutations,
    setReactivityEngine: $0712aa0f43f6aa4b$var$setReactivityEngine,
    onAttributeRemoved: $0712aa0f43f6aa4b$var$onAttributeRemoved,
    onAttributesAdded: $0712aa0f43f6aa4b$var$onAttributesAdded,
    closestDataStack: $0712aa0f43f6aa4b$var$closestDataStack,
    skipDuringClone: $0712aa0f43f6aa4b$var$skipDuringClone,
    onlyDuringClone: $0712aa0f43f6aa4b$var$onlyDuringClone,
    addRootSelector: $0712aa0f43f6aa4b$var$addRootSelector,
    addInitSelector: $0712aa0f43f6aa4b$var$addInitSelector,
    setErrorHandler: $0712aa0f43f6aa4b$var$setErrorHandler,
    interceptClone: $0712aa0f43f6aa4b$var$interceptClone,
    addScopeToNode: $0712aa0f43f6aa4b$var$addScopeToNode,
    deferMutations: $0712aa0f43f6aa4b$var$deferMutations,
    mapAttributes: $0712aa0f43f6aa4b$var$mapAttributes,
    evaluateLater: $0712aa0f43f6aa4b$var$evaluateLater,
    interceptInit: $0712aa0f43f6aa4b$var$interceptInit,
    initInterceptors: $0712aa0f43f6aa4b$var$initInterceptors,
    injectMagics: $0712aa0f43f6aa4b$var$injectMagics,
    setEvaluator: $0712aa0f43f6aa4b$var$setEvaluator,
    setRawEvaluator: $0712aa0f43f6aa4b$var$setRawEvaluator,
    mergeProxies: $0712aa0f43f6aa4b$var$mergeProxies,
    extractProp: $0712aa0f43f6aa4b$var$extractProp,
    findClosest: $0712aa0f43f6aa4b$var$findClosest,
    onElRemoved: $0712aa0f43f6aa4b$var$onElRemoved,
    closestRoot: $0712aa0f43f6aa4b$var$closestRoot,
    destroyTree: $0712aa0f43f6aa4b$var$destroyTree,
    interceptor: $0712aa0f43f6aa4b$var$interceptor,
    transition: // INTERNAL: not public API and is subject to change without major release.
    $0712aa0f43f6aa4b$var$transition,
    setStyles: // INTERNAL
    $0712aa0f43f6aa4b$var$setStyles,
    mutateDom: // INTERNAL
    $0712aa0f43f6aa4b$var$mutateDom,
    deferInit: $0712aa0f43f6aa4b$var$deferInit,
    directive: $0712aa0f43f6aa4b$var$directive,
    entangle: $0712aa0f43f6aa4b$var$entangle,
    throttle: $0712aa0f43f6aa4b$var$throttle,
    debounce: $0712aa0f43f6aa4b$var$debounce,
    evaluate: $0712aa0f43f6aa4b$var$evaluate,
    evaluateRaw: $0712aa0f43f6aa4b$var$evaluateRaw,
    initTree: $0712aa0f43f6aa4b$var$initTree,
    nextTick: $0712aa0f43f6aa4b$var$nextTick,
    prefixed: $0712aa0f43f6aa4b$var$prefix,
    prefix: $0712aa0f43f6aa4b$var$setPrefix,
    plugin: $0712aa0f43f6aa4b$var$plugin,
    magic: $0712aa0f43f6aa4b$var$magic,
    store: $0712aa0f43f6aa4b$var$store,
    start: $0712aa0f43f6aa4b$var$start,
    clone: $0712aa0f43f6aa4b$var$clone,
    cloneNode: // INTERNAL
    $0712aa0f43f6aa4b$var$cloneNode,
    // INTERNAL
    bound: $0712aa0f43f6aa4b$var$getBinding,
    $data: $0712aa0f43f6aa4b$var$scope,
    watch: $0712aa0f43f6aa4b$var$watch,
    walk: $0712aa0f43f6aa4b$var$walk,
    data: $0712aa0f43f6aa4b$var$data,
    bind: $0712aa0f43f6aa4b$var$bind2
};
var $0712aa0f43f6aa4b$var$alpine_default = $0712aa0f43f6aa4b$var$Alpine;
// packages/csp/src/parser.js
var $0712aa0f43f6aa4b$var$safemap = /* @__PURE__ */ new WeakMap();
var $0712aa0f43f6aa4b$var$globals = /* @__PURE__ */ new Set();
Object.getOwnPropertyNames(globalThis).forEach((key)=>{
    if (key === "styleMedia" || key === "sharedStorage") return;
    let value;
    try {
        value = globalThis[key];
    } catch  {
        return;
    }
    $0712aa0f43f6aa4b$var$globals.add(value);
});
var $0712aa0f43f6aa4b$var$Token = class {
    constructor(type, value, start2, end){
        this.type = type;
        this.value = value;
        this.start = start2;
        this.end = end;
    }
};
var $0712aa0f43f6aa4b$var$IDENTIFIER_NAME_TYPES = [
    "IDENTIFIER",
    "KEYWORD",
    "BOOLEAN",
    "NULL",
    "UNDEFINED"
];
var $0712aa0f43f6aa4b$var$Tokenizer = class {
    constructor(input){
        this.input = input;
        this.position = 0;
        this.tokens = [];
    }
    tokenize() {
        while(this.position < this.input.length){
            this.skipWhitespace();
            if (this.position >= this.input.length) break;
            const char = this.input[this.position];
            if (this.isDigit(char)) this.readNumber();
            else if (this.isAlpha(char) || char === "_" || char === "$") this.readIdentifierOrKeyword();
            else if (char === '"' || char === "'") this.readString();
            else if (char === "/" && this.peek() === "/") this.skipLineComment();
            else this.readOperatorOrPunctuation();
        }
        this.tokens.push(new $0712aa0f43f6aa4b$var$Token("EOF", null, this.position, this.position));
        return this.tokens;
    }
    skipWhitespace() {
        while(this.position < this.input.length && /\s/.test(this.input[this.position]))this.position++;
    }
    skipLineComment() {
        while(this.position < this.input.length && this.input[this.position] !== "\n")this.position++;
    }
    isDigit(char) {
        return /[0-9]/.test(char);
    }
    isAlpha(char) {
        return /[a-zA-Z]/.test(char);
    }
    isAlphaNumeric(char) {
        return /[a-zA-Z0-9_$]/.test(char);
    }
    peek(offset = 1) {
        return this.input[this.position + offset] || "";
    }
    readNumber() {
        const start2 = this.position;
        let hasDecimal = false;
        while(this.position < this.input.length){
            const char = this.input[this.position];
            if (this.isDigit(char)) this.position++;
            else if (char === "." && !hasDecimal) {
                hasDecimal = true;
                this.position++;
            } else break;
        }
        const value = this.input.slice(start2, this.position);
        this.tokens.push(new $0712aa0f43f6aa4b$var$Token("NUMBER", parseFloat(value), start2, this.position));
    }
    readIdentifierOrKeyword() {
        const start2 = this.position;
        while(this.position < this.input.length && this.isAlphaNumeric(this.input[this.position]))this.position++;
        const value = this.input.slice(start2, this.position);
        const keywords = [
            "true",
            "false",
            "null",
            "undefined",
            "new",
            "typeof",
            "void",
            "delete",
            "in",
            "instanceof"
        ];
        if (keywords.includes(value)) {
            if (value === "true" || value === "false") this.tokens.push(new $0712aa0f43f6aa4b$var$Token("BOOLEAN", value === "true", start2, this.position));
            else if (value === "null") this.tokens.push(new $0712aa0f43f6aa4b$var$Token("NULL", null, start2, this.position));
            else if (value === "undefined") this.tokens.push(new $0712aa0f43f6aa4b$var$Token("UNDEFINED", void 0, start2, this.position));
            else this.tokens.push(new $0712aa0f43f6aa4b$var$Token("KEYWORD", value, start2, this.position));
        } else this.tokens.push(new $0712aa0f43f6aa4b$var$Token("IDENTIFIER", value, start2, this.position));
    }
    readString() {
        const start2 = this.position;
        const quote = this.input[this.position];
        this.position++;
        let value = "";
        let escaped = false;
        while(this.position < this.input.length){
            const char = this.input[this.position];
            if (escaped) {
                switch(char){
                    case "n":
                        value += "\n";
                        break;
                    case "t":
                        value += "	";
                        break;
                    case "r":
                        value += "\r";
                        break;
                    case "\\":
                        value += "\\";
                        break;
                    case quote:
                        value += quote;
                        break;
                    case "u":
                        {
                            const codeUnit = this.input.slice(this.position + 1, this.position + 5);
                            if (/^[0-9a-fA-F]{4}$/.test(codeUnit)) {
                                value += String.fromCharCode(parseInt(codeUnit, 16));
                                this.position += 4;
                            } else value += char;
                            break;
                        }
                    default:
                        value += char;
                }
                escaped = false;
            } else if (char === "\\") escaped = true;
            else if (char === quote) {
                this.position++;
                this.tokens.push(new $0712aa0f43f6aa4b$var$Token("STRING", value, start2, this.position));
                return;
            } else value += char;
            this.position++;
        }
        throw new Error(`Unterminated string starting at position ${start2}`);
    }
    readOperatorOrPunctuation() {
        const start2 = this.position;
        const char = this.input[this.position];
        const next = this.peek();
        const nextNext = this.peek(2);
        if (char === "=" && next === "=" && nextNext === "=") {
            this.position += 3;
            this.tokens.push(new $0712aa0f43f6aa4b$var$Token("OPERATOR", "===", start2, this.position));
        } else if (char === "!" && next === "=" && nextNext === "=") {
            this.position += 3;
            this.tokens.push(new $0712aa0f43f6aa4b$var$Token("OPERATOR", "!==", start2, this.position));
        } else if (char === "=" && next === "=") {
            this.position += 2;
            this.tokens.push(new $0712aa0f43f6aa4b$var$Token("OPERATOR", "==", start2, this.position));
        } else if (char === "!" && next === "=") {
            this.position += 2;
            this.tokens.push(new $0712aa0f43f6aa4b$var$Token("OPERATOR", "!=", start2, this.position));
        } else if (char === "<" && next === "=") {
            this.position += 2;
            this.tokens.push(new $0712aa0f43f6aa4b$var$Token("OPERATOR", "<=", start2, this.position));
        } else if (char === ">" && next === "=") {
            this.position += 2;
            this.tokens.push(new $0712aa0f43f6aa4b$var$Token("OPERATOR", ">=", start2, this.position));
        } else if (char === "&" && next === "&") {
            this.position += 2;
            this.tokens.push(new $0712aa0f43f6aa4b$var$Token("OPERATOR", "&&", start2, this.position));
        } else if (char === "|" && next === "|") {
            this.position += 2;
            this.tokens.push(new $0712aa0f43f6aa4b$var$Token("OPERATOR", "||", start2, this.position));
        } else if (char === "+" && next === "+") {
            this.position += 2;
            this.tokens.push(new $0712aa0f43f6aa4b$var$Token("OPERATOR", "++", start2, this.position));
        } else if (char === "-" && next === "-") {
            this.position += 2;
            this.tokens.push(new $0712aa0f43f6aa4b$var$Token("OPERATOR", "--", start2, this.position));
        } else {
            this.position++;
            const type = "()[]{},.;:?".includes(char) ? "PUNCTUATION" : "OPERATOR";
            this.tokens.push(new $0712aa0f43f6aa4b$var$Token(type, char, start2, this.position));
        }
    }
};
var $0712aa0f43f6aa4b$var$Parser = class {
    constructor(tokens){
        this.tokens = tokens;
        this.position = 0;
    }
    parse() {
        if (this.isAtEnd()) throw new Error("Empty expression");
        const expr = this.parseExpression();
        this.match("PUNCTUATION", ";");
        if (!this.isAtEnd()) throw new Error(`Unexpected token: ${this.current().value}`);
        return expr;
    }
    parseExpression() {
        return this.parseAssignment();
    }
    parseAssignment() {
        const expr = this.parseTernary();
        if (this.match("OPERATOR", "=")) {
            const value = this.parseAssignment();
            if (expr.type === "Identifier" || expr.type === "MemberExpression") return {
                type: "AssignmentExpression",
                left: expr,
                operator: "=",
                right: value
            };
            throw new Error("Invalid assignment target");
        }
        return expr;
    }
    parseTernary() {
        const expr = this.parseLogicalOr();
        if (this.match("PUNCTUATION", "?")) {
            const consequent = this.parseExpression();
            this.consume("PUNCTUATION", ":");
            const alternate = this.parseExpression();
            return {
                type: "ConditionalExpression",
                test: expr,
                consequent: consequent,
                alternate: alternate
            };
        }
        return expr;
    }
    parseLogicalOr() {
        let expr = this.parseLogicalAnd();
        while(this.match("OPERATOR", "||")){
            const operator = this.previous().value;
            const right = this.parseLogicalAnd();
            expr = {
                type: "BinaryExpression",
                operator: operator,
                left: expr,
                right: right
            };
        }
        return expr;
    }
    parseLogicalAnd() {
        let expr = this.parseEquality();
        while(this.match("OPERATOR", "&&")){
            const operator = this.previous().value;
            const right = this.parseEquality();
            expr = {
                type: "BinaryExpression",
                operator: operator,
                left: expr,
                right: right
            };
        }
        return expr;
    }
    parseEquality() {
        let expr = this.parseRelational();
        while(this.match("OPERATOR", "==", "!=", "===", "!==")){
            const operator = this.previous().value;
            const right = this.parseRelational();
            expr = {
                type: "BinaryExpression",
                operator: operator,
                left: expr,
                right: right
            };
        }
        return expr;
    }
    parseRelational() {
        let expr = this.parseAdditive();
        while(this.match("OPERATOR", "<", ">", "<=", ">=")){
            const operator = this.previous().value;
            const right = this.parseAdditive();
            expr = {
                type: "BinaryExpression",
                operator: operator,
                left: expr,
                right: right
            };
        }
        return expr;
    }
    parseAdditive() {
        let expr = this.parseMultiplicative();
        while(this.match("OPERATOR", "+", "-")){
            const operator = this.previous().value;
            const right = this.parseMultiplicative();
            expr = {
                type: "BinaryExpression",
                operator: operator,
                left: expr,
                right: right
            };
        }
        return expr;
    }
    parseMultiplicative() {
        let expr = this.parseUnary();
        while(this.match("OPERATOR", "*", "/", "%")){
            const operator = this.previous().value;
            const right = this.parseUnary();
            expr = {
                type: "BinaryExpression",
                operator: operator,
                left: expr,
                right: right
            };
        }
        return expr;
    }
    parseUnary() {
        if (this.match("OPERATOR", "++", "--")) {
            const operator = this.previous().value;
            const argument = this.parseUnary();
            return {
                type: "UpdateExpression",
                operator: operator,
                argument: argument,
                prefix: true
            };
        }
        if (this.match("OPERATOR", "!", "-", "+")) {
            const operator = this.previous().value;
            const argument = this.parseUnary();
            return {
                type: "UnaryExpression",
                operator: operator,
                argument: argument,
                prefix: true
            };
        }
        return this.parsePostfix();
    }
    parsePostfix() {
        let expr = this.parseMember();
        if (this.match("OPERATOR", "++", "--")) {
            const operator = this.previous().value;
            return {
                type: "UpdateExpression",
                operator: operator,
                argument: expr,
                prefix: false
            };
        }
        return expr;
    }
    parseMember() {
        let expr = this.parsePrimary();
        while(true){
            if (this.match("PUNCTUATION", ".")) {
                const name = this.consumeIdentifierName();
                expr = {
                    type: "MemberExpression",
                    object: expr,
                    property: {
                        type: "Identifier",
                        name: name
                    },
                    computed: false
                };
            } else if (this.match("PUNCTUATION", "[")) {
                const property = this.parseExpression();
                this.consume("PUNCTUATION", "]");
                expr = {
                    type: "MemberExpression",
                    object: expr,
                    property: property,
                    computed: true
                };
            } else if (this.match("PUNCTUATION", "(")) {
                const args = this.parseArguments();
                expr = {
                    type: "CallExpression",
                    callee: expr,
                    arguments: args
                };
            } else break;
        }
        return expr;
    }
    parseArguments() {
        const args = [];
        if (!this.check("PUNCTUATION", ")")) do args.push(this.parseExpression());
        while (this.match("PUNCTUATION", ","));
        this.consume("PUNCTUATION", ")");
        return args;
    }
    parsePrimary() {
        if (this.match("NUMBER")) return {
            type: "Literal",
            value: this.previous().value
        };
        if (this.match("STRING")) return {
            type: "Literal",
            value: this.previous().value
        };
        if (this.match("BOOLEAN")) return {
            type: "Literal",
            value: this.previous().value
        };
        if (this.match("NULL")) return {
            type: "Literal",
            value: null
        };
        if (this.match("UNDEFINED")) return {
            type: "Literal",
            value: void 0
        };
        if (this.match("IDENTIFIER")) return {
            type: "Identifier",
            name: this.previous().value
        };
        if (this.match("PUNCTUATION", "(")) {
            const expr = this.parseExpression();
            this.consume("PUNCTUATION", ")");
            return expr;
        }
        if (this.match("PUNCTUATION", "[")) return this.parseArrayLiteral();
        if (this.match("PUNCTUATION", "{")) return this.parseObjectLiteral();
        throw new Error(`Unexpected token: ${this.current().type} "${this.current().value}"`);
    }
    parseArrayLiteral() {
        const elements = [];
        while(!this.check("PUNCTUATION", "]") && !this.isAtEnd()){
            elements.push(this.parseExpression());
            if (this.match("PUNCTUATION", ",")) {
                if (this.check("PUNCTUATION", "]")) break;
            } else break;
        }
        this.consume("PUNCTUATION", "]");
        return {
            type: "ArrayExpression",
            elements: elements
        };
    }
    parseObjectLiteral() {
        const properties = [];
        while(!this.check("PUNCTUATION", "}") && !this.isAtEnd()){
            let key;
            let computed = false;
            if (this.match("STRING")) key = {
                type: "Literal",
                value: this.previous().value
            };
            else if (this.checkIdentifierName()) {
                const name = this.consumeIdentifierName();
                key = {
                    type: "Identifier",
                    name: name
                };
            } else if (this.match("PUNCTUATION", "[")) {
                key = this.parseExpression();
                computed = true;
                this.consume("PUNCTUATION", "]");
            } else throw new Error("Expected property key");
            this.consume("PUNCTUATION", ":");
            const value = this.parseExpression();
            properties.push({
                type: "Property",
                key: key,
                value: value,
                computed: computed,
                shorthand: false
            });
            if (this.match("PUNCTUATION", ",")) {
                if (this.check("PUNCTUATION", "}")) break;
            } else break;
        }
        this.consume("PUNCTUATION", "}");
        return {
            type: "ObjectExpression",
            properties: properties
        };
    }
    match(...args) {
        for(let i = 0; i < args.length; i++){
            const arg = args[i];
            if (i === 0 && args.length > 1) {
                const type = arg;
                for(let j = 1; j < args.length; j++)if (this.check(type, args[j])) {
                    this.advance();
                    return true;
                }
                return false;
            } else if (args.length === 1) {
                if (this.checkType(arg)) {
                    this.advance();
                    return true;
                }
                return false;
            }
        }
        return false;
    }
    check(type, value) {
        if (this.isAtEnd()) return false;
        if (value !== void 0) return this.current().type === type && this.current().value === value;
        return this.current().type === type;
    }
    checkType(type) {
        if (this.isAtEnd()) return false;
        return this.current().type === type;
    }
    advance() {
        if (!this.isAtEnd()) this.position++;
        return this.previous();
    }
    isAtEnd() {
        return this.current().type === "EOF";
    }
    current() {
        return this.tokens[this.position];
    }
    previous() {
        return this.tokens[this.position - 1];
    }
    consume(type, value) {
        if (value !== void 0) {
            if (this.check(type, value)) return this.advance();
            throw new Error(`Expected ${type} "${value}" but got ${this.current().type} "${this.current().value}"`);
        }
        if (this.check(type)) return this.advance();
        throw new Error(`Expected ${type} but got ${this.current().type} "${this.current().value}"`);
    }
    checkIdentifierName() {
        if (this.isAtEnd()) return false;
        return $0712aa0f43f6aa4b$var$IDENTIFIER_NAME_TYPES.includes(this.current().type);
    }
    consumeIdentifierName() {
        if (!this.checkIdentifierName()) throw new Error(`Expected an identifier name but got ${this.current().type} "${this.current().value}"`);
        const token = this.advance();
        switch(token.type){
            case "BOOLEAN":
                return token.value ? "true" : "false";
            case "NULL":
                return "null";
            case "UNDEFINED":
                return "undefined";
            default:
                return token.value;
        }
    }
};
var $0712aa0f43f6aa4b$var$Evaluator = class {
    evaluate({ node: node, scope: scope2 = {}, context: context = null, forceBindingRootScopeToFunctions: forceBindingRootScopeToFunctions = true }) {
        switch(node.type){
            case "Literal":
                return node.value;
            case "Identifier":
                if (node.name in scope2) {
                    const value2 = scope2[node.name];
                    this.checkForDangerousValues(value2);
                    if (typeof value2 === "function") return value2.bind(scope2);
                    return value2;
                }
                throw new Error(`Undefined variable: ${node.name}`);
            case "MemberExpression":
                const object = this.evaluate({
                    node: node.object,
                    scope: scope2,
                    context: context,
                    forceBindingRootScopeToFunctions: forceBindingRootScopeToFunctions
                });
                if (object == null) throw new Error("Cannot read property of null or undefined");
                let property;
                if (node.computed) property = this.evaluate({
                    node: node.property,
                    scope: scope2,
                    context: context,
                    forceBindingRootScopeToFunctions: forceBindingRootScopeToFunctions
                });
                else property = node.property.name;
                this.checkForDangerousKeywords(property);
                let memberValue = object[property];
                this.checkForDangerousValues(memberValue);
                if (typeof memberValue === "function") {
                    if (forceBindingRootScopeToFunctions) return memberValue.bind(scope2);
                    else return memberValue.bind(object);
                }
                return memberValue;
            case "CallExpression":
                const args = node.arguments.map((arg)=>this.evaluate({
                        node: arg,
                        scope: scope2,
                        context: context,
                        forceBindingRootScopeToFunctions: forceBindingRootScopeToFunctions
                    }));
                let returnValue;
                if (node.callee.type === "MemberExpression") {
                    const obj = this.evaluate({
                        node: node.callee.object,
                        scope: scope2,
                        context: context,
                        forceBindingRootScopeToFunctions: forceBindingRootScopeToFunctions
                    });
                    let prop;
                    if (node.callee.computed) prop = this.evaluate({
                        node: node.callee.property,
                        scope: scope2,
                        context: context,
                        forceBindingRootScopeToFunctions: forceBindingRootScopeToFunctions
                    });
                    else prop = node.callee.property.name;
                    this.checkForDangerousKeywords(prop);
                    let func = obj[prop];
                    if (typeof func !== "function") throw new Error("Value is not a function");
                    returnValue = func.apply(obj, args);
                } else if (node.callee.type === "Identifier") {
                    const name = node.callee.name;
                    let func;
                    if (name in scope2) func = scope2[name];
                    else throw new Error(`Undefined variable: ${name}`);
                    if (typeof func !== "function") throw new Error("Value is not a function");
                    const thisContext = context !== null ? context : scope2;
                    returnValue = func.apply(thisContext, args);
                } else {
                    const callee = this.evaluate({
                        node: node.callee,
                        scope: scope2,
                        context: context,
                        forceBindingRootScopeToFunctions: forceBindingRootScopeToFunctions
                    });
                    if (typeof callee !== "function") throw new Error("Value is not a function");
                    returnValue = callee.apply(context, args);
                }
                this.checkForDangerousValues(returnValue);
                return returnValue;
            case "UnaryExpression":
                const argument = this.evaluate({
                    node: node.argument,
                    scope: scope2,
                    context: context,
                    forceBindingRootScopeToFunctions: forceBindingRootScopeToFunctions
                });
                switch(node.operator){
                    case "!":
                        return !argument;
                    case "-":
                        return -argument;
                    case "+":
                        return +argument;
                    default:
                        throw new Error(`Unknown unary operator: ${node.operator}`);
                }
            case "UpdateExpression":
                if (node.argument.type === "Identifier") {
                    const name = node.argument.name;
                    if (!(name in scope2)) throw new Error(`Undefined variable: ${name}`);
                    const oldValue = scope2[name];
                    if (node.operator === "++") scope2[name] = oldValue + 1;
                    else if (node.operator === "--") scope2[name] = oldValue - 1;
                    return node.prefix ? scope2[name] : oldValue;
                } else if (node.argument.type === "MemberExpression") {
                    const obj = this.evaluate({
                        node: node.argument.object,
                        scope: scope2,
                        context: context,
                        forceBindingRootScopeToFunctions: forceBindingRootScopeToFunctions
                    });
                    const prop = node.argument.computed ? this.evaluate({
                        node: node.argument.property,
                        scope: scope2,
                        context: context,
                        forceBindingRootScopeToFunctions: forceBindingRootScopeToFunctions
                    }) : node.argument.property.name;
                    if (this.isDOMObject(obj)) throw new Error("Property assignments on DOM objects are prohibited in the CSP build");
                    this.checkForDangerousKeywords(prop);
                    const oldValue = obj[prop];
                    if (node.operator === "++") obj[prop] = oldValue + 1;
                    else if (node.operator === "--") obj[prop] = oldValue - 1;
                    return node.prefix ? obj[prop] : oldValue;
                }
                throw new Error("Invalid update expression target");
            case "BinaryExpression":
                const left = this.evaluate({
                    node: node.left,
                    scope: scope2,
                    context: context,
                    forceBindingRootScopeToFunctions: forceBindingRootScopeToFunctions
                });
                const evalRight = ()=>this.evaluate({
                        node: node.right,
                        scope: scope2,
                        context: context,
                        forceBindingRootScopeToFunctions: forceBindingRootScopeToFunctions
                    });
                if (node.operator === "&&") return left && evalRight();
                if (node.operator === "||") return left || evalRight();
                const right = evalRight();
                switch(node.operator){
                    case "+":
                        return left + right;
                    case "-":
                        return left - right;
                    case "*":
                        return left * right;
                    case "/":
                        return left / right;
                    case "%":
                        return left % right;
                    case "==":
                        return left == right;
                    case "!=":
                        return left != right;
                    case "===":
                        return left === right;
                    case "!==":
                        return left !== right;
                    case "<":
                        return left < right;
                    case ">":
                        return left > right;
                    case "<=":
                        return left <= right;
                    case ">=":
                        return left >= right;
                    default:
                        throw new Error(`Unknown binary operator: ${node.operator}`);
                }
            case "ConditionalExpression":
                const test = this.evaluate({
                    node: node.test,
                    scope: scope2,
                    context: context,
                    forceBindingRootScopeToFunctions: forceBindingRootScopeToFunctions
                });
                return test ? this.evaluate({
                    node: node.consequent,
                    scope: scope2,
                    context: context,
                    forceBindingRootScopeToFunctions: forceBindingRootScopeToFunctions
                }) : this.evaluate({
                    node: node.alternate,
                    scope: scope2,
                    context: context,
                    forceBindingRootScopeToFunctions: forceBindingRootScopeToFunctions
                });
            case "AssignmentExpression":
                const value = this.evaluate({
                    node: node.right,
                    scope: scope2,
                    context: context,
                    forceBindingRootScopeToFunctions: forceBindingRootScopeToFunctions
                });
                if (node.left.type === "Identifier") {
                    scope2[node.left.name] = value;
                    return value;
                } else if (node.left.type === "MemberExpression") {
                    const obj = this.evaluate({
                        node: node.left.object,
                        scope: scope2,
                        context: context,
                        forceBindingRootScopeToFunctions: forceBindingRootScopeToFunctions
                    });
                    const prop = node.left.computed ? this.evaluate({
                        node: node.left.property,
                        scope: scope2,
                        context: context,
                        forceBindingRootScopeToFunctions: forceBindingRootScopeToFunctions
                    }) : node.left.property.name;
                    if (this.isDOMObject(obj)) throw new Error("Property assignments on DOM objects are prohibited in the CSP build");
                    this.checkForDangerousKeywords(prop);
                    obj[prop] = value;
                    return value;
                }
                throw new Error("Invalid assignment target");
            case "ArrayExpression":
                return node.elements.map((el)=>this.evaluate({
                        node: el,
                        scope: scope2,
                        context: context,
                        forceBindingRootScopeToFunctions: forceBindingRootScopeToFunctions
                    }));
            case "ObjectExpression":
                const result = {};
                for (const prop of node.properties){
                    const key = prop.computed ? this.evaluate({
                        node: prop.key,
                        scope: scope2,
                        context: context,
                        forceBindingRootScopeToFunctions: forceBindingRootScopeToFunctions
                    }) : prop.key.type === "Identifier" ? prop.key.name : this.evaluate({
                        node: prop.key,
                        scope: scope2,
                        context: context,
                        forceBindingRootScopeToFunctions: forceBindingRootScopeToFunctions
                    });
                    const value2 = this.evaluate({
                        node: prop.value,
                        scope: scope2,
                        context: context,
                        forceBindingRootScopeToFunctions: forceBindingRootScopeToFunctions
                    });
                    result[key] = value2;
                }
                return result;
            default:
                throw new Error(`Unknown node type: ${node.type}`);
        }
    }
    isDOMObject(obj) {
        if (obj instanceof Node) return true;
        if (typeof CSSStyleDeclaration !== "undefined" && obj instanceof CSSStyleDeclaration) return true;
        if (typeof DOMStringMap !== "undefined" && obj instanceof DOMStringMap) return true;
        if (typeof DOMTokenList !== "undefined" && obj instanceof DOMTokenList) return true;
        if (typeof NamedNodeMap !== "undefined" && obj instanceof NamedNodeMap) return true;
        let ctor = obj != null && obj.constructor;
        if (ctor && typeof ctor.name === "string" && /^(SVG|CSS|DOM)[A-Z]/.test(ctor.name)) return true;
        return false;
    }
    checkForDangerousKeywords(keyword) {
        let blacklist = [
            "constructor",
            "prototype",
            "__proto__",
            "__defineGetter__",
            "__defineSetter__",
            "insertAdjacentHTML",
            "insertAdjacentElement",
            "insertAdjacentText",
            "setAttribute",
            "setAttributeNS",
            "setAttributeNode",
            "setAttributeNodeNS",
            "createElement",
            "createElementNS",
            "createDocumentFragment",
            "createContextualFragment",
            "appendChild",
            "insertBefore",
            "replaceChild"
        ];
        if (blacklist.includes(keyword)) throw new Error(`Accessing "${keyword}" is prohibited in the CSP build`);
    }
    checkForDangerousValues(prop) {
        if (prop === null) return;
        if (typeof prop !== "object" && typeof prop !== "function") return;
        if ($0712aa0f43f6aa4b$var$safemap.has(prop)) return;
        if (prop instanceof HTMLIFrameElement || prop instanceof HTMLScriptElement || typeof SVGScriptElement !== "undefined" && prop instanceof SVGScriptElement) throw new Error("Accessing iframes and scripts is prohibited in the CSP build");
        if (typeof Document !== "undefined" && prop instanceof Document) throw new Error("Accessing document objects is prohibited in the CSP build");
        if ($0712aa0f43f6aa4b$var$globals.has(prop)) throw new Error("Accessing global variables is prohibited in the CSP build");
        $0712aa0f43f6aa4b$var$safemap.set(prop, true);
        return true;
    }
};
function $0712aa0f43f6aa4b$var$generateRuntimeFunction(expression) {
    try {
        const tokenizer = new $0712aa0f43f6aa4b$var$Tokenizer(expression);
        const tokens = tokenizer.tokenize();
        const parser = new $0712aa0f43f6aa4b$var$Parser(tokens);
        const ast = parser.parse();
        const evaluator = new $0712aa0f43f6aa4b$var$Evaluator();
        return function(options = {}) {
            const { scope: scope2 = {}, context: context = null, forceBindingRootScopeToFunctions: forceBindingRootScopeToFunctions = false } = options;
            return evaluator.evaluate({
                node: ast,
                scope: scope2,
                context: context,
                forceBindingRootScopeToFunctions: forceBindingRootScopeToFunctions
            });
        };
    } catch (error2) {
        throw new Error(`CSP Parser Error: ${error2.message}`);
    }
}
// packages/csp/src/evaluator.js
function $0712aa0f43f6aa4b$var$cspRawEvaluator(el, expression, extras = {}) {
    let dataStack = $0712aa0f43f6aa4b$var$generateDataStack(el);
    let scope2 = $0712aa0f43f6aa4b$var$mergeProxies([
        extras.scope ?? {},
        ...dataStack
    ]);
    let params = extras.params ?? [];
    let evaluate2 = $0712aa0f43f6aa4b$var$generateRuntimeFunction(expression);
    let result = evaluate2({
        scope: scope2,
        forceBindingRootScopeToFunctions: true
    });
    if (typeof result === "function" && $0712aa0f43f6aa4b$var$shouldAutoEvaluateFunctions) return result.apply(scope2, params);
    return result;
}
function $0712aa0f43f6aa4b$var$cspEvaluator(el, expression) {
    let dataStack = $0712aa0f43f6aa4b$var$generateDataStack(el);
    if (typeof expression === "function") return $0712aa0f43f6aa4b$var$generateEvaluatorFromFunction(dataStack, expression);
    let evaluator = $0712aa0f43f6aa4b$var$generateEvaluator(el, expression, dataStack);
    return $0712aa0f43f6aa4b$var$tryCatch.bind(null, el, expression, evaluator);
}
function $0712aa0f43f6aa4b$var$generateDataStack(el) {
    let overriddenMagics = {};
    $0712aa0f43f6aa4b$var$injectMagics(overriddenMagics, el);
    return [
        overriddenMagics,
        ...$0712aa0f43f6aa4b$var$closestDataStack(el)
    ];
}
function $0712aa0f43f6aa4b$var$generateEvaluator(el, expression, dataStack) {
    if (el instanceof HTMLIFrameElement) throw new Error("Evaluating expressions on an iframe is prohibited in the CSP build");
    if (el instanceof HTMLScriptElement) throw new Error("Evaluating expressions on a script is prohibited in the CSP build");
    return (receiver = ()=>{}, { scope: scope2 = {}, params: params = [] } = {})=>{
        let completeScope = $0712aa0f43f6aa4b$var$mergeProxies([
            scope2,
            ...dataStack
        ]);
        let evaluate2 = $0712aa0f43f6aa4b$var$generateRuntimeFunction(expression);
        let returnValue = evaluate2({
            scope: completeScope,
            forceBindingRootScopeToFunctions: true
        });
        if ($0712aa0f43f6aa4b$var$shouldAutoEvaluateFunctions && typeof returnValue === "function") {
            let nextReturnValue = returnValue.apply(returnValue, params);
            if (nextReturnValue instanceof Promise) nextReturnValue.then((i)=>receiver(i));
            else receiver(nextReturnValue);
        } else if (typeof returnValue === "object" && returnValue instanceof Promise) returnValue.then((i)=>receiver(i));
        else receiver(returnValue);
    };
}
// node_modules/@vue/shared/dist/shared.esm-bundler.js
function $0712aa0f43f6aa4b$var$makeMap(str) {
    const map = /* @__PURE__ */ Object.create(null);
    for (const key of str.split(","))map[key] = 1;
    return (val)=>val in map;
}
var $0712aa0f43f6aa4b$var$EMPTY_OBJ = Object.freeze({});
var $0712aa0f43f6aa4b$var$EMPTY_ARR = Object.freeze([]);
var $0712aa0f43f6aa4b$var$extend = Object.assign;
var $0712aa0f43f6aa4b$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $0712aa0f43f6aa4b$var$hasOwn = (val, key)=>$0712aa0f43f6aa4b$var$hasOwnProperty.call(val, key);
var $0712aa0f43f6aa4b$var$isArray = Array.isArray;
var $0712aa0f43f6aa4b$var$isMap = (val)=>$0712aa0f43f6aa4b$var$toTypeString(val) === "[object Map]";
var $0712aa0f43f6aa4b$var$isString = (val)=>typeof val === "string";
var $0712aa0f43f6aa4b$var$isSymbol = (val)=>typeof val === "symbol";
var $0712aa0f43f6aa4b$var$isObject = (val)=>val !== null && typeof val === "object";
var $0712aa0f43f6aa4b$var$objectToString = Object.prototype.toString;
var $0712aa0f43f6aa4b$var$toTypeString = (value)=>$0712aa0f43f6aa4b$var$objectToString.call(value);
var $0712aa0f43f6aa4b$var$toRawType = (value)=>{
    return $0712aa0f43f6aa4b$var$toTypeString(value).slice(8, -1);
};
var $0712aa0f43f6aa4b$var$isIntegerKey = (key)=>$0712aa0f43f6aa4b$var$isString(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
var $0712aa0f43f6aa4b$var$cacheStringFunction = (fn)=>{
    const cache = /* @__PURE__ */ Object.create(null);
    return (str)=>{
        const hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
};
var $0712aa0f43f6aa4b$var$camelizeRE = /-\w/g;
var $0712aa0f43f6aa4b$var$camelize = $0712aa0f43f6aa4b$var$cacheStringFunction((str)=>{
    return str.replace($0712aa0f43f6aa4b$var$camelizeRE, (c)=>c.slice(1).toUpperCase());
});
var $0712aa0f43f6aa4b$var$hyphenateRE = /\B([A-Z])/g;
var $0712aa0f43f6aa4b$var$hyphenate = $0712aa0f43f6aa4b$var$cacheStringFunction((str)=>str.replace($0712aa0f43f6aa4b$var$hyphenateRE, "-$1").toLowerCase());
var $0712aa0f43f6aa4b$var$capitalize = $0712aa0f43f6aa4b$var$cacheStringFunction((str)=>{
    return str.charAt(0).toUpperCase() + str.slice(1);
});
var $0712aa0f43f6aa4b$var$toHandlerKey = $0712aa0f43f6aa4b$var$cacheStringFunction((str)=>{
    const s = str ? `on${$0712aa0f43f6aa4b$var$capitalize(str)}` : ``;
    return s;
});
var $0712aa0f43f6aa4b$var$hasChanged = (value, oldValue)=>!Object.is(value, oldValue);
var $0712aa0f43f6aa4b$var$specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
var $0712aa0f43f6aa4b$var$isBooleanAttr2 = /* @__PURE__ */ $0712aa0f43f6aa4b$var$makeMap($0712aa0f43f6aa4b$var$specialBooleanAttrs + `,async,autofocus,autoplay,controls,default,defer,disabled,inert,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected`);
// node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js
function $0712aa0f43f6aa4b$var$warn2(msg, ...args) {
    console.warn(`[Vue warn] ${msg}`, ...args);
}
var $0712aa0f43f6aa4b$var$activeEffectScope;
var $0712aa0f43f6aa4b$var$activeSub;
var $0712aa0f43f6aa4b$var$pausedQueueEffects = /* @__PURE__ */ new WeakSet();
var $0712aa0f43f6aa4b$var$ReactiveEffect = class {
    constructor(fn){
        this.fn = fn;
        this.deps = void 0;
        this.depsTail = void 0;
        this.flags = 5;
        this.next = void 0;
        this.cleanup = void 0;
        this.scheduler = void 0;
        if ($0712aa0f43f6aa4b$var$activeEffectScope) {
            if ($0712aa0f43f6aa4b$var$activeEffectScope.active) $0712aa0f43f6aa4b$var$activeEffectScope.effects.push(this);
            else this.flags &= -2;
        }
    }
    pause() {
        this.flags |= 64;
    }
    resume() {
        if (this.flags & 64) {
            this.flags &= -65;
            if ($0712aa0f43f6aa4b$var$pausedQueueEffects.has(this)) {
                $0712aa0f43f6aa4b$var$pausedQueueEffects.delete(this);
                this.trigger();
            }
        }
    }
    /**
   * @internal
   */ notify() {
        if (this.flags & 2 && !(this.flags & 32)) return;
        if (!(this.flags & 8)) $0712aa0f43f6aa4b$var$batch(this);
    }
    run() {
        if (!(this.flags & 1)) return this.fn();
        this.flags |= 2;
        $0712aa0f43f6aa4b$var$cleanupEffect(this);
        $0712aa0f43f6aa4b$var$prepareDeps(this);
        const prevEffect = $0712aa0f43f6aa4b$var$activeSub;
        const prevShouldTrack = $0712aa0f43f6aa4b$var$shouldTrack;
        $0712aa0f43f6aa4b$var$activeSub = this;
        $0712aa0f43f6aa4b$var$shouldTrack = true;
        try {
            return this.fn();
        } finally{
            if ($0712aa0f43f6aa4b$var$activeSub !== this) $0712aa0f43f6aa4b$var$warn2("Active effect was not restored correctly - this is likely a Vue internal bug.");
            $0712aa0f43f6aa4b$var$cleanupDeps(this);
            $0712aa0f43f6aa4b$var$activeSub = prevEffect;
            $0712aa0f43f6aa4b$var$shouldTrack = prevShouldTrack;
            this.flags &= -3;
        }
    }
    stop() {
        if (this.flags & 1) {
            for(let link = this.deps; link; link = link.nextDep)$0712aa0f43f6aa4b$var$removeSub(link);
            this.deps = this.depsTail = void 0;
            $0712aa0f43f6aa4b$var$cleanupEffect(this);
            this.onStop && this.onStop();
            this.flags &= -2;
        }
    }
    trigger() {
        if (this.flags & 64) $0712aa0f43f6aa4b$var$pausedQueueEffects.add(this);
        else if (this.scheduler) this.scheduler();
        else this.runIfDirty();
    }
    /**
   * @internal
   */ runIfDirty() {
        if ($0712aa0f43f6aa4b$var$isDirty(this)) this.run();
    }
    get dirty() {
        return $0712aa0f43f6aa4b$var$isDirty(this);
    }
};
var $0712aa0f43f6aa4b$var$batchDepth = 0;
var $0712aa0f43f6aa4b$var$batchedSub;
var $0712aa0f43f6aa4b$var$batchedComputed;
function $0712aa0f43f6aa4b$var$batch(sub, isComputed = false) {
    sub.flags |= 8;
    if (isComputed) {
        sub.next = $0712aa0f43f6aa4b$var$batchedComputed;
        $0712aa0f43f6aa4b$var$batchedComputed = sub;
        return;
    }
    sub.next = $0712aa0f43f6aa4b$var$batchedSub;
    $0712aa0f43f6aa4b$var$batchedSub = sub;
}
function $0712aa0f43f6aa4b$var$startBatch() {
    $0712aa0f43f6aa4b$var$batchDepth++;
}
function $0712aa0f43f6aa4b$var$endBatch() {
    if (--$0712aa0f43f6aa4b$var$batchDepth > 0) return;
    if ($0712aa0f43f6aa4b$var$batchedComputed) {
        let e = $0712aa0f43f6aa4b$var$batchedComputed;
        $0712aa0f43f6aa4b$var$batchedComputed = void 0;
        while(e){
            const next = e.next;
            e.next = void 0;
            e.flags &= -9;
            e = next;
        }
    }
    let error2;
    while($0712aa0f43f6aa4b$var$batchedSub){
        let e = $0712aa0f43f6aa4b$var$batchedSub;
        $0712aa0f43f6aa4b$var$batchedSub = void 0;
        while(e){
            const next = e.next;
            e.next = void 0;
            e.flags &= -9;
            if (e.flags & 1) try {
                e.trigger();
            } catch (err) {
                if (!error2) error2 = err;
            }
            e = next;
        }
    }
    if (error2) throw error2;
}
function $0712aa0f43f6aa4b$var$prepareDeps(sub) {
    for(let link = sub.deps; link; link = link.nextDep){
        link.version = -1;
        link.prevActiveLink = link.dep.activeLink;
        link.dep.activeLink = link;
    }
}
function $0712aa0f43f6aa4b$var$cleanupDeps(sub) {
    let head;
    let tail = sub.depsTail;
    let link = tail;
    while(link){
        const prev = link.prevDep;
        if (link.version === -1) {
            if (link === tail) tail = prev;
            $0712aa0f43f6aa4b$var$removeSub(link);
            $0712aa0f43f6aa4b$var$removeDep(link);
        } else head = link;
        link.dep.activeLink = link.prevActiveLink;
        link.prevActiveLink = void 0;
        link = prev;
    }
    sub.deps = head;
    sub.depsTail = tail;
}
function $0712aa0f43f6aa4b$var$isDirty(sub) {
    for(let link = sub.deps; link; link = link.nextDep){
        if (link.dep.version !== link.version || link.dep.computed && ($0712aa0f43f6aa4b$var$refreshComputed(link.dep.computed) || link.dep.version !== link.version)) return true;
    }
    if (sub._dirty) return true;
    return false;
}
function $0712aa0f43f6aa4b$var$refreshComputed(computed) {
    if (computed.flags & 4 && !(computed.flags & 16)) return;
    computed.flags &= -17;
    if (computed.globalVersion === $0712aa0f43f6aa4b$var$globalVersion) return;
    computed.globalVersion = $0712aa0f43f6aa4b$var$globalVersion;
    if (!computed.isSSR && computed.flags & 128 && (!computed.deps && !computed._dirty || !$0712aa0f43f6aa4b$var$isDirty(computed))) return;
    computed.flags |= 2;
    const dep = computed.dep;
    const prevSub = $0712aa0f43f6aa4b$var$activeSub;
    const prevShouldTrack = $0712aa0f43f6aa4b$var$shouldTrack;
    $0712aa0f43f6aa4b$var$activeSub = computed;
    $0712aa0f43f6aa4b$var$shouldTrack = true;
    try {
        $0712aa0f43f6aa4b$var$prepareDeps(computed);
        const value = computed.fn(computed._value);
        if (dep.version === 0 || $0712aa0f43f6aa4b$var$hasChanged(value, computed._value)) {
            computed.flags |= 128;
            computed._value = value;
            dep.version++;
        }
    } catch (err) {
        dep.version++;
        throw err;
    } finally{
        $0712aa0f43f6aa4b$var$activeSub = prevSub;
        $0712aa0f43f6aa4b$var$shouldTrack = prevShouldTrack;
        $0712aa0f43f6aa4b$var$cleanupDeps(computed);
        computed.flags &= -3;
    }
}
function $0712aa0f43f6aa4b$var$removeSub(link, soft = false) {
    const { dep: dep, prevSub: prevSub, nextSub: nextSub } = link;
    if (prevSub) {
        prevSub.nextSub = nextSub;
        link.prevSub = void 0;
    }
    if (nextSub) {
        nextSub.prevSub = prevSub;
        link.nextSub = void 0;
    }
    if (dep.subsHead === link) dep.subsHead = nextSub;
    if (dep.subs === link) {
        dep.subs = prevSub;
        if (!prevSub && dep.computed) {
            dep.computed.flags &= -5;
            for(let l = dep.computed.deps; l; l = l.nextDep)$0712aa0f43f6aa4b$var$removeSub(l, true);
        }
    }
    if (!soft && !--dep.sc && dep.map) dep.map.delete(dep.key);
}
function $0712aa0f43f6aa4b$var$removeDep(link) {
    const { prevDep: prevDep, nextDep: nextDep } = link;
    if (prevDep) {
        prevDep.nextDep = nextDep;
        link.prevDep = void 0;
    }
    if (nextDep) {
        nextDep.prevDep = prevDep;
        link.nextDep = void 0;
    }
}
function $0712aa0f43f6aa4b$var$effect2(fn, options) {
    if (fn.effect instanceof $0712aa0f43f6aa4b$var$ReactiveEffect) fn = fn.effect.fn;
    const e = new $0712aa0f43f6aa4b$var$ReactiveEffect(fn);
    if (options) $0712aa0f43f6aa4b$var$extend(e, options);
    try {
        e.run();
    } catch (err) {
        e.stop();
        throw err;
    }
    const runner = e.run.bind(e);
    runner.effect = e;
    return runner;
}
function $0712aa0f43f6aa4b$var$stop(runner) {
    runner.effect.stop();
}
var $0712aa0f43f6aa4b$var$shouldTrack = true;
var $0712aa0f43f6aa4b$var$trackStack = [];
function $0712aa0f43f6aa4b$var$pauseTracking() {
    $0712aa0f43f6aa4b$var$trackStack.push($0712aa0f43f6aa4b$var$shouldTrack);
    $0712aa0f43f6aa4b$var$shouldTrack = false;
}
function $0712aa0f43f6aa4b$var$resetTracking() {
    const last = $0712aa0f43f6aa4b$var$trackStack.pop();
    $0712aa0f43f6aa4b$var$shouldTrack = last === void 0 ? true : last;
}
function $0712aa0f43f6aa4b$var$cleanupEffect(e) {
    const { cleanup: cleanup } = e;
    e.cleanup = void 0;
    if (cleanup) {
        const prevSub = $0712aa0f43f6aa4b$var$activeSub;
        $0712aa0f43f6aa4b$var$activeSub = void 0;
        try {
            cleanup();
        } finally{
            $0712aa0f43f6aa4b$var$activeSub = prevSub;
        }
    }
}
var $0712aa0f43f6aa4b$var$globalVersion = 0;
var $0712aa0f43f6aa4b$var$Link = class {
    constructor(sub, dep){
        this.sub = sub;
        this.dep = dep;
        this.version = dep.version;
        this.nextDep = this.prevDep = this.nextSub = this.prevSub = this.prevActiveLink = void 0;
    }
};
var $0712aa0f43f6aa4b$var$Dep = class {
    // TODO isolatedDeclarations "__v_skip"
    constructor(computed){
        this.computed = computed;
        this.version = 0;
        this.activeLink = void 0;
        this.subs = void 0;
        this.map = void 0;
        this.key = void 0;
        this.sc = 0;
        this.__v_skip = true;
        this.subsHead = void 0;
    }
    track(debugInfo) {
        if (!$0712aa0f43f6aa4b$var$activeSub || !$0712aa0f43f6aa4b$var$shouldTrack || $0712aa0f43f6aa4b$var$activeSub === this.computed) return;
        let link = this.activeLink;
        if (link === void 0 || link.sub !== $0712aa0f43f6aa4b$var$activeSub) {
            link = this.activeLink = new $0712aa0f43f6aa4b$var$Link($0712aa0f43f6aa4b$var$activeSub, this);
            if (!$0712aa0f43f6aa4b$var$activeSub.deps) $0712aa0f43f6aa4b$var$activeSub.deps = $0712aa0f43f6aa4b$var$activeSub.depsTail = link;
            else {
                link.prevDep = $0712aa0f43f6aa4b$var$activeSub.depsTail;
                $0712aa0f43f6aa4b$var$activeSub.depsTail.nextDep = link;
                $0712aa0f43f6aa4b$var$activeSub.depsTail = link;
            }
            $0712aa0f43f6aa4b$var$addSub(link);
        } else if (link.version === -1) {
            link.version = this.version;
            if (link.nextDep) {
                const next = link.nextDep;
                next.prevDep = link.prevDep;
                if (link.prevDep) link.prevDep.nextDep = next;
                link.prevDep = $0712aa0f43f6aa4b$var$activeSub.depsTail;
                link.nextDep = void 0;
                $0712aa0f43f6aa4b$var$activeSub.depsTail.nextDep = link;
                $0712aa0f43f6aa4b$var$activeSub.depsTail = link;
                if ($0712aa0f43f6aa4b$var$activeSub.deps === link) $0712aa0f43f6aa4b$var$activeSub.deps = next;
            }
        }
        if ($0712aa0f43f6aa4b$var$activeSub.onTrack) $0712aa0f43f6aa4b$var$activeSub.onTrack($0712aa0f43f6aa4b$var$extend({
            effect: $0712aa0f43f6aa4b$var$activeSub
        }, debugInfo));
        return link;
    }
    trigger(debugInfo) {
        this.version++;
        $0712aa0f43f6aa4b$var$globalVersion++;
        this.notify(debugInfo);
    }
    notify(debugInfo) {
        $0712aa0f43f6aa4b$var$startBatch();
        try {
            for(let head = this.subsHead; head; head = head.nextSub)if (head.sub.onTrigger && !(head.sub.flags & 8)) head.sub.onTrigger($0712aa0f43f6aa4b$var$extend({
                effect: head.sub
            }, debugInfo));
            for(let link = this.subs; link; link = link.prevSub)if (link.sub.notify()) link.sub.dep.notify();
        } finally{
            $0712aa0f43f6aa4b$var$endBatch();
        }
    }
};
function $0712aa0f43f6aa4b$var$addSub(link) {
    link.dep.sc++;
    if (link.sub.flags & 4) {
        const computed = link.dep.computed;
        if (computed && !link.dep.subs) {
            computed.flags |= 20;
            for(let l = computed.deps; l; l = l.nextDep)$0712aa0f43f6aa4b$var$addSub(l);
        }
        const currentTail = link.dep.subs;
        if (currentTail !== link) {
            link.prevSub = currentTail;
            if (currentTail) currentTail.nextSub = link;
        }
        if (link.dep.subsHead === void 0) link.dep.subsHead = link;
        link.dep.subs = link;
    }
}
var $0712aa0f43f6aa4b$var$targetMap = /* @__PURE__ */ new WeakMap();
var $0712aa0f43f6aa4b$var$ITERATE_KEY = /* @__PURE__ */ Symbol("Object iterate");
var $0712aa0f43f6aa4b$var$MAP_KEY_ITERATE_KEY = /* @__PURE__ */ Symbol("Map keys iterate");
var $0712aa0f43f6aa4b$var$ARRAY_ITERATE_KEY = /* @__PURE__ */ Symbol("Array iterate");
function $0712aa0f43f6aa4b$var$track(target, type, key) {
    if ($0712aa0f43f6aa4b$var$shouldTrack && $0712aa0f43f6aa4b$var$activeSub) {
        let depsMap = $0712aa0f43f6aa4b$var$targetMap.get(target);
        if (!depsMap) $0712aa0f43f6aa4b$var$targetMap.set(target, depsMap = /* @__PURE__ */ new Map());
        let dep = depsMap.get(key);
        if (!dep) {
            depsMap.set(key, dep = new $0712aa0f43f6aa4b$var$Dep());
            dep.map = depsMap;
            dep.key = key;
        }
        dep.track({
            target: target,
            type: type,
            key: key
        });
    }
}
function $0712aa0f43f6aa4b$var$trigger(target, type, key, newValue, oldValue, oldTarget) {
    const depsMap = $0712aa0f43f6aa4b$var$targetMap.get(target);
    if (!depsMap) {
        $0712aa0f43f6aa4b$var$globalVersion++;
        return;
    }
    const run = (dep)=>{
        if (dep) dep.trigger({
            target: target,
            type: type,
            key: key,
            newValue: newValue,
            oldValue: oldValue,
            oldTarget: oldTarget
        });
    };
    $0712aa0f43f6aa4b$var$startBatch();
    if (type === "clear") depsMap.forEach(run);
    else {
        const targetIsArray = $0712aa0f43f6aa4b$var$isArray(target);
        const isArrayIndex = targetIsArray && $0712aa0f43f6aa4b$var$isIntegerKey(key);
        if (targetIsArray && key === "length") {
            const newLength = Number(newValue);
            depsMap.forEach((dep, key2)=>{
                if (key2 === "length" || key2 === $0712aa0f43f6aa4b$var$ARRAY_ITERATE_KEY || !$0712aa0f43f6aa4b$var$isSymbol(key2) && key2 >= newLength) run(dep);
            });
        } else {
            if (key !== void 0 || depsMap.has(void 0)) run(depsMap.get(key));
            if (isArrayIndex) run(depsMap.get($0712aa0f43f6aa4b$var$ARRAY_ITERATE_KEY));
            switch(type){
                case "add":
                    if (!targetIsArray) {
                        run(depsMap.get($0712aa0f43f6aa4b$var$ITERATE_KEY));
                        if ($0712aa0f43f6aa4b$var$isMap(target)) run(depsMap.get($0712aa0f43f6aa4b$var$MAP_KEY_ITERATE_KEY));
                    } else if (isArrayIndex) run(depsMap.get("length"));
                    break;
                case "delete":
                    if (!targetIsArray) {
                        run(depsMap.get($0712aa0f43f6aa4b$var$ITERATE_KEY));
                        if ($0712aa0f43f6aa4b$var$isMap(target)) run(depsMap.get($0712aa0f43f6aa4b$var$MAP_KEY_ITERATE_KEY));
                    }
                    break;
                case "set":
                    if ($0712aa0f43f6aa4b$var$isMap(target)) run(depsMap.get($0712aa0f43f6aa4b$var$ITERATE_KEY));
                    break;
            }
        }
    }
    $0712aa0f43f6aa4b$var$endBatch();
}
function $0712aa0f43f6aa4b$var$reactiveReadArray(array) {
    const raw2 = $0712aa0f43f6aa4b$var$toRaw(array);
    if (raw2 === array) return raw2;
    $0712aa0f43f6aa4b$var$track(raw2, "iterate", $0712aa0f43f6aa4b$var$ARRAY_ITERATE_KEY);
    return $0712aa0f43f6aa4b$var$isShallow(array) ? raw2 : raw2.map($0712aa0f43f6aa4b$var$toReactive);
}
function $0712aa0f43f6aa4b$var$shallowReadArray(arr) {
    $0712aa0f43f6aa4b$var$track(arr = $0712aa0f43f6aa4b$var$toRaw(arr), "iterate", $0712aa0f43f6aa4b$var$ARRAY_ITERATE_KEY);
    return arr;
}
function $0712aa0f43f6aa4b$var$toWrapped(target, item) {
    if ($0712aa0f43f6aa4b$var$isReadonly(target)) return $0712aa0f43f6aa4b$var$isReactive2(target) ? $0712aa0f43f6aa4b$var$toReadonly($0712aa0f43f6aa4b$var$toReactive(item)) : $0712aa0f43f6aa4b$var$toReadonly(item);
    return $0712aa0f43f6aa4b$var$toReactive(item);
}
var $0712aa0f43f6aa4b$var$arrayInstrumentations = {
    __proto__: null,
    [Symbol.iterator] () {
        return $0712aa0f43f6aa4b$var$iterator(this, Symbol.iterator, (item)=>$0712aa0f43f6aa4b$var$toWrapped(this, item));
    },
    concat (...args) {
        return $0712aa0f43f6aa4b$var$reactiveReadArray(this).concat(...args.map((x)=>$0712aa0f43f6aa4b$var$isArray(x) ? $0712aa0f43f6aa4b$var$reactiveReadArray(x) : x));
    },
    entries () {
        return $0712aa0f43f6aa4b$var$iterator(this, "entries", (value)=>{
            value[1] = $0712aa0f43f6aa4b$var$toWrapped(this, value[1]);
            return value;
        });
    },
    every (fn, thisArg) {
        return $0712aa0f43f6aa4b$var$apply(this, "every", fn, thisArg, void 0, arguments);
    },
    filter (fn, thisArg) {
        return $0712aa0f43f6aa4b$var$apply(this, "filter", fn, thisArg, (v)=>v.map((item)=>$0712aa0f43f6aa4b$var$toWrapped(this, item)), arguments);
    },
    find (fn, thisArg) {
        return $0712aa0f43f6aa4b$var$apply(this, "find", fn, thisArg, (item)=>$0712aa0f43f6aa4b$var$toWrapped(this, item), arguments);
    },
    findIndex (fn, thisArg) {
        return $0712aa0f43f6aa4b$var$apply(this, "findIndex", fn, thisArg, void 0, arguments);
    },
    findLast (fn, thisArg) {
        return $0712aa0f43f6aa4b$var$apply(this, "findLast", fn, thisArg, (item)=>$0712aa0f43f6aa4b$var$toWrapped(this, item), arguments);
    },
    findLastIndex (fn, thisArg) {
        return $0712aa0f43f6aa4b$var$apply(this, "findLastIndex", fn, thisArg, void 0, arguments);
    },
    // flat, flatMap could benefit from ARRAY_ITERATE but are not straight-forward to implement
    forEach (fn, thisArg) {
        return $0712aa0f43f6aa4b$var$apply(this, "forEach", fn, thisArg, void 0, arguments);
    },
    includes (...args) {
        return $0712aa0f43f6aa4b$var$searchProxy(this, "includes", args);
    },
    indexOf (...args) {
        return $0712aa0f43f6aa4b$var$searchProxy(this, "indexOf", args);
    },
    join (separator) {
        return $0712aa0f43f6aa4b$var$reactiveReadArray(this).join(separator);
    },
    // keys() iterator only reads `length`, no optimization required
    lastIndexOf (...args) {
        return $0712aa0f43f6aa4b$var$searchProxy(this, "lastIndexOf", args);
    },
    map (fn, thisArg) {
        return $0712aa0f43f6aa4b$var$apply(this, "map", fn, thisArg, void 0, arguments);
    },
    pop () {
        return $0712aa0f43f6aa4b$var$noTracking(this, "pop");
    },
    push (...args) {
        return $0712aa0f43f6aa4b$var$noTracking(this, "push", args);
    },
    reduce (fn, ...args) {
        return $0712aa0f43f6aa4b$var$reduce(this, "reduce", fn, args);
    },
    reduceRight (fn, ...args) {
        return $0712aa0f43f6aa4b$var$reduce(this, "reduceRight", fn, args);
    },
    shift () {
        return $0712aa0f43f6aa4b$var$noTracking(this, "shift");
    },
    // slice could use ARRAY_ITERATE but also seems to beg for range tracking
    some (fn, thisArg) {
        return $0712aa0f43f6aa4b$var$apply(this, "some", fn, thisArg, void 0, arguments);
    },
    splice (...args) {
        return $0712aa0f43f6aa4b$var$noTracking(this, "splice", args);
    },
    toReversed () {
        return $0712aa0f43f6aa4b$var$reactiveReadArray(this).toReversed();
    },
    toSorted (comparer) {
        return $0712aa0f43f6aa4b$var$reactiveReadArray(this).toSorted(comparer);
    },
    toSpliced (...args) {
        return $0712aa0f43f6aa4b$var$reactiveReadArray(this).toSpliced(...args);
    },
    unshift (...args) {
        return $0712aa0f43f6aa4b$var$noTracking(this, "unshift", args);
    },
    values () {
        return $0712aa0f43f6aa4b$var$iterator(this, "values", (item)=>$0712aa0f43f6aa4b$var$toWrapped(this, item));
    }
};
function $0712aa0f43f6aa4b$var$iterator(self2, method, wrapValue) {
    const arr = $0712aa0f43f6aa4b$var$shallowReadArray(self2);
    const iter = arr[method]();
    if (arr !== self2 && !$0712aa0f43f6aa4b$var$isShallow(self2)) {
        iter._next = iter.next;
        iter.next = ()=>{
            const result = iter._next();
            if (!result.done) result.value = wrapValue(result.value);
            return result;
        };
    }
    return iter;
}
var $0712aa0f43f6aa4b$var$arrayProto = Array.prototype;
function $0712aa0f43f6aa4b$var$apply(self2, method, fn, thisArg, wrappedRetFn, args) {
    const arr = $0712aa0f43f6aa4b$var$shallowReadArray(self2);
    const needsWrap = arr !== self2 && !$0712aa0f43f6aa4b$var$isShallow(self2);
    const methodFn = arr[method];
    if (methodFn !== $0712aa0f43f6aa4b$var$arrayProto[method]) {
        const result2 = methodFn.apply(self2, args);
        return needsWrap ? $0712aa0f43f6aa4b$var$toReactive(result2) : result2;
    }
    let wrappedFn = fn;
    if (arr !== self2) {
        if (needsWrap) wrappedFn = function(item, index) {
            return fn.call(this, $0712aa0f43f6aa4b$var$toWrapped(self2, item), index, self2);
        };
        else if (fn.length > 2) wrappedFn = function(item, index) {
            return fn.call(this, item, index, self2);
        };
    }
    const result = methodFn.call(arr, wrappedFn, thisArg);
    return needsWrap && wrappedRetFn ? wrappedRetFn(result) : result;
}
function $0712aa0f43f6aa4b$var$reduce(self2, method, fn, args) {
    const arr = $0712aa0f43f6aa4b$var$shallowReadArray(self2);
    const needsWrap = arr !== self2 && !$0712aa0f43f6aa4b$var$isShallow(self2);
    let wrappedFn = fn;
    let wrapInitialAccumulator = false;
    if (arr !== self2) {
        if (needsWrap) {
            wrapInitialAccumulator = args.length === 0;
            wrappedFn = function(acc, item, index) {
                if (wrapInitialAccumulator) {
                    wrapInitialAccumulator = false;
                    acc = $0712aa0f43f6aa4b$var$toWrapped(self2, acc);
                }
                return fn.call(this, acc, $0712aa0f43f6aa4b$var$toWrapped(self2, item), index, self2);
            };
        } else if (fn.length > 3) wrappedFn = function(acc, item, index) {
            return fn.call(this, acc, item, index, self2);
        };
    }
    const result = arr[method](wrappedFn, ...args);
    return wrapInitialAccumulator ? $0712aa0f43f6aa4b$var$toWrapped(self2, result) : result;
}
function $0712aa0f43f6aa4b$var$searchProxy(self2, method, args) {
    const arr = $0712aa0f43f6aa4b$var$toRaw(self2);
    $0712aa0f43f6aa4b$var$track(arr, "iterate", $0712aa0f43f6aa4b$var$ARRAY_ITERATE_KEY);
    const res = arr[method](...args);
    if ((res === -1 || res === false) && $0712aa0f43f6aa4b$var$isProxy(args[0])) {
        args[0] = $0712aa0f43f6aa4b$var$toRaw(args[0]);
        return arr[method](...args);
    }
    return res;
}
function $0712aa0f43f6aa4b$var$noTracking(self2, method, args = []) {
    $0712aa0f43f6aa4b$var$pauseTracking();
    $0712aa0f43f6aa4b$var$startBatch();
    const res = $0712aa0f43f6aa4b$var$toRaw(self2)[method].apply(self2, args);
    $0712aa0f43f6aa4b$var$endBatch();
    $0712aa0f43f6aa4b$var$resetTracking();
    return res;
}
var $0712aa0f43f6aa4b$var$isNonTrackableKeys = /* @__PURE__ */ $0712aa0f43f6aa4b$var$makeMap(`__proto__,__v_isRef,__isVue`);
var $0712aa0f43f6aa4b$var$builtInSymbols = new Set(/* @__PURE__ */ Object.getOwnPropertyNames(Symbol).filter((key)=>key !== "arguments" && key !== "caller").map((key)=>Symbol[key]).filter($0712aa0f43f6aa4b$var$isSymbol));
function $0712aa0f43f6aa4b$var$hasOwnProperty2(key) {
    if (!$0712aa0f43f6aa4b$var$isSymbol(key)) key = String(key);
    const obj = $0712aa0f43f6aa4b$var$toRaw(this);
    $0712aa0f43f6aa4b$var$track(obj, "has", key);
    return obj.hasOwnProperty(key);
}
var $0712aa0f43f6aa4b$var$BaseReactiveHandler = class {
    constructor(_isReadonly = false, _isShallow = false){
        this._isReadonly = _isReadonly;
        this._isShallow = _isShallow;
    }
    get(target, key, receiver) {
        if (key === "__v_skip") return target["__v_skip"];
        const isReadonly2 = this._isReadonly, isShallow2 = this._isShallow;
        if (key === "__v_isReactive") return !isReadonly2;
        else if (key === "__v_isReadonly") return isReadonly2;
        else if (key === "__v_isShallow") return isShallow2;
        else if (key === "__v_raw") {
            if (receiver === (isReadonly2 ? isShallow2 ? $0712aa0f43f6aa4b$var$shallowReadonlyMap : $0712aa0f43f6aa4b$var$readonlyMap : isShallow2 ? $0712aa0f43f6aa4b$var$shallowReactiveMap : $0712aa0f43f6aa4b$var$reactiveMap).get(target) || // receiver is not the reactive proxy, but has the same prototype
            // this means the receiver is a user proxy of the reactive proxy
            Object.getPrototypeOf(target) === Object.getPrototypeOf(receiver)) return target;
            return;
        }
        const targetIsArray = $0712aa0f43f6aa4b$var$isArray(target);
        if (!isReadonly2) {
            let fn;
            if (targetIsArray && (fn = $0712aa0f43f6aa4b$var$arrayInstrumentations[key])) return fn;
            if (key === "hasOwnProperty") return $0712aa0f43f6aa4b$var$hasOwnProperty2;
        }
        const res = Reflect.get(target, key, // if this is a proxy wrapping a ref, return methods using the raw ref
        // as receiver so that we don't have to call `toRaw` on the ref in all
        // its class methods
        $0712aa0f43f6aa4b$var$isRef(target) ? target : receiver);
        if ($0712aa0f43f6aa4b$var$isSymbol(key) ? $0712aa0f43f6aa4b$var$builtInSymbols.has(key) : $0712aa0f43f6aa4b$var$isNonTrackableKeys(key)) return res;
        if (!isReadonly2) $0712aa0f43f6aa4b$var$track(target, "get", key);
        if (isShallow2) return res;
        if ($0712aa0f43f6aa4b$var$isRef(res)) {
            const value = targetIsArray && $0712aa0f43f6aa4b$var$isIntegerKey(key) ? res : res.value;
            return isReadonly2 && $0712aa0f43f6aa4b$var$isObject(value) ? $0712aa0f43f6aa4b$var$readonly(value) : value;
        }
        if ($0712aa0f43f6aa4b$var$isObject(res)) return isReadonly2 ? $0712aa0f43f6aa4b$var$readonly(res) : $0712aa0f43f6aa4b$var$reactive2(res);
        return res;
    }
};
var $0712aa0f43f6aa4b$var$MutableReactiveHandler = class extends $0712aa0f43f6aa4b$var$BaseReactiveHandler {
    constructor(isShallow2 = false){
        super(false, isShallow2);
    }
    set(target, key, value, receiver) {
        let oldValue = target[key];
        const isArrayWithIntegerKey = $0712aa0f43f6aa4b$var$isArray(target) && $0712aa0f43f6aa4b$var$isIntegerKey(key);
        if (!this._isShallow) {
            const isOldValueReadonly = $0712aa0f43f6aa4b$var$isReadonly(oldValue);
            if (!$0712aa0f43f6aa4b$var$isShallow(value) && !$0712aa0f43f6aa4b$var$isReadonly(value)) {
                oldValue = $0712aa0f43f6aa4b$var$toRaw(oldValue);
                value = $0712aa0f43f6aa4b$var$toRaw(value);
            }
            if (!isArrayWithIntegerKey && $0712aa0f43f6aa4b$var$isRef(oldValue) && !$0712aa0f43f6aa4b$var$isRef(value)) {
                if (isOldValueReadonly) {
                    $0712aa0f43f6aa4b$var$warn2(`Set operation on key "${String(key)}" failed: target is readonly.`, target[key]);
                    return true;
                } else {
                    oldValue.value = value;
                    return true;
                }
            }
        }
        const hadKey = isArrayWithIntegerKey ? Number(key) < target.length : $0712aa0f43f6aa4b$var$hasOwn(target, key);
        const result = Reflect.set(target, key, value, $0712aa0f43f6aa4b$var$isRef(target) ? target : receiver);
        if (target === $0712aa0f43f6aa4b$var$toRaw(receiver) && result) {
            if (!hadKey) $0712aa0f43f6aa4b$var$trigger(target, "add", key, value);
            else if ($0712aa0f43f6aa4b$var$hasChanged(value, oldValue)) $0712aa0f43f6aa4b$var$trigger(target, "set", key, value, oldValue);
        }
        return result;
    }
    deleteProperty(target, key) {
        const hadKey = $0712aa0f43f6aa4b$var$hasOwn(target, key);
        const oldValue = target[key];
        const result = Reflect.deleteProperty(target, key);
        if (result && hadKey) $0712aa0f43f6aa4b$var$trigger(target, "delete", key, void 0, oldValue);
        return result;
    }
    has(target, key) {
        const result = Reflect.has(target, key);
        if (!$0712aa0f43f6aa4b$var$isSymbol(key) || !$0712aa0f43f6aa4b$var$builtInSymbols.has(key)) $0712aa0f43f6aa4b$var$track(target, "has", key);
        return result;
    }
    ownKeys(target) {
        $0712aa0f43f6aa4b$var$track(target, "iterate", $0712aa0f43f6aa4b$var$isArray(target) ? "length" : $0712aa0f43f6aa4b$var$ITERATE_KEY);
        return Reflect.ownKeys(target);
    }
};
var $0712aa0f43f6aa4b$var$ReadonlyReactiveHandler = class extends $0712aa0f43f6aa4b$var$BaseReactiveHandler {
    constructor(isShallow2 = false){
        super(true, isShallow2);
    }
    set(target, key) {
        $0712aa0f43f6aa4b$var$warn2(`Set operation on key "${String(key)}" failed: target is readonly.`, target);
        return true;
    }
    deleteProperty(target, key) {
        $0712aa0f43f6aa4b$var$warn2(`Delete operation on key "${String(key)}" failed: target is readonly.`, target);
        return true;
    }
};
var $0712aa0f43f6aa4b$var$mutableHandlers = /* @__PURE__ */ new $0712aa0f43f6aa4b$var$MutableReactiveHandler();
var $0712aa0f43f6aa4b$var$readonlyHandlers = /* @__PURE__ */ new $0712aa0f43f6aa4b$var$ReadonlyReactiveHandler();
var $0712aa0f43f6aa4b$var$toShallow = (value)=>value;
var $0712aa0f43f6aa4b$var$getProto = (v)=>Reflect.getPrototypeOf(v);
function $0712aa0f43f6aa4b$var$createIterableMethod(method, isReadonly2, isShallow2) {
    return function(...args) {
        const target = this["__v_raw"];
        const rawTarget = $0712aa0f43f6aa4b$var$toRaw(target);
        const targetIsMap = $0712aa0f43f6aa4b$var$isMap(rawTarget);
        const isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
        const isKeyOnly = method === "keys" && targetIsMap;
        const innerIterator = target[method](...args);
        const wrap = isShallow2 ? $0712aa0f43f6aa4b$var$toShallow : isReadonly2 ? $0712aa0f43f6aa4b$var$toReadonly : $0712aa0f43f6aa4b$var$toReactive;
        !isReadonly2 && $0712aa0f43f6aa4b$var$track(rawTarget, "iterate", isKeyOnly ? $0712aa0f43f6aa4b$var$MAP_KEY_ITERATE_KEY : $0712aa0f43f6aa4b$var$ITERATE_KEY);
        return $0712aa0f43f6aa4b$var$extend(// inheriting all iterator properties
        Object.create(innerIterator), {
            // iterator protocol
            next () {
                const { value: value, done: done } = innerIterator.next();
                return done ? {
                    value: value,
                    done: done
                } : {
                    value: isPair ? [
                        wrap(value[0]),
                        wrap(value[1])
                    ] : wrap(value),
                    done: done
                };
            }
        });
    };
}
function $0712aa0f43f6aa4b$var$createReadonlyMethod(type) {
    return function(...args) {
        {
            const key = args[0] ? `on key "${args[0]}" ` : ``;
            $0712aa0f43f6aa4b$var$warn2(`${$0712aa0f43f6aa4b$var$capitalize(type)} operation ${key}failed: target is readonly.`, $0712aa0f43f6aa4b$var$toRaw(this));
        }
        return type === "delete" ? false : type === "clear" ? void 0 : this;
    };
}
function $0712aa0f43f6aa4b$var$createInstrumentations(readonly2, shallow) {
    const instrumentations = {
        get (key) {
            const target = this["__v_raw"];
            const rawTarget = $0712aa0f43f6aa4b$var$toRaw(target);
            const rawKey = $0712aa0f43f6aa4b$var$toRaw(key);
            if (!readonly2) {
                if ($0712aa0f43f6aa4b$var$hasChanged(key, rawKey)) $0712aa0f43f6aa4b$var$track(rawTarget, "get", key);
                $0712aa0f43f6aa4b$var$track(rawTarget, "get", rawKey);
            }
            const { has: has } = $0712aa0f43f6aa4b$var$getProto(rawTarget);
            const wrap = shallow ? $0712aa0f43f6aa4b$var$toShallow : readonly2 ? $0712aa0f43f6aa4b$var$toReadonly : $0712aa0f43f6aa4b$var$toReactive;
            if (has.call(rawTarget, key)) return wrap(target.get(key));
            else if (has.call(rawTarget, rawKey)) return wrap(target.get(rawKey));
            else if (target !== rawTarget) target.get(key);
        },
        get size () {
            const target = this["__v_raw"];
            !readonly2 && $0712aa0f43f6aa4b$var$track($0712aa0f43f6aa4b$var$toRaw(target), "iterate", $0712aa0f43f6aa4b$var$ITERATE_KEY);
            return target.size;
        },
        has (key) {
            const target = this["__v_raw"];
            const rawTarget = $0712aa0f43f6aa4b$var$toRaw(target);
            const rawKey = $0712aa0f43f6aa4b$var$toRaw(key);
            if (!readonly2) {
                if ($0712aa0f43f6aa4b$var$hasChanged(key, rawKey)) $0712aa0f43f6aa4b$var$track(rawTarget, "has", key);
                $0712aa0f43f6aa4b$var$track(rawTarget, "has", rawKey);
            }
            return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
        },
        forEach (callback, thisArg) {
            const observed = this;
            const target = observed["__v_raw"];
            const rawTarget = $0712aa0f43f6aa4b$var$toRaw(target);
            const wrap = shallow ? $0712aa0f43f6aa4b$var$toShallow : readonly2 ? $0712aa0f43f6aa4b$var$toReadonly : $0712aa0f43f6aa4b$var$toReactive;
            !readonly2 && $0712aa0f43f6aa4b$var$track(rawTarget, "iterate", $0712aa0f43f6aa4b$var$ITERATE_KEY);
            return target.forEach((value, key)=>{
                return callback.call(thisArg, wrap(value), wrap(key), observed);
            });
        }
    };
    $0712aa0f43f6aa4b$var$extend(instrumentations, readonly2 ? {
        add: $0712aa0f43f6aa4b$var$createReadonlyMethod("add"),
        set: $0712aa0f43f6aa4b$var$createReadonlyMethod("set"),
        delete: $0712aa0f43f6aa4b$var$createReadonlyMethod("delete"),
        clear: $0712aa0f43f6aa4b$var$createReadonlyMethod("clear")
    } : {
        add (value) {
            const target = $0712aa0f43f6aa4b$var$toRaw(this);
            const proto = $0712aa0f43f6aa4b$var$getProto(target);
            const rawValue = $0712aa0f43f6aa4b$var$toRaw(value);
            const valueToAdd = !shallow && !$0712aa0f43f6aa4b$var$isShallow(value) && !$0712aa0f43f6aa4b$var$isReadonly(value) ? rawValue : value;
            const hadKey = proto.has.call(target, valueToAdd) || $0712aa0f43f6aa4b$var$hasChanged(value, valueToAdd) && proto.has.call(target, value) || $0712aa0f43f6aa4b$var$hasChanged(rawValue, valueToAdd) && proto.has.call(target, rawValue);
            if (!hadKey) {
                target.add(valueToAdd);
                $0712aa0f43f6aa4b$var$trigger(target, "add", valueToAdd, valueToAdd);
            }
            return this;
        },
        set (key, value) {
            if (!shallow && !$0712aa0f43f6aa4b$var$isShallow(value) && !$0712aa0f43f6aa4b$var$isReadonly(value)) value = $0712aa0f43f6aa4b$var$toRaw(value);
            const target = $0712aa0f43f6aa4b$var$toRaw(this);
            const { has: has, get: get2 } = $0712aa0f43f6aa4b$var$getProto(target);
            let hadKey = has.call(target, key);
            if (!hadKey) {
                key = $0712aa0f43f6aa4b$var$toRaw(key);
                hadKey = has.call(target, key);
            } else $0712aa0f43f6aa4b$var$checkIdentityKeys(target, has, key);
            const oldValue = get2.call(target, key);
            target.set(key, value);
            if (!hadKey) $0712aa0f43f6aa4b$var$trigger(target, "add", key, value);
            else if ($0712aa0f43f6aa4b$var$hasChanged(value, oldValue)) $0712aa0f43f6aa4b$var$trigger(target, "set", key, value, oldValue);
            return this;
        },
        delete (key) {
            const target = $0712aa0f43f6aa4b$var$toRaw(this);
            const { has: has, get: get2 } = $0712aa0f43f6aa4b$var$getProto(target);
            let hadKey = has.call(target, key);
            if (!hadKey) {
                key = $0712aa0f43f6aa4b$var$toRaw(key);
                hadKey = has.call(target, key);
            } else $0712aa0f43f6aa4b$var$checkIdentityKeys(target, has, key);
            const oldValue = get2 ? get2.call(target, key) : void 0;
            const result = target.delete(key);
            if (hadKey) $0712aa0f43f6aa4b$var$trigger(target, "delete", key, void 0, oldValue);
            return result;
        },
        clear () {
            const target = $0712aa0f43f6aa4b$var$toRaw(this);
            const hadItems = target.size !== 0;
            const oldTarget = $0712aa0f43f6aa4b$var$isMap(target) ? new Map(target) : new Set(target);
            const result = target.clear();
            if (hadItems) $0712aa0f43f6aa4b$var$trigger(target, "clear", void 0, void 0, oldTarget);
            return result;
        }
    });
    const iteratorMethods = [
        "keys",
        "values",
        "entries",
        Symbol.iterator
    ];
    iteratorMethods.forEach((method)=>{
        instrumentations[method] = $0712aa0f43f6aa4b$var$createIterableMethod(method, readonly2, shallow);
    });
    return instrumentations;
}
function $0712aa0f43f6aa4b$var$createInstrumentationGetter(isReadonly2, shallow) {
    const instrumentations = $0712aa0f43f6aa4b$var$createInstrumentations(isReadonly2, shallow);
    return (target, key, receiver)=>{
        if (key === "__v_isReactive") return !isReadonly2;
        else if (key === "__v_isReadonly") return isReadonly2;
        else if (key === "__v_raw") return target;
        return Reflect.get($0712aa0f43f6aa4b$var$hasOwn(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
    };
}
var $0712aa0f43f6aa4b$var$mutableCollectionHandlers = {
    get: /* @__PURE__ */ $0712aa0f43f6aa4b$var$createInstrumentationGetter(false, false)
};
var $0712aa0f43f6aa4b$var$readonlyCollectionHandlers = {
    get: /* @__PURE__ */ $0712aa0f43f6aa4b$var$createInstrumentationGetter(true, false)
};
function $0712aa0f43f6aa4b$var$checkIdentityKeys(target, has, key) {
    const rawKey = $0712aa0f43f6aa4b$var$toRaw(key);
    if (rawKey !== key && has.call(target, rawKey)) {
        const type = $0712aa0f43f6aa4b$var$toRawType(target);
        $0712aa0f43f6aa4b$var$warn2(`Reactive ${type} contains both the raw and reactive versions of the same object${type === `Map` ? ` as keys` : ``}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`);
    }
}
var $0712aa0f43f6aa4b$var$reactiveMap = /* @__PURE__ */ new WeakMap();
var $0712aa0f43f6aa4b$var$shallowReactiveMap = /* @__PURE__ */ new WeakMap();
var $0712aa0f43f6aa4b$var$readonlyMap = /* @__PURE__ */ new WeakMap();
var $0712aa0f43f6aa4b$var$shallowReadonlyMap = /* @__PURE__ */ new WeakMap();
function $0712aa0f43f6aa4b$var$targetTypeMap(rawType) {
    switch(rawType){
        case "Object":
        case "Array":
            return 1;
        case "Map":
        case "Set":
        case "WeakMap":
        case "WeakSet":
            return 2;
        default:
            return 0;
    }
}
function $0712aa0f43f6aa4b$var$reactive2(target) {
    if (/* @__PURE__ */ $0712aa0f43f6aa4b$var$isReadonly(target)) return target;
    return $0712aa0f43f6aa4b$var$createReactiveObject(target, false, $0712aa0f43f6aa4b$var$mutableHandlers, $0712aa0f43f6aa4b$var$mutableCollectionHandlers, $0712aa0f43f6aa4b$var$reactiveMap);
}
function $0712aa0f43f6aa4b$var$readonly(target) {
    return $0712aa0f43f6aa4b$var$createReactiveObject(target, true, $0712aa0f43f6aa4b$var$readonlyHandlers, $0712aa0f43f6aa4b$var$readonlyCollectionHandlers, $0712aa0f43f6aa4b$var$readonlyMap);
}
function $0712aa0f43f6aa4b$var$createReactiveObject(target, isReadonly2, baseHandlers, collectionHandlers, proxyMap) {
    if (!$0712aa0f43f6aa4b$var$isObject(target)) {
        $0712aa0f43f6aa4b$var$warn2(`value cannot be made ${isReadonly2 ? "readonly" : "reactive"}: ${String(target)}`);
        return target;
    }
    if (target["__v_raw"] && !(isReadonly2 && target["__v_isReactive"])) return target;
    if (target["__v_skip"] || !Object.isExtensible(target)) return target;
    const existingProxy = proxyMap.get(target);
    if (existingProxy) return existingProxy;
    const targetType = $0712aa0f43f6aa4b$var$targetTypeMap($0712aa0f43f6aa4b$var$toRawType(target));
    if (targetType === 0) return target;
    const proxy = new Proxy(target, targetType === 2 ? collectionHandlers : baseHandlers);
    proxyMap.set(target, proxy);
    return proxy;
}
function $0712aa0f43f6aa4b$var$isReactive2(value) {
    if (/* @__PURE__ */ $0712aa0f43f6aa4b$var$isReadonly(value)) return /* @__PURE__ */ $0712aa0f43f6aa4b$var$isReactive2(value["__v_raw"]);
    return !!(value && value["__v_isReactive"]);
}
function $0712aa0f43f6aa4b$var$isReadonly(value) {
    return !!(value && value["__v_isReadonly"]);
}
function $0712aa0f43f6aa4b$var$isShallow(value) {
    return !!(value && value["__v_isShallow"]);
}
function $0712aa0f43f6aa4b$var$isProxy(value) {
    return value ? !!value["__v_raw"] : false;
}
function $0712aa0f43f6aa4b$var$toRaw(observed) {
    const raw2 = observed && observed["__v_raw"];
    return raw2 ? /* @__PURE__ */ $0712aa0f43f6aa4b$var$toRaw(raw2) : observed;
}
var $0712aa0f43f6aa4b$var$toReactive = (value)=>$0712aa0f43f6aa4b$var$isObject(value) ? /* @__PURE__ */ $0712aa0f43f6aa4b$var$reactive2(value) : value;
var $0712aa0f43f6aa4b$var$toReadonly = (value)=>$0712aa0f43f6aa4b$var$isObject(value) ? /* @__PURE__ */ $0712aa0f43f6aa4b$var$readonly(value) : value;
function $0712aa0f43f6aa4b$var$isRef(r) {
    return r ? r["__v_isRef"] === true : false;
}
// packages/alpinejs/src/magics/$nextTick.js
$0712aa0f43f6aa4b$var$magic("nextTick", ()=>$0712aa0f43f6aa4b$var$nextTick);
// packages/alpinejs/src/magics/$dispatch.js
$0712aa0f43f6aa4b$var$magic("dispatch", (el)=>$0712aa0f43f6aa4b$var$dispatch.bind($0712aa0f43f6aa4b$var$dispatch, el));
// packages/alpinejs/src/magics/$watch.js
$0712aa0f43f6aa4b$var$magic("watch", (el, { evaluateLater: evaluateLater2, cleanup: cleanup })=>(key, callback)=>{
        let evaluate2 = evaluateLater2(key);
        let getter = ()=>{
            let value;
            evaluate2((i)=>value = i);
            return value;
        };
        let unwatch = $0712aa0f43f6aa4b$var$watch(getter, callback);
        cleanup(unwatch);
    });
// packages/alpinejs/src/magics/$store.js
$0712aa0f43f6aa4b$var$magic("store", $0712aa0f43f6aa4b$var$getStores);
// packages/alpinejs/src/magics/$data.js
$0712aa0f43f6aa4b$var$magic("data", (el)=>$0712aa0f43f6aa4b$var$scope(el));
// packages/alpinejs/src/magics/$root.js
$0712aa0f43f6aa4b$var$magic("root", (el)=>$0712aa0f43f6aa4b$var$closestRoot(el));
// packages/alpinejs/src/magics/$refs.js
$0712aa0f43f6aa4b$var$magic("refs", (el)=>{
    if (el._x_refs_proxy) return el._x_refs_proxy;
    el._x_refs_proxy = $0712aa0f43f6aa4b$var$mergeProxies($0712aa0f43f6aa4b$var$getArrayOfRefObject(el));
    return el._x_refs_proxy;
});
function $0712aa0f43f6aa4b$var$getArrayOfRefObject(el) {
    let refObjects = [];
    $0712aa0f43f6aa4b$var$findClosest(el, (i)=>{
        if (i._x_refs) refObjects.push(i._x_refs);
    });
    return refObjects;
}
// packages/alpinejs/src/ids.js
var $0712aa0f43f6aa4b$var$globalIdMemo = {};
function $0712aa0f43f6aa4b$var$findAndIncrementId(name) {
    if (!$0712aa0f43f6aa4b$var$globalIdMemo[name]) $0712aa0f43f6aa4b$var$globalIdMemo[name] = 0;
    return ++$0712aa0f43f6aa4b$var$globalIdMemo[name];
}
function $0712aa0f43f6aa4b$var$closestIdRoot(el, name) {
    return $0712aa0f43f6aa4b$var$findClosest(el, (element)=>{
        if (element._x_ids && element._x_ids[name]) return true;
    });
}
function $0712aa0f43f6aa4b$var$setIdRoot(el, name) {
    if (!el._x_ids) el._x_ids = {};
    if (!el._x_ids[name]) el._x_ids[name] = $0712aa0f43f6aa4b$var$findAndIncrementId(name);
}
// packages/alpinejs/src/magics/$id.js
$0712aa0f43f6aa4b$var$magic("id", (el, { cleanup: cleanup })=>(name, key = null)=>{
        let cacheKey = `${name}${key ? `-${key}` : ""}`;
        return $0712aa0f43f6aa4b$var$cacheIdByNameOnElement(el, cacheKey, cleanup, ()=>{
            let root = $0712aa0f43f6aa4b$var$closestIdRoot(el, name);
            let id = root ? root._x_ids[name] : $0712aa0f43f6aa4b$var$findAndIncrementId(name);
            return key ? `${name}-${id}-${key}` : `${name}-${id}`;
        });
    });
$0712aa0f43f6aa4b$var$interceptClone((from, to)=>{
    if (from._x_id) to._x_id = from._x_id;
});
function $0712aa0f43f6aa4b$var$cacheIdByNameOnElement(el, cacheKey, cleanup, callback) {
    if (!el._x_id) el._x_id = {};
    if (el._x_id[cacheKey]) return el._x_id[cacheKey];
    let output = callback();
    el._x_id[cacheKey] = output;
    cleanup(()=>{
        delete el._x_id[cacheKey];
    });
    return output;
}
// packages/alpinejs/src/magics/$el.js
$0712aa0f43f6aa4b$var$magic("el", (el)=>el);
// packages/alpinejs/src/magics/index.js
$0712aa0f43f6aa4b$var$warnMissingPluginMagic("Focus", "focus", "focus");
$0712aa0f43f6aa4b$var$warnMissingPluginMagic("Persist", "persist", "persist");
function $0712aa0f43f6aa4b$var$warnMissingPluginMagic(name, magicName, slug) {
    $0712aa0f43f6aa4b$var$magic(magicName, (el)=>$0712aa0f43f6aa4b$var$warn(`You can't use [$${magicName}] without first installing the "${name}" plugin here: https://alpinejs.dev/plugins/${slug}`, el));
}
// packages/alpinejs/src/directives/x-modelable.js
$0712aa0f43f6aa4b$var$directive("modelable", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2, cleanup: cleanup })=>{
    let func = evaluateLater2(expression);
    let innerGet = ()=>{
        let result;
        func((i)=>result = i);
        return result;
    };
    let evaluateInnerSet = evaluateLater2(`${expression} = __placeholder`);
    let innerSet = (val)=>evaluateInnerSet(()=>{}, {
            scope: {
                "__placeholder": val
            }
        });
    let initialValue = innerGet();
    innerSet(initialValue);
    queueMicrotask(()=>{
        if (!el._x_model) return;
        el._x_removeModelListeners["default"]();
        let outerGet = el._x_model.get;
        let outerSet = el._x_model.setWithModifiers;
        let releaseEntanglement = $0712aa0f43f6aa4b$var$entangle({
            get () {
                return outerGet();
            },
            set (value) {
                outerSet(value);
            }
        }, {
            get () {
                return innerGet();
            },
            set (value) {
                innerSet(value);
            }
        });
        cleanup(releaseEntanglement);
    });
});
// packages/alpinejs/src/directives/x-teleport.js
$0712aa0f43f6aa4b$var$directive("teleport", (el, { modifiers: modifiers, expression: expression }, { cleanup: cleanup })=>{
    if (el.tagName.toLowerCase() !== "template") $0712aa0f43f6aa4b$var$warn("x-teleport can only be used on a <template> tag", el);
    let target = $0712aa0f43f6aa4b$var$getTarget(expression);
    let clone2 = el.content.cloneNode(true).firstElementChild;
    el._x_teleport = clone2;
    clone2._x_teleportBack = el;
    el.setAttribute("data-teleport-template", true);
    clone2.setAttribute("data-teleport-target", true);
    if (el._x_forwardEvents) el._x_forwardEvents.forEach((eventName)=>{
        clone2.addEventListener(eventName, (e)=>{
            e.stopPropagation();
            el.dispatchEvent(new e.constructor(e.type, e));
        });
    });
    $0712aa0f43f6aa4b$var$addScopeToNode(clone2, {}, el);
    let placeInDom = (clone3, target2, modifiers2)=>{
        if (modifiers2.includes("prepend")) target2.parentNode.insertBefore(clone3, target2);
        else if (modifiers2.includes("append")) target2.parentNode.insertBefore(clone3, target2.nextSibling);
        else target2.appendChild(clone3);
    };
    $0712aa0f43f6aa4b$var$mutateDom(()=>{
        $0712aa0f43f6aa4b$var$skipDuringClone(()=>{
            placeInDom(clone2, target, modifiers);
            $0712aa0f43f6aa4b$var$initTree(clone2);
        })();
    });
    el._x_teleportPutBack = ()=>{
        let target2 = $0712aa0f43f6aa4b$var$getTarget(expression);
        $0712aa0f43f6aa4b$var$mutateDom(()=>{
            placeInDom(el._x_teleport, target2, modifiers);
        });
    };
    cleanup(()=>$0712aa0f43f6aa4b$var$mutateDom(()=>{
            clone2.remove();
            $0712aa0f43f6aa4b$var$destroyTree(clone2);
        }));
});
var $0712aa0f43f6aa4b$var$teleportContainerDuringClone = document.createElement("div");
function $0712aa0f43f6aa4b$var$getTarget(expression) {
    let target = $0712aa0f43f6aa4b$var$skipDuringClone(()=>{
        return document.querySelector(expression);
    }, ()=>{
        return $0712aa0f43f6aa4b$var$teleportContainerDuringClone;
    })();
    if (!target) $0712aa0f43f6aa4b$var$warn(`Cannot find x-teleport element for selector: "${expression}"`);
    return target;
}
// packages/alpinejs/src/directives/x-ignore.js
var $0712aa0f43f6aa4b$var$handler = ()=>{};
$0712aa0f43f6aa4b$var$handler.inline = (el, { modifiers: modifiers }, { cleanup: cleanup })=>{
    modifiers.includes("self") ? el._x_ignoreSelf = true : el._x_ignore = true;
    cleanup(()=>{
        modifiers.includes("self") ? delete el._x_ignoreSelf : delete el._x_ignore;
    });
};
$0712aa0f43f6aa4b$var$directive("ignore", $0712aa0f43f6aa4b$var$handler);
// packages/alpinejs/src/directives/x-effect.js
$0712aa0f43f6aa4b$var$directive("effect", $0712aa0f43f6aa4b$var$skipDuringClone((el, { expression: expression }, { effect: effect3 })=>{
    effect3($0712aa0f43f6aa4b$var$evaluateLater(el, expression));
}));
// packages/alpinejs/src/utils/on.js
function $0712aa0f43f6aa4b$var$on(el, event, modifiers, callback) {
    let listenerTarget = el;
    let handler4 = (e)=>callback(e);
    let options = {};
    let wrapHandler = (callback2, wrapper)=>(e)=>wrapper(callback2, e);
    if (modifiers.includes("dot")) event = $0712aa0f43f6aa4b$var$dotSyntax(event);
    if (modifiers.includes("camel")) event = $0712aa0f43f6aa4b$var$camelCase2(event);
    if (modifiers.includes("capture")) options.capture = true;
    if (modifiers.includes("window")) listenerTarget = window;
    if (modifiers.includes("document")) listenerTarget = document;
    if (modifiers.includes("passive")) options.passive = modifiers[modifiers.indexOf("passive") + 1] !== "false";
    handler4 = $0712aa0f43f6aa4b$var$addDebounceOrThrottle(modifiers, handler4);
    if (modifiers.includes("prevent")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.preventDefault();
        next(e);
    });
    if (modifiers.includes("stop")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.stopPropagation();
        next(e);
    });
    if (modifiers.includes("once")) handler4 = wrapHandler(handler4, (next, e)=>{
        next(e);
        listenerTarget.removeEventListener(event, handler4, options);
    });
    if (modifiers.includes("away") || modifiers.includes("outside")) {
        listenerTarget = document;
        handler4 = wrapHandler(handler4, (next, e)=>{
            if (el.contains(e.target)) return;
            if (e.target.isConnected === false) return;
            if (el.offsetWidth < 1 && el.offsetHeight < 1) return;
            if (el._x_isShown === false) return;
            next(e);
        });
    }
    if (modifiers.includes("self")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.target === el && next(e);
    });
    if (event === "submit") handler4 = wrapHandler(handler4, (next, e)=>{
        if (e.target._x_pendingModelUpdates) e.target._x_pendingModelUpdates.forEach((fn)=>fn());
        next(e);
    });
    if ($0712aa0f43f6aa4b$var$isKeyEvent(event) || $0712aa0f43f6aa4b$var$isClickEvent(event)) handler4 = wrapHandler(handler4, (next, e)=>{
        if ($0712aa0f43f6aa4b$var$isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers)) return;
        next(e);
    });
    listenerTarget.addEventListener(event, handler4, options);
    return ()=>{
        listenerTarget.removeEventListener(event, handler4, options);
    };
}
function $0712aa0f43f6aa4b$var$addDebounceOrThrottle(modifiers, handler4) {
    if (modifiers.includes("debounce")) {
        let nextModifier = modifiers[modifiers.indexOf("debounce") + 1] || "invalid-wait";
        let wait = $0712aa0f43f6aa4b$var$isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
        handler4 = $0712aa0f43f6aa4b$var$debounce(handler4, wait);
    }
    if (modifiers.includes("throttle")) {
        let nextModifier = modifiers[modifiers.indexOf("throttle") + 1] || "invalid-wait";
        let wait = $0712aa0f43f6aa4b$var$isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
        handler4 = $0712aa0f43f6aa4b$var$throttle(handler4, wait);
    }
    return handler4;
}
function $0712aa0f43f6aa4b$var$dotSyntax(subject) {
    return subject.replace(/-/g, ".");
}
function $0712aa0f43f6aa4b$var$camelCase2(subject) {
    return subject.toLowerCase().replace(/-(\w)/g, (match, char)=>char.toUpperCase());
}
function $0712aa0f43f6aa4b$var$isNumeric(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
function $0712aa0f43f6aa4b$var$kebabCase2(subject) {
    if ([
        " ",
        "_"
    ].includes(subject)) return subject;
    return subject.replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[_\s]/, "-").toLowerCase();
}
function $0712aa0f43f6aa4b$var$isKeyEvent(event) {
    return [
        "keydown",
        "keyup"
    ].includes(event);
}
function $0712aa0f43f6aa4b$var$isClickEvent(event) {
    return [
        "contextmenu",
        "click",
        "mouse"
    ].some((i)=>event.includes(i));
}
var $0712aa0f43f6aa4b$var$nonKeyModifiers = [
    // x-on's own modifiers:
    "window",
    "document",
    "prevent",
    "stop",
    "once",
    "capture",
    "self",
    "away",
    "outside",
    "passive",
    "dot",
    "camel",
    "preserve-scroll",
    // x-model's own modifiers:
    "blur",
    "change",
    "lazy",
    "number",
    "boolean",
    "trim",
    "fill",
    "unintrusive",
    "parent"
];
function $0712aa0f43f6aa4b$var$isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers) {
    let keyModifiers = modifiers.filter((modifier, index)=>{
        if (modifier === "false" && modifiers[index - 1] === "passive") return false;
        return !$0712aa0f43f6aa4b$var$nonKeyModifiers.includes(modifier);
    });
    if (keyModifiers.includes("debounce")) {
        let debounceIndex = keyModifiers.indexOf("debounce");
        keyModifiers.splice(debounceIndex, $0712aa0f43f6aa4b$var$isNumeric((keyModifiers[debounceIndex + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
    }
    if (keyModifiers.includes("throttle")) {
        let debounceIndex = keyModifiers.indexOf("throttle");
        keyModifiers.splice(debounceIndex, $0712aa0f43f6aa4b$var$isNumeric((keyModifiers[debounceIndex + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
    }
    if (keyModifiers.length === 0) return false;
    if (keyModifiers.length === 1 && $0712aa0f43f6aa4b$var$keyToModifiers(e.key).includes(keyModifiers[0])) return false;
    const systemKeyModifiers = [
        "ctrl",
        "shift",
        "alt",
        "meta",
        "cmd",
        "super"
    ];
    const selectedSystemKeyModifiers = systemKeyModifiers.filter((modifier)=>keyModifiers.includes(modifier));
    keyModifiers = keyModifiers.filter((i)=>!selectedSystemKeyModifiers.includes(i));
    if (selectedSystemKeyModifiers.length > 0) {
        const activelyPressedKeyModifiers = selectedSystemKeyModifiers.filter((modifier)=>{
            if (modifier === "cmd" || modifier === "super") modifier = "meta";
            return e[`${modifier}Key`];
        });
        if (activelyPressedKeyModifiers.length === selectedSystemKeyModifiers.length) {
            if ($0712aa0f43f6aa4b$var$isClickEvent(e.type)) return false;
            if ($0712aa0f43f6aa4b$var$keyToModifiers(e.key).includes(keyModifiers[0])) return false;
        }
    }
    return true;
}
function $0712aa0f43f6aa4b$var$keyToModifiers(key) {
    if (!key) return [];
    key = $0712aa0f43f6aa4b$var$kebabCase2(key);
    let modifierToKeyMap = {
        "ctrl": "control",
        "slash": "/",
        "space": " ",
        "spacebar": " ",
        "cmd": "meta",
        "esc": "escape",
        "up": "arrow-up",
        "down": "arrow-down",
        "left": "arrow-left",
        "right": "arrow-right",
        "period": ".",
        "comma": ",",
        "equal": "=",
        "minus": "-",
        "underscore": "_"
    };
    modifierToKeyMap[key] = key;
    return Object.keys(modifierToKeyMap).map((modifier)=>{
        if (modifierToKeyMap[modifier] === key) return modifier;
    }).filter((modifier)=>modifier);
}
// packages/alpinejs/src/directives/x-model.js
$0712aa0f43f6aa4b$var$directive("model", (el, { modifiers: modifiers, expression: expression }, { effect: effect3, cleanup: cleanup })=>{
    let scopeTarget = el;
    if (modifiers.includes("parent")) scopeTarget = $0712aa0f43f6aa4b$var$findClosest(el, (element)=>element !== el);
    let evaluateGet = $0712aa0f43f6aa4b$var$evaluateLater(scopeTarget, expression);
    let evaluateSet;
    if (typeof expression === "string") evaluateSet = $0712aa0f43f6aa4b$var$evaluateLater(scopeTarget, `${expression} = __placeholder`);
    else if (typeof expression === "function" && typeof expression() === "string") evaluateSet = $0712aa0f43f6aa4b$var$evaluateLater(scopeTarget, `${expression()} = __placeholder`);
    else evaluateSet = ()=>{};
    let getValue = ()=>{
        let result;
        evaluateGet((value)=>result = value);
        return $0712aa0f43f6aa4b$var$isGetterSetter(result) ? result.get() : result;
    };
    let setValue = (value)=>{
        let result;
        evaluateGet((value2)=>result = value2);
        if ($0712aa0f43f6aa4b$var$isGetterSetter(result)) result.set(value);
        else evaluateSet(()=>{}, {
            scope: {
                "__placeholder": value
            }
        });
    };
    if (typeof expression === "string" && el.type === "radio") $0712aa0f43f6aa4b$var$mutateDom(()=>{
        if (!el.hasAttribute("name")) el.setAttribute("name", expression);
    });
    let hasChangeModifier = modifiers.includes("change") || modifiers.includes("lazy");
    let hasBlurModifier = modifiers.includes("blur");
    let hasEnterModifier = modifiers.includes("enter");
    let hasExplicitEventModifiers = hasChangeModifier || hasBlurModifier || hasEnterModifier;
    let removeListener;
    if ($0712aa0f43f6aa4b$var$isCloning) removeListener = ()=>{};
    else if (hasExplicitEventModifiers) {
        let listeners = [];
        let syncValue = (e)=>setValue($0712aa0f43f6aa4b$var$getInputValue(el, modifiers, e, getValue()));
        if (hasChangeModifier) listeners.push($0712aa0f43f6aa4b$var$on(el, "change", modifiers, syncValue));
        if (hasBlurModifier) {
            listeners.push($0712aa0f43f6aa4b$var$on(el, "blur", modifiers, syncValue));
            if (el.form) {
                let form = el.form;
                let syncCallback = ()=>syncValue({
                        target: el
                    });
                if (!form._x_pendingModelUpdates) form._x_pendingModelUpdates = [];
                form._x_pendingModelUpdates.push(syncCallback);
                cleanup(()=>{
                    if (form._x_pendingModelUpdates) form._x_pendingModelUpdates.splice(form._x_pendingModelUpdates.indexOf(syncCallback), 1);
                });
            }
        }
        if (hasEnterModifier) listeners.push($0712aa0f43f6aa4b$var$on(el, "keydown", modifiers, (e)=>{
            if (e.key === "Enter") syncValue(e);
        }));
        removeListener = ()=>listeners.forEach((remove2)=>remove2());
    } else {
        let event = el.tagName.toLowerCase() === "select" || [
            "checkbox",
            "radio"
        ].includes(el.type) ? "change" : "input";
        removeListener = $0712aa0f43f6aa4b$var$on(el, event, modifiers, (e)=>{
            setValue($0712aa0f43f6aa4b$var$getInputValue(el, modifiers, e, getValue()));
        });
    }
    if (modifiers.includes("fill")) {
        if ([
            void 0,
            null,
            ""
        ].includes(getValue()) || $0712aa0f43f6aa4b$var$isCheckbox(el) && Array.isArray(getValue()) || el.tagName.toLowerCase() === "select" && el.multiple) setValue($0712aa0f43f6aa4b$var$getInputValue(el, modifiers, {
            target: el
        }, getValue()));
    }
    if (!el._x_removeModelListeners) el._x_removeModelListeners = {};
    el._x_removeModelListeners["default"] = removeListener;
    cleanup(()=>el._x_removeModelListeners["default"]());
    if (el.form) {
        let removeResetListener = $0712aa0f43f6aa4b$var$on(el.form, "reset", [], (e)=>{
            $0712aa0f43f6aa4b$var$nextTick(()=>el._x_model && el._x_model.set($0712aa0f43f6aa4b$var$getInputValue(el, modifiers, {
                    target: el
                }, getValue())));
        });
        cleanup(()=>removeResetListener());
    }
    el._x_model = {
        get () {
            return getValue();
        },
        set (value) {
            setValue(value);
        },
        setWithModifiers: $0712aa0f43f6aa4b$var$addDebounceOrThrottle(modifiers, setValue)
    };
    el._x_forceModelUpdate = (value)=>{
        if (value === void 0 && typeof expression === "string" && expression.match(/\./)) value = "";
        $0712aa0f43f6aa4b$var$mutateDom(()=>{
            if ($0712aa0f43f6aa4b$var$isCheckbox(el)) {
                if (Array.isArray(value)) el.checked = value.some((val)=>val == el.value);
                else el.checked = !!value;
            } else if ($0712aa0f43f6aa4b$var$isRadio(el)) {
                if (typeof value === "boolean") el.checked = $0712aa0f43f6aa4b$var$safeParseBoolean(el.value) === value;
                else el.checked = el.value == value;
            } else $0712aa0f43f6aa4b$var$bind(el, "value", value);
        });
    };
    if (el.tagName === "SELECT") {
        let observer2 = new MutationObserver(()=>{
            el._x_forceModelUpdate(getValue());
        });
        observer2.observe(el, {
            childList: true
        });
        cleanup(()=>observer2.disconnect());
    }
    effect3(()=>{
        let value = getValue();
        if (modifiers.includes("unintrusive") && document.activeElement.isSameNode(el)) return;
        el._x_forceModelUpdate(value);
    });
});
function $0712aa0f43f6aa4b$var$getInputValue(el, modifiers, event, currentValue) {
    return $0712aa0f43f6aa4b$var$mutateDom(()=>{
        if (event instanceof CustomEvent && event.detail !== void 0) return event.detail !== null && event.detail !== void 0 ? event.detail : event.target.value;
        else if ($0712aa0f43f6aa4b$var$isCheckbox(el)) {
            if (Array.isArray(currentValue)) {
                let newValue = null;
                if (modifiers.includes("number")) newValue = $0712aa0f43f6aa4b$var$safeParseNumber(event.target.value);
                else if (modifiers.includes("boolean")) newValue = $0712aa0f43f6aa4b$var$safeParseBoolean(event.target.value);
                else newValue = event.target.value;
                return event.target.checked ? currentValue.includes(newValue) ? currentValue : currentValue.concat([
                    newValue
                ]) : currentValue.filter((el2)=>!$0712aa0f43f6aa4b$var$checkedAttrLooseCompare2(el2, newValue));
            } else return event.target.checked;
        } else if (el.tagName.toLowerCase() === "select" && el.multiple) {
            if (modifiers.includes("number")) return Array.from(event.target.selectedOptions).map((option)=>{
                let rawValue = option.value || option.text;
                return $0712aa0f43f6aa4b$var$safeParseNumber(rawValue);
            });
            else if (modifiers.includes("boolean")) return Array.from(event.target.selectedOptions).map((option)=>{
                let rawValue = option.value || option.text;
                return $0712aa0f43f6aa4b$var$safeParseBoolean(rawValue);
            });
            return Array.from(event.target.selectedOptions).map((option)=>{
                return option.value || option.text;
            });
        } else {
            let newValue;
            if ($0712aa0f43f6aa4b$var$isRadio(el)) {
                if (event.target.checked) newValue = event.target.value;
                else newValue = currentValue;
            } else newValue = event.target.value;
            if (modifiers.includes("number")) return $0712aa0f43f6aa4b$var$safeParseNumber(newValue);
            else if (modifiers.includes("boolean")) return $0712aa0f43f6aa4b$var$safeParseBoolean(newValue);
            else if (modifiers.includes("trim")) return newValue.trim();
            else return newValue;
        }
    });
}
function $0712aa0f43f6aa4b$var$safeParseNumber(rawValue) {
    let number = rawValue ? parseFloat(rawValue) : null;
    return $0712aa0f43f6aa4b$var$isNumeric2(number) ? number : rawValue;
}
function $0712aa0f43f6aa4b$var$checkedAttrLooseCompare2(valueA, valueB) {
    return valueA == valueB;
}
function $0712aa0f43f6aa4b$var$isNumeric2(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
function $0712aa0f43f6aa4b$var$isGetterSetter(value) {
    return value !== null && typeof value === "object" && typeof value.get === "function" && typeof value.set === "function";
}
// packages/alpinejs/src/directives/x-cloak.js
$0712aa0f43f6aa4b$var$directive("cloak", (el)=>queueMicrotask(()=>$0712aa0f43f6aa4b$var$mutateDom(()=>el.removeAttribute($0712aa0f43f6aa4b$var$prefix("cloak")))));
// packages/alpinejs/src/directives/x-init.js
$0712aa0f43f6aa4b$var$addInitSelector(()=>`[${$0712aa0f43f6aa4b$var$prefix("init")}]`);
$0712aa0f43f6aa4b$var$directive("init", $0712aa0f43f6aa4b$var$skipDuringClone((el, { expression: expression }, { evaluate: evaluate2 })=>{
    if (typeof expression === "string") return !!expression.trim() && evaluate2(expression, {}, false);
    return evaluate2(expression, {}, false);
}));
// packages/alpinejs/src/directives/x-text.js
$0712aa0f43f6aa4b$var$directive("text", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2 })=>{
    let evaluate2 = evaluateLater2(expression);
    effect3(()=>{
        evaluate2((value)=>{
            $0712aa0f43f6aa4b$var$mutateDom(()=>{
                el.textContent = value;
            });
        });
    });
});
// packages/alpinejs/src/directives/x-html.js
$0712aa0f43f6aa4b$var$directive("html", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2 })=>{
    let evaluate2 = evaluateLater2(expression);
    effect3(()=>{
        evaluate2((value)=>{
            $0712aa0f43f6aa4b$var$mutateDom(()=>{
                Array.from(el.children).forEach((child)=>$0712aa0f43f6aa4b$var$destroyTree(child));
                el.innerHTML = value ?? "";
                el._x_ignoreSelf = true;
                $0712aa0f43f6aa4b$var$initTree(el);
                delete el._x_ignoreSelf;
            });
        });
    }, {
        priority: "structural"
    });
});
// packages/alpinejs/src/directives/x-bind.js
$0712aa0f43f6aa4b$var$mapAttributes($0712aa0f43f6aa4b$var$startingWith(":", $0712aa0f43f6aa4b$var$into($0712aa0f43f6aa4b$var$prefix("bind:"))));
var $0712aa0f43f6aa4b$var$handler2 = (el, { value: value, modifiers: modifiers, expression: expression, original: original }, { effect: effect3, cleanup: cleanup })=>{
    if (!value) {
        let bindingProviders = {};
        $0712aa0f43f6aa4b$var$injectBindingProviders(bindingProviders);
        let getBindings = $0712aa0f43f6aa4b$var$evaluateLater(el, expression);
        getBindings((bindings)=>{
            $0712aa0f43f6aa4b$var$applyBindingsObject(el, bindings, original);
        }, {
            scope: bindingProviders
        });
        return;
    }
    if (value === "key") return $0712aa0f43f6aa4b$var$storeKeyForXFor(el, expression);
    if (el._x_inlineBindings && el._x_inlineBindings[value] && el._x_inlineBindings[value].extract) return;
    let evaluate2 = $0712aa0f43f6aa4b$var$evaluateLater(el, expression);
    effect3(()=>evaluate2((result)=>{
            if (result === void 0 && typeof expression === "string" && expression.match(/\./)) result = "";
            $0712aa0f43f6aa4b$var$mutateDom(()=>$0712aa0f43f6aa4b$var$bind(el, value, result, modifiers));
        }));
    cleanup(()=>{
        el._x_undoAddedClasses && el._x_undoAddedClasses();
        el._x_undoAddedStyles && el._x_undoAddedStyles();
    });
};
$0712aa0f43f6aa4b$var$handler2.inline = (el, { value: value, modifiers: modifiers, expression: expression })=>{
    if (!value) return;
    if (!el._x_inlineBindings) el._x_inlineBindings = {};
    el._x_inlineBindings[value] = {
        expression: expression,
        extract: false
    };
};
$0712aa0f43f6aa4b$var$directive("bind", $0712aa0f43f6aa4b$var$handler2);
function $0712aa0f43f6aa4b$var$storeKeyForXFor(el, expression) {
    el._x_keyExpression = expression;
}
// packages/alpinejs/src/directives/x-data.js
$0712aa0f43f6aa4b$var$addRootSelector(()=>`[${$0712aa0f43f6aa4b$var$prefix("data")}]`);
var $0712aa0f43f6aa4b$var$dataForReconciliation = Symbol();
$0712aa0f43f6aa4b$var$directive("data", (el, { expression: expression }, { cleanup: cleanup })=>{
    if ($0712aa0f43f6aa4b$var$shouldSkipRegisteringDataDuringClone(el)) return;
    let dataToReconcile = el[$0712aa0f43f6aa4b$var$dataForReconciliation];
    if (dataToReconcile?.expression === expression) return;
    expression = expression === "" ? "{}" : expression;
    let magicContext = {};
    $0712aa0f43f6aa4b$var$injectMagics(magicContext, el);
    let dataProviderContext = {};
    $0712aa0f43f6aa4b$var$injectDataProviders(dataProviderContext, magicContext);
    let data2 = $0712aa0f43f6aa4b$var$evaluate(el, expression, {
        scope: dataProviderContext
    });
    if (data2 === void 0 || data2 === true) data2 = {};
    $0712aa0f43f6aa4b$var$injectMagics(data2, el);
    let reactiveData;
    if (dataToReconcile?.reactiveData) {
        reactiveData = dataToReconcile.reactiveData;
        $0712aa0f43f6aa4b$var$reconcileData(reactiveData, data2);
        let initialized = {
            expression: expression
        };
        el[$0712aa0f43f6aa4b$var$dataForReconciliation] = initialized;
        queueMicrotask(()=>{
            if (el[$0712aa0f43f6aa4b$var$dataForReconciliation] === initialized) delete el[$0712aa0f43f6aa4b$var$dataForReconciliation];
        });
    } else reactiveData = $0712aa0f43f6aa4b$var$reactive(data2);
    $0712aa0f43f6aa4b$var$initInterceptors(reactiveData, cleanup);
    let undo = $0712aa0f43f6aa4b$var$addScopeToNode(el, reactiveData);
    $0712aa0f43f6aa4b$var$skipDuringClone(()=>{
        reactiveData["init"] && $0712aa0f43f6aa4b$var$evaluate(el, reactiveData["init"]);
    })();
    cleanup(()=>{
        reactiveData["destroy"] && $0712aa0f43f6aa4b$var$evaluate(el, reactiveData["destroy"]);
        undo();
        let removed = {
            reactiveData: reactiveData
        };
        el[$0712aa0f43f6aa4b$var$dataForReconciliation] = removed;
        queueMicrotask(()=>{
            if (el[$0712aa0f43f6aa4b$var$dataForReconciliation] === removed) delete el[$0712aa0f43f6aa4b$var$dataForReconciliation];
        });
    });
});
function $0712aa0f43f6aa4b$var$reconcileData(target, source) {
    Object.keys(source).forEach((key)=>{
        let descriptor = Object.getOwnPropertyDescriptor(source, key);
        let existingDescriptor = Object.getOwnPropertyDescriptor(target, key);
        if (descriptor.get || descriptor.set || existingDescriptor?.get || existingDescriptor?.set) {
            if (existingDescriptor) delete target[key];
            if (!existingDescriptor) target[key] = void 0;
            descriptor.get || descriptor.set ? Object.defineProperty(target, key, descriptor) : target[key] = source[key];
        } else target[key] = source[key];
    });
    Object.keys(target).filter((key)=>!Object.prototype.hasOwnProperty.call(source, key)).forEach((key)=>delete target[key]);
}
$0712aa0f43f6aa4b$var$interceptClone((from, to)=>{
    if (from._x_dataStack) {
        to._x_dataStack = from._x_dataStack;
        to.setAttribute("data-has-alpine-state", true);
    }
});
function $0712aa0f43f6aa4b$var$shouldSkipRegisteringDataDuringClone(el) {
    if (!$0712aa0f43f6aa4b$var$isCloning) return false;
    if ($0712aa0f43f6aa4b$var$isCloningLegacy) return true;
    return el.hasAttribute("data-has-alpine-state");
}
// packages/alpinejs/src/directives/x-show.js
$0712aa0f43f6aa4b$var$directive("show", (el, { modifiers: modifiers, expression: expression }, { effect: effect3 })=>{
    let evaluate2 = $0712aa0f43f6aa4b$var$evaluateLater(el, expression);
    if (!el._x_doHide) el._x_doHide = ()=>{
        $0712aa0f43f6aa4b$var$mutateDom(()=>{
            el.style.setProperty("display", "none", modifiers.includes("important") ? "important" : void 0);
        });
    };
    if (!el._x_doShow) el._x_doShow = ()=>{
        $0712aa0f43f6aa4b$var$mutateDom(()=>{
            if (el.style.length === 1 && el.style.display === "none") el.removeAttribute("style");
            else el.style.removeProperty("display");
        });
    };
    let hide = ()=>{
        el._x_doHide();
        el._x_isShown = false;
    };
    let show = ()=>{
        el._x_doShow();
        el._x_isShown = true;
    };
    let clickAwayCompatibleShow = ()=>setTimeout(show);
    let toggle = $0712aa0f43f6aa4b$var$once((value)=>value ? show() : hide(), (value)=>{
        if (typeof el._x_toggleAndCascadeWithTransitions === "function") el._x_toggleAndCascadeWithTransitions(el, value, show, hide);
        else value ? clickAwayCompatibleShow() : hide();
    });
    let oldValue;
    let firstTime = true;
    effect3(()=>evaluate2((value)=>{
            if (!firstTime && value === oldValue) return;
            if (modifiers.includes("immediate")) value ? clickAwayCompatibleShow() : hide();
            toggle(value);
            oldValue = value;
            firstTime = false;
        }));
});
// packages/alpinejs/src/directives/x-for.js
$0712aa0f43f6aa4b$var$directive("for", $0712aa0f43f6aa4b$var$skipDuringClone((el, { expression: expression }, { effect: effect3, cleanup: cleanup })=>{
    let iteratorNames = $0712aa0f43f6aa4b$var$parseForExpression(expression);
    let evaluateItems = $0712aa0f43f6aa4b$var$evaluateLater(el, iteratorNames.items);
    let evaluateKey = $0712aa0f43f6aa4b$var$evaluateLater(el, // the x-bind:key expression is stored for our use instead of evaluated.
    el._x_keyExpression || "index");
    el._x_lookup = /* @__PURE__ */ new Map();
    effect3(()=>$0712aa0f43f6aa4b$var$loop(el, iteratorNames, evaluateItems, evaluateKey), {
        priority: "structural"
    });
    cleanup(()=>{
        el._x_lookup.forEach((el2)=>$0712aa0f43f6aa4b$var$mutateDom(()=>{
                $0712aa0f43f6aa4b$var$destroyTree(el2);
                el2.remove();
            }));
        delete el._x_lookup;
        delete el._x_lastRenderedEl;
    });
}));
function $0712aa0f43f6aa4b$var$refreshScope(scope2) {
    return (newScope)=>{
        Object.entries(newScope).forEach(([key, value])=>{
            scope2[key] = value;
        });
    };
}
function $0712aa0f43f6aa4b$var$loop(templateEl, iteratorNames, evaluateItems, evaluateKey) {
    evaluateItems((items)=>{
        if ($0712aa0f43f6aa4b$var$isNumeric3(items)) items = Array.from({
            length: items
        }, (_, i)=>i + 1);
        if (items === void 0 || items === null) items = [];
        if (items instanceof Set) items = Array.from(items);
        if (items instanceof Map) items = Array.from(items);
        let oldLookup = templateEl._x_lookup;
        let lookup = /* @__PURE__ */ new Map();
        templateEl._x_lookup = lookup;
        let hasStringKeys = $0712aa0f43f6aa4b$var$isObject2(items);
        let scopeEntries = Object.entries(items).map(([index, item])=>{
            if (!hasStringKeys) index = parseInt(index);
            let scope2 = $0712aa0f43f6aa4b$var$getIterationScopeVariables(iteratorNames, item, index, items);
            let key;
            evaluateKey((innerKey)=>{
                if (typeof innerKey === "object") $0712aa0f43f6aa4b$var$warn("x-for key cannot be an object, it must be a string or an integer", templateEl);
                if (oldLookup.has(innerKey)) {
                    lookup.set(innerKey, oldLookup.get(innerKey));
                    oldLookup.delete(innerKey);
                }
                key = innerKey;
            }, {
                scope: {
                    index: index,
                    ...scope2
                }
            });
            return [
                key,
                scope2
            ];
        });
        $0712aa0f43f6aa4b$var$mutateDom(()=>{
            oldLookup.forEach((el)=>{
                $0712aa0f43f6aa4b$var$destroyTree(el);
                el.remove();
            });
            let added = /* @__PURE__ */ new Set();
            let prev = templateEl;
            scopeEntries.forEach(([key, scope2])=>{
                if (lookup.has(key)) {
                    let el = lookup.get(key);
                    el._x_refreshXForScope(scope2);
                    if (prev.nextElementSibling !== el) {
                        if (prev.nextElementSibling) el.replaceWith(prev.nextElementSibling);
                        prev.after(el);
                    }
                    prev = el;
                    if (el._x_currentIfEl) {
                        if (el.nextElementSibling !== el._x_currentIfEl) prev.after(el._x_currentIfEl);
                        prev = el._x_currentIfEl;
                    }
                    return;
                }
                if (templateEl.content.children.length > 1) $0712aa0f43f6aa4b$var$warn("x-for templates require a single root element, additional elements will be ignored.", templateEl);
                let clone2 = document.importNode(templateEl.content, true).firstElementChild;
                let reactiveScope = $0712aa0f43f6aa4b$var$reactive(scope2);
                $0712aa0f43f6aa4b$var$addScopeToNode(clone2, reactiveScope, templateEl);
                clone2._x_refreshXForScope = $0712aa0f43f6aa4b$var$refreshScope(reactiveScope);
                lookup.set(key, clone2);
                added.add(clone2);
                prev.after(clone2);
                prev = clone2;
            });
            added.forEach((clone2)=>$0712aa0f43f6aa4b$var$initTree(clone2));
            if (prev !== templateEl) templateEl._x_lastRenderedEl = prev;
            else delete templateEl._x_lastRenderedEl;
        });
    });
}
function $0712aa0f43f6aa4b$var$parseForExpression(expression) {
    let forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
    let stripParensRE = /^\s*\(|\)\s*$/g;
    let forAliasRE = /([\s\S]*?)\b(?:in|of)\b([\s\S]*)/;
    let inMatch = expression.match(forAliasRE);
    if (!inMatch) return;
    let res = {};
    res.items = inMatch[2].trim();
    let item = inMatch[1].replace(stripParensRE, "").trim();
    let iteratorMatch = item.match(forIteratorRE);
    if (iteratorMatch) {
        res.item = item.replace(forIteratorRE, "").trim();
        res.index = iteratorMatch[1].trim();
        if (iteratorMatch[2]) res.collection = iteratorMatch[2].trim();
    } else res.item = item;
    return res;
}
function $0712aa0f43f6aa4b$var$getIterationScopeVariables(iteratorNames, item, index, items) {
    let scopeVariables = {};
    if (/^\[.*\]$/.test(iteratorNames.item) && Array.isArray(item)) {
        let names = iteratorNames.item.replace("[", "").replace("]", "").split(",").map((i)=>i.trim());
        names.forEach((name, i)=>{
            scopeVariables[name] = item[i];
        });
    } else if (/^\{.*\}$/.test(iteratorNames.item) && !Array.isArray(item) && typeof item === "object") {
        let names = iteratorNames.item.replace("{", "").replace("}", "").split(",").map((i)=>i.trim());
        names.forEach((name)=>{
            scopeVariables[name] = item[name];
        });
    } else scopeVariables[iteratorNames.item] = item;
    if (iteratorNames.index) scopeVariables[iteratorNames.index] = index;
    if (iteratorNames.collection) scopeVariables[iteratorNames.collection] = items;
    return scopeVariables;
}
function $0712aa0f43f6aa4b$var$isNumeric3(subject) {
    return typeof subject !== "object" && !isNaN(subject);
}
function $0712aa0f43f6aa4b$var$isObject2(subject) {
    return typeof subject === "object" && !Array.isArray(subject);
}
// packages/alpinejs/src/directives/x-ref.js
function $0712aa0f43f6aa4b$var$handler3() {}
$0712aa0f43f6aa4b$var$handler3.inline = (el, { expression: expression }, { cleanup: cleanup })=>{
    let root = $0712aa0f43f6aa4b$var$closestRoot(el);
    if (!root) return;
    if (!root._x_refs) root._x_refs = {};
    root._x_refs[expression] = el;
    cleanup(()=>delete root._x_refs[expression]);
};
$0712aa0f43f6aa4b$var$directive("ref", $0712aa0f43f6aa4b$var$handler3);
// packages/alpinejs/src/directives/x-if.js
$0712aa0f43f6aa4b$var$directive("if", $0712aa0f43f6aa4b$var$skipDuringClone((el, { expression: expression }, { effect: effect3, cleanup: cleanup })=>{
    if (el.tagName.toLowerCase() !== "template") $0712aa0f43f6aa4b$var$warn("x-if can only be used on a <template> tag", el);
    let evaluate2 = $0712aa0f43f6aa4b$var$evaluateLater(el, expression);
    let show = ()=>{
        if (el._x_currentIfEl) return el._x_currentIfEl;
        let clone2 = el.content.cloneNode(true).firstElementChild;
        $0712aa0f43f6aa4b$var$addScopeToNode(clone2, {}, el);
        $0712aa0f43f6aa4b$var$mutateDom(()=>{
            el.after(clone2);
            $0712aa0f43f6aa4b$var$initTree(clone2);
        });
        el._x_currentIfEl = clone2;
        el._x_lastRenderedEl = clone2;
        el._x_undoIf = ()=>{
            $0712aa0f43f6aa4b$var$mutateDom(()=>{
                $0712aa0f43f6aa4b$var$destroyTree(clone2);
                clone2.remove();
            });
            delete el._x_currentIfEl;
            delete el._x_lastRenderedEl;
        };
        return clone2;
    };
    let hide = ()=>{
        if (!el._x_undoIf) return;
        el._x_undoIf();
        delete el._x_undoIf;
    };
    effect3(()=>evaluate2((value)=>{
            value ? show() : hide();
        }), {
        priority: "structural"
    });
    cleanup(()=>el._x_undoIf && el._x_undoIf());
}));
// packages/alpinejs/src/directives/x-id.js
$0712aa0f43f6aa4b$var$directive("id", (el, { expression: expression }, { evaluate: evaluate2 })=>{
    let names = evaluate2(expression);
    names.forEach((name)=>$0712aa0f43f6aa4b$var$setIdRoot(el, name));
});
$0712aa0f43f6aa4b$var$interceptClone((from, to)=>{
    if (from._x_ids) to._x_ids = from._x_ids;
});
// packages/alpinejs/src/directives/x-on.js
$0712aa0f43f6aa4b$var$mapAttributes($0712aa0f43f6aa4b$var$startingWith("@", $0712aa0f43f6aa4b$var$into($0712aa0f43f6aa4b$var$prefix("on:"))));
$0712aa0f43f6aa4b$var$directive("on", $0712aa0f43f6aa4b$var$skipDuringClone((el, { value: value, modifiers: modifiers, expression: expression }, { cleanup: cleanup })=>{
    let evaluate2 = expression ? $0712aa0f43f6aa4b$var$evaluateLater(el, expression) : ()=>{};
    if (el.tagName.toLowerCase() === "template") {
        if (!el._x_forwardEvents) el._x_forwardEvents = [];
        if (!el._x_forwardEvents.includes(value)) el._x_forwardEvents.push(value);
    }
    let removeListener = $0712aa0f43f6aa4b$var$on(el, value, modifiers, (e)=>{
        evaluate2(()=>{}, {
            scope: {
                "$event": e
            },
            params: [
                e
            ]
        });
    });
    cleanup(()=>removeListener());
}));
// packages/alpinejs/src/directives/index.js
$0712aa0f43f6aa4b$var$warnMissingPluginDirective("Collapse", "collapse", "collapse");
$0712aa0f43f6aa4b$var$warnMissingPluginDirective("Intersect", "intersect", "intersect");
$0712aa0f43f6aa4b$var$warnMissingPluginDirective("Focus", "trap", "focus");
$0712aa0f43f6aa4b$var$warnMissingPluginDirective("Mask", "mask", "mask");
function $0712aa0f43f6aa4b$var$warnMissingPluginDirective(name, directiveName, slug) {
    $0712aa0f43f6aa4b$var$directive(directiveName, (el)=>$0712aa0f43f6aa4b$var$warn(`You can't use [x-${directiveName}] without first installing the "${name}" plugin here: https://alpinejs.dev/plugins/${slug}`, el));
}
// packages/csp/src/directives/x-html.js
$0712aa0f43f6aa4b$var$directive("html", (el, { expression: expression })=>{
    $0712aa0f43f6aa4b$var$handleError(new Error("Using the x-html directive is prohibited in the CSP build"), el);
});
// packages/csp/src/index.js
$0712aa0f43f6aa4b$var$alpine_default.setEvaluator($0712aa0f43f6aa4b$var$cspEvaluator);
$0712aa0f43f6aa4b$var$alpine_default.setRawEvaluator($0712aa0f43f6aa4b$var$cspRawEvaluator);
$0712aa0f43f6aa4b$var$alpine_default.setReactivityEngine({
    reactive: $0712aa0f43f6aa4b$var$reactive2,
    // Since Vue 3.2, the scheduler is called with no arguments, so we wrap
    // the effect to hand Alpine's scheduler the runner it expects to queue.
    effect: (callback, options = {})=>{
        let runner;
        runner = $0712aa0f43f6aa4b$var$effect2(callback, {
            scheduler: ()=>{
                if (!runner) return;
                options.scheduler ? options.scheduler(runner) : runner();
            }
        });
        return runner;
    },
    release: $0712aa0f43f6aa4b$var$stop,
    raw: $0712aa0f43f6aa4b$var$toRaw
});
var $0712aa0f43f6aa4b$export$b7ee041e4ad2afec = $0712aa0f43f6aa4b$var$alpine_default;
// packages/csp/builds/module.js
var $0712aa0f43f6aa4b$export$2e2bcd8739ae039 = $0712aa0f43f6aa4b$export$b7ee041e4ad2afec;
 /*! Bundled license information:

@vue/shared/dist/shared.esm-bundler.js:
  (**
  * @vue/shared v3.5.41
  * (c) 2018-present Yuxi (Evan) You and Vue contributors
  * @license MIT
  **)

@vue/reactivity/dist/reactivity.esm-bundler.js:
  (**
  * @vue/reactivity v3.5.41
  * (c) 2018-present Yuxi (Evan) You and Vue contributors
  * @license MIT
  **)
*/ 

var $c2f84a84ccd9d6f1$var$htmx = (()=>{
    /**
     * HCON, htmx's mini config language. Mirrors the JSON API.
     *
     * Used by hx-trigger, hx-swap, hx-vals, and other htmx config attributes.
     *
     * @see https://four.htmx.org/docs#hcon
     */ const HCON = {
        /**
         * Parses an HCON string into an object.
         *
         * @example
         * HCON.parse('foo:1 bar:true');     // {foo: 1, bar: true}
         * HCON.parse('sse.mode:once');      // {sse: {mode: 'once'}}
         * HCON.parse('{"foo": 1}');         // {foo: 1}
         */ parse (string) {
            if (!string) return {};
            if (string.startsWith('{')) return JSON.parse(string);
            let pattern = /(?:"([^"]+)"|'([^']+)'|([^\s,:]+))(?:\s*:\s*(?:"([^"]*)"|'([^']*)'|<((?:[^/]|\/(?!>))+)\/>|([^\s,]+)))?(?=\s|,|$)/g;
            let result = {};
            for (let match of string.matchAll(pattern)){
                let [, doubleQuotedKey, singleQuotedKey, bareKey, doubleQuotedValue, singleQuotedValue, hyperscriptValue, bareValue] = match;
                // pick this match's key and value forms
                let key = doubleQuotedKey ?? singleQuotedKey ?? bareKey;
                let value = (doubleQuotedValue ?? singleQuotedValue ?? hyperscriptValue ?? bareValue ?? 'true').trim();
                // JSON-parse if possible (e.g. "5" -> 5; "abc" stays string)
                try {
                    value = JSON.parse(value);
                } catch  {}
                // bare a.b -> {a:{b:...}}; quoted "a.b" -> {"a.b":...}
                let isDottedPath = bareKey?.includes('.');
                let pair = isDottedPath ? key.split('.').reduceRight((acc, segment)=>({
                        [segment]: acc
                    }), value) : {
                    [key]: value
                };
                HCON.merge(pair, result);
            }
            return result;
        },
        /**
         * Splits an HCON-aware string at top-level commas.
         * Commas inside [], (), <.../>, "...", '...' are preserved.
         *
         * @example
         * HCON.split('a:1, b:2');                // ['a:1', ' b:2']
         * HCON.split('from:".a, .b", click');    // ['from:".a, .b"', ' click']
         */ split (string) {
            return string.split(/,(?![^\[]*\])(?![^(]*\))(?![^<]*\/>)(?=(?:[^"']|"[^"]*"|'[^']*')*$)/);
        },
        /**
         * Deep-merges a source (HCON string or object) into a target.
         *
         * @example
         * HCON.merge({a: {b: 1}}, {a: {c: 2}});   // {a: {b: 1, c: 2}}
         * HCON.merge('a.b:1', {a: {c: 2}});       // {a: {b: 1, c: 2}}
         */ merge (source, target) {
            if (typeof source === 'string') source = HCON.parse(source);
            for (let [key, val] of Object.entries(source)){
                if ([
                    '__proto__',
                    'constructor',
                    'prototype'
                ].includes(key)) continue;
                let sourceIsObject = val?.constructor === Object;
                let targetIsObject = target[key]?.constructor === Object;
                if (sourceIsObject && targetIsObject) HCON.merge(val, target[key]);
                else target[key] = val;
            }
            return target;
        }
    };
    class RequestQueue {
        #current = null;
        #queue = [];
        /** Returns "run", "queued", or "dropped" */ admit(strategy, runRequest, abortRequest) {
            if (!this.#current) {
                this.#current = {
                    strategy: strategy,
                    abort: abortRequest
                };
                return "run";
            }
            if (strategy === "replace" || strategy !== "abort" && this.#current.strategy === "abort") {
                this.#queue = [];
                this.#current.abort?.();
                this.#current = {
                    strategy: strategy,
                    abort: abortRequest
                };
                return "run";
            }
            if (strategy === "queue all") this.#queue.push(runRequest);
            else if (strategy === "queue last") this.#queue = [
                runRequest
            ];
            else if (strategy !== "abort" && strategy !== "drop" && this.#queue.length === 0) // default queue first
            this.#queue.push(runRequest);
            else return "dropped";
            return "queued";
        }
        continue() {
            this.#current = null // free current slot
            ;
            this.#queue.shift()?.() // run next request
            ;
        }
        abort() {
            this.#current?.abort?.();
        }
    }
    class Htmx {
        #HCON = HCON;
        #extMethods = new Map();
        #approvedExt = '';
        #registeredExt = new Set();
        _loc = window.location;
        #internalAPI;
        #Function = Function;
        #AsyncFunction = Object.getPrototypeOf(async function() {}).constructor;
        #ttPolicy = {
            createHTML: (s)=>s,
            createScript: (s)=>s
        };
        #actionSelector;
        #boostSelector = "a,form";
        #verbs = [
            "get",
            "post",
            "put",
            "patch",
            "delete",
            "query"
        ];
        #hxOnQuery;
        #transitionQueue;
        #historyAbort;
        #historyInitialized;
        #processingTransition;
        constructor(){
            this.#initHtmxConfig();
            this.#initRequestIndicatorCss();
            this.#actionSelector = this.#prefixSelector('[hx-action],[hx-get],[hx-post],[hx-put],[hx-patch],[hx-delete],[hx-query]');
            this.#hxOnQuery = new XPathEvaluator().createExpression(`.//*[@*[${this.#prefixes("hx-on").map((p)=>`starts-with(name(), "${p}")`).join(' or ')}]]`);
            this.#internalAPI = {
                HCON: HCON,
                attributeValue: this.#attributeValue.bind(this),
                parseTriggerSpecs: this.#parseTriggerSpecs.bind(this),
                determineMethodAndAction: this.#determineMethodAndAction.bind(this),
                createRequestContext: this.#createRequestContext.bind(this),
                collectFormData: this.#collectFormData.bind(this),
                getAttributeObject: this.#getAttributeObject.bind(this),
                insertContent: this.#insertContent.bind(this),
                morph: this.#morph.bind(this),
                isSoftMatch: this.#isSoftMatch.bind(this),
                initSecurity: (ttPolicy, syncFn, asyncFn)=>{
                    if (ttPolicy) this.#ttPolicy = ttPolicy;
                    if (syncFn) this.#Function = syncFn;
                    if (asyncFn) this.#AsyncFunction = asyncFn;
                },
                onTrigger: this.#onTrigger.bind(this),
                htmxProp: this.#htmxProp.bind(this),
                triggerHtmxEvent: this.#trigger.bind(this),
                executeJavaScript: this.#executeJavaScript.bind(this)
            };
            let init = ()=>this.initialize();
            if (document.readyState === 'loading') document.addEventListener("DOMContentLoaded", init);
            else setTimeout(init);
        }
        #initHtmxConfig() {
            this.version = '4.0.0';
            this.config = {
                logAll: false,
                prefix: "data-hx-",
                transitions: false,
                history: true,
                mode: 'same-origin',
                defaultSwap: "innerHTML",
                defaultFocusScroll: false,
                indicatorClass: "htmx-indicator",
                requestClass: "htmx-request",
                includeIndicatorCSS: true,
                defaultTimeout: 60000,
                /* 60 second default timeout */ extensions: '',
                morphIgnore: [
                    "data-htmx-powered"
                ],
                morphSkip: '[hx-morph-skip]',
                morphSkipChildren: '[hx-morph-skip-children]',
                morphScanLimit: 10,
                noSwap: [
                    204,
                    304
                ],
                implicitInheritance: false,
                defaultSettleDelay: 1,
                allowEmptySwapAfterOOB: false
            };
            let metaConfig = document.querySelector('meta[name="htmx-config"]');
            if (metaConfig) HCON.merge(metaConfig.content, this.config);
            this.#approvedExt = this.config.extensions;
        }
        #initRequestIndicatorCss() {
            if (this.config.includeIndicatorCSS !== false) {
                let indicator = this.config.indicatorClass;
                let request = this.config.requestClass;
                let sheet = new CSSStyleSheet();
                sheet.replaceSync(`.${indicator}{opacity:0;visibility: hidden} ` + `.${request} .${indicator}, .${request}.${indicator}{opacity:1;visibility: visible;transition: opacity 200ms ease-in}`);
                document.adoptedStyleSheets = [
                    ...document.adoptedStyleSheets,
                    sheet
                ];
            }
        }
        registerExtension(name, extension) {
            if (this.#approvedExt && !this.#approvedExt.split(/,\s*/).includes(name)) return false;
            if (this.#registeredExt.has(name)) return false;
            this.#registeredExt.add(name);
            if (extension.init) extension.init(this.#internalAPI);
            Object.entries(extension).forEach(([key, value])=>{
                if (!this.#extMethods.get(key)?.push(value)) this.#extMethods.set(key, [
                    value
                ]);
            });
        }
        #ignore(elt) {
            let p = this.config.prefix;
            return !elt.closest || elt.closest('[hx-ignore]') != null || p && elt.closest(`[${p}ignore]`) != null;
        }
        #attr(elt, name) {
            let p = this.config.prefix;
            return elt.getAttribute(name) ?? (p ? elt.getAttribute(name.replace('hx-', p)) : null);
        }
        #attrName(elt, name) {
            let p = this.config.prefix && name.replace('hx-', this.config.prefix);
            return elt.hasAttribute(name) ? name : p && elt.hasAttribute(p) ? p : null;
        }
        #prefixSelector(s) {
            return this.#prefixes(s).join(',');
        }
        #prefixes(s) {
            let result = [
                s
            ];
            if (this.config.prefix) result.push(s.replaceAll('hx-', this.config.prefix));
            return result;
        }
        #queryEltAndDescendants(elt, selector) {
            let results = [
                ...elt.querySelectorAll?.(selector) ?? []
            ];
            if (elt.matches?.(selector)) results.unshift(elt);
            return results;
        }
        #normalizeSwapStyle(style) {
            return style === 'before' ? 'beforebegin' : style === 'after' ? 'afterend' : style === 'prepend' ? 'afterbegin' : style === 'append' ? 'beforeend' : style;
        }
        #findThisElements(elt, attrName) {
            let result = [];
            this.#attributeValue(elt, attrName, undefined, (val, elt)=>{
                if (val?.split(/\s*[,:]\s*/).includes('this')) result.push(elt);
            });
            return result;
        }
        #attributeValue(elt, name, defaultVal, eltCollector) {
            name = this.#maybeAdjustMetaCharacter(name);
            let inherited = this.#maybeAdjustMetaCharacter(":inherited");
            let append = this.#maybeAdjustMetaCharacter(":append");
            let val = this.#attr(elt, name) ?? this.#attr(elt, name + inherited);
            if (val != null) return eltCollector ? eltCollector(val, elt) : val;
            let n1 = CSS.escape(this.config.implicitInheritance ? name : name + inherited);
            let n2 = CSS.escape(name + inherited + append);
            let inheritSelector = this.#prefixSelector(`[${n1}],[${n2}]`);
            let appendName = this.#attrName(elt, name + append) ?? this.#attrName(elt, name + inherited + append);
            if (appendName) {
                let appendValue = elt.getAttribute(appendName);
                let parent = elt.parentNode?.closest?.(inheritSelector);
                if (eltCollector) eltCollector(appendValue, elt);
                if (parent) {
                    let parentVal = this.#attributeValue(parent, name, undefined, eltCollector);
                    return parentVal ? (parentVal + "," + appendValue).replace(/[{}]/g, '') : appendValue;
                }
                return appendValue;
            }
            let parent = elt.parentNode?.closest?.(inheritSelector);
            if (parent) {
                val = this.#attributeValue(parent, name, undefined, eltCollector);
                if (!eltCollector && val && this.config.implicitInheritance) this.#triggerExtensions(elt, "htmx:after:implicitInheritance", {
                    elt: elt,
                    name: name,
                    parent: parent
                });
                return val;
            }
            return defaultVal;
        }
        #parseTriggerSpecs(spec) {
            return HCON.split(spec).flatMap((s)=>{
                let [, name, rest] = s.match(/^\s*(\S+\[[^\]]*\]|\S+)\s*(.*?)\s*$/) ?? [];
                if (!name) return []; // skip empty/whitespace-only tokens
                if (/\[[^\]]*$/.test(name)) throw "unterminated:" + name; // e.g. click[ctrlKey
                return [
                    {
                        name: name,
                        ...HCON.parse(rest)
                    }
                ]; // spread modifiers (delay, throttle, etc.) onto result
            });
        }
        #determineMethodAndAction(elt, evt) {
            let method = this.#attributeValue(elt, "hx-method");
            let action = this.#attributeValue(elt, "hx-action");
            if (!action) for (let verb of this.#verbs){
                let verbAction = this.#attributeValue(elt, "hx-" + verb);
                if (verbAction != null) {
                    action = verbAction;
                    method = verb;
                    break;
                }
            }
            if (this.#isBoosted(elt)) action ||= evt.submitter?.getAttribute?.("formAction") || elt.getAttribute(elt.matches("a") ? "href" : "action");
            method ||= evt.submitter?.getAttribute?.("formmethod") || elt.getAttribute("method") || "GET";
            return {
                action: action,
                method: method.toUpperCase()
            };
        }
        #htmxProp(elt) {
            if (!elt._htmx) {
                elt._htmx = {
                    listeners: [],
                    triggerSpecs: []
                };
                elt.setAttribute('data-htmx-powered', 'true');
            }
            return elt._htmx;
        }
        #htmxState(elt) {
            return elt._htmx_state ||= {};
        }
        #initializeElement(elt) {
            if (this.#shouldInitialize(elt) && this.#trigger(elt, "htmx:before:init", {}, true)) {
                let htmxProp = this.#htmxProp(elt);
                htmxProp.initialized = true;
                htmxProp.eventHandler = this.#createHtmxEventHandler(elt);
                this.#initializeTriggers(elt);
                this.#trigger(elt, "htmx:after:init", {}, true);
            }
        }
        #createHtmxEventHandler(elt) {
            return async (evt)=>{
                try {
                    let ctx = this.#createRequestContext(elt, evt);
                    await this.#handleTriggerEvent(ctx);
                } catch (e) {
                    this.#trigger(elt, 'htmx:error', {
                        error: e
                    });
                }
            };
        }
        #createRequestContext(sourceElement, sourceEvent) {
            let { action: action, method: method } = this.#determineMethodAndAction(sourceElement, sourceEvent);
            let [fullAction, anchor] = (action || '').split('#');
            let ac = new AbortController();
            let ctx = {
                sourceElement: sourceElement,
                sourceEvent: sourceEvent,
                status: "created",
                select: this.#attributeValue(sourceElement, "hx-select"),
                selectOOB: this.#attributeValue(sourceElement, "hx-select-oob"),
                target: this.#attributeValue(sourceElement, "hx-target"),
                swap: this.#attributeValue(sourceElement, "hx-swap") ?? this.config.defaultSwap,
                push: this.#attributeValue(sourceElement, "hx-push-url"),
                replace: this.#attributeValue(sourceElement, "hx-replace-url"),
                transition: this.config.transitions,
                confirm: this.#attributeValue(sourceElement, "hx-confirm"),
                request: {
                    validate: "true" === this.#attributeValue(sourceElement, "hx-validate", sourceElement.matches('form') && !sourceElement.noValidate && !sourceEvent.submitter?.formNoValidate ? "true" : "false"),
                    action: fullAction,
                    anchor: anchor,
                    method: method,
                    headers: this.#createCoreHeaders(sourceElement),
                    abort: ac.abort.bind(ac),
                    credentials: "same-origin",
                    signal: ac.signal,
                    mode: this.config.mode
                }
            };
            // Apply boost config overrides
            if (sourceElement._htmx?.boosted) HCON.merge(sourceElement._htmx.boosted, ctx);
            ctx.target = this.#resolveTarget(sourceElement, ctx.target);
            if (ctx.target) ctx.request.headers["HX-Target"] = this.#buildIdentifier(ctx.target);
            // Apply hx-config overrides
            let hxConfig = this.#attributeValue(sourceElement, "hx-config");
            if (hxConfig) {
                HCON.merge(hxConfig, ctx.request);
                ctx.request.mode = this.config.mode; // mode is security-sensitive, never allow per-element override
            }
            return ctx;
        }
        #buildIdentifier(elt) {
            return `${elt.tagName.toLowerCase()}${elt.id ? '#' + encodeURI(elt.id) : ''}`;
        }
        #createCoreHeaders(elt) {
            let headers = {
                "HX-Request": "true",
                "HX-Source": this.#buildIdentifier(elt),
                "HX-Current-URL": location.href,
                "Accept": "text/html"
            };
            if (this.#isBoosted(elt)) headers["HX-Boosted"] = "true";
            return headers;
        }
        #handleHxHeaders(elt, ctx) {
            return this.#getAttributeObject(elt, "hx-headers", (obj)=>{
                for(let key in obj)ctx.request.headers[key] = String(obj[key]);
            }, {
                ctx: ctx
            });
        }
        #resolveTarget(elt, selector) {
            if (selector instanceof Element) return selector;
            else if (selector != null) return this.#findOrWarn(elt, selector, "hx-target");
            else if (this.#isBoosted(elt)) return document.body;
            else return elt;
        }
        #isBoosted(elt) {
            return elt?._htmx?.boosted;
        }
        async #handleTriggerEvent(ctx) {
            let elt = ctx.sourceElement;
            let evt = ctx.sourceEvent;
            if (!elt.isConnected) return;
            if (this.#isModifierKeyClick(evt)) return;
            if (this.#shouldCancel(evt)) evt.preventDefault();
            // determine if request uses query params
            let usesQueryParams = /GET|DELETE/.test(ctx.request.method);
            // Only include *enclosing* form info for request types that do not use
            // query parameters (can still be included explicitly with hx-include)
            let form = usesQueryParams ? elt.matches('form') ? elt : null : elt.form || elt.closest("form");
            // Build request body
            let body = this.#collectFormData(elt, form, evt.submitter, ctx.request.validate, usesQueryParams);
            if (!body) return; // Validation failed
            let valsResult = this.#getAttributeObject(elt, "hx-vals", (obj)=>{
                ctx.vals = obj; // make available for json extensions
                for(let key in obj)body.set(key, obj[key]);
            }, {
                ctx: ctx
            });
            if (valsResult) await valsResult; // Only await if it returned a promise
            if (ctx.values) for(let k in ctx.values){
                body.delete(k);
                body.append(k, ctx.values[k]);
            }
            // Handle dynamic headers
            let headersResult = this.#handleHxHeaders(elt, ctx);
            if (headersResult) await headersResult // Only await if it returned a promise
            ;
            // Setup event-dependent request details
            Object.assign(ctx.request, {
                form: form,
                submitter: evt.submitter,
                body: body
            });
            if (!this.#trigger(elt, "htmx:config:request", {
                ctx: ctx
            })) return;
            if (ctx.request.method === 'DIALOG') return;
            let javascriptContent = this.#extractJavascriptContent(ctx.request.action);
            if (javascriptContent != null) {
                let data = Object.fromEntries(ctx.request.body);
                await this.#executeJavaScript(ctx.sourceElement, data, javascriptContent, false);
                return;
            } else if (usesQueryParams) {
                let url = new URL(ctx.request.action, document.baseURI);
                for (let key of ctx.request.body.keys())url.searchParams.delete(key);
                for (let [key, value] of ctx.request.body)url.searchParams.append(key, value);
                // Keep relative if same origin, otherwise use full URL
                if (url.origin === location.origin) ctx.request.action = url.pathname + url.search;
                else ctx.request.action = url.href;
                ctx.request.body = null;
            } else if ((this.#attributeValue(elt, "hx-encoding") ?? form?.enctype) !== "multipart/form-data") ctx.request.body = new URLSearchParams(ctx.request.body);
            await this.#issueRequest(ctx);
        }
        async #issueRequest(ctx) {
            let elt = ctx.sourceElement;
            let syncStrategy = this.#determineSyncStrategy(elt);
            let requestQueue = this.#getRequestQueue(elt);
            this.#initializeAbortListener(elt);
            if (requestQueue.admit(syncStrategy, ()=>this.#issueRequest(ctx), ()=>ctx.request?.abort?.() // abort if replaced
            ) !== "run") return;
            ctx.status = "issuing";
            let indicators = [];
            let disableElements = [];
            try {
                // Handle confirmation
                if (ctx.confirm) {
                    let confirmed = await new Promise((resolve)=>{
                        let detail = {
                            ctx: ctx,
                            issueRequest: ()=>resolve(true),
                            dropRequest: ()=>resolve(false)
                        };
                        if (this.#trigger(elt, "htmx:confirm", detail)) {
                            let js = this.#extractJavascriptContent(ctx.confirm);
                            resolve(js ? this.#executeJavaScript(elt, {
                                ctx: ctx
                            }, js, true) : window.confirm(ctx.confirm));
                        }
                    });
                    if (!confirmed) return;
                }
                // initialize timeout & indicators after confirmation
                this.#initTimeout(ctx);
                indicators = this.#showIndicators(elt);
                disableElements = this.#disableElements(elt);
                ctx.fetch ||= window.fetch.bind(window);
                // Set HX-Request-Type based on final target/select (after all modifications)
                ctx.request.headers["HX-Request-Type"] = ctx.target === document.body || ctx.select ? "full" : "partial";
                if (!this.#trigger(elt, "htmx:before:request", {
                    ctx: ctx
                })) return;
                let response = await ctx.fetch(ctx.request.action, ctx.request);
                ctx.response = {
                    raw: response,
                    status: response.status,
                    headers: response.headers
                };
                this.#extractHxHeaders(ctx);
                if (!this.#trigger(elt, "htmx:before:response", {
                    ctx: ctx
                })) return;
                ctx.text = await response.text();
                if (!this.#trigger(elt, "htmx:after:request", {
                    ctx: ctx
                })) return;
                if (ctx.response.status >= 400) this.#trigger(elt, "htmx:response:error", {
                    ctx: ctx
                });
                if (this.#handleHeadersAndMaybeReturnEarly(ctx)) {
                    ctx.keepIndicators = true;
                    return;
                }
                if (ctx.status === "issuing") {
                    if (ctx.hx.retarget) ctx.target = ctx.hx.retarget; // HX-Retarget
                    if (ctx.hx.reswap) ctx.swap = ctx.hx.reswap; // HX-Reswap
                    if (ctx.hx.reselect) ctx.select = ctx.hx.reselect; // HX-Reselect
                    ctx.status = "response received";
                    this.#handleStatusCodes(ctx);
                    await this.swap(ctx);
                    ctx.status = "swapped";
                }
            } catch (error) {
                ctx.status = "error: " + error;
                this.#trigger(elt, "htmx:error", {
                    ctx: ctx,
                    error: error
                });
            } finally{
                // An extension that took over the response reports when it has
                // finished delivering. Undefined for a normal request.
                await ctx.extensionPromise?.catch(()=>{});
                clearTimeout(ctx.requestTimeout);
                if (ctx.hx?.trigger) this.#handleTriggerHeader(ctx.hx.trigger, ctx.sourceElement);
                this.#trigger(elt, "htmx:finally:request", {
                    ctx: ctx
                });
                if (!ctx.keepIndicators) {
                    this.#hideIndicators(indicators);
                    this.#enableElements(disableElements);
                }
                requestQueue.continue();
            }
        }
        // Extract HX-* response headers into ctx.hx
        // Maps: HX-Trigger -> ctx.hx.trigger, HX-Push-Url -> ctx.hx.pushurl, etc.
        #extractHxHeaders(ctx) {
            ctx.hx = {};
            for (let [k, v] of ctx.response.raw.headers)if (k.toLowerCase().startsWith('hx-')) ctx.hx[k.slice(3).toLowerCase().replace(/-/g, '')] = v;
        }
        // Handle response headers that abort normal swap processing.
        // Returns true if the response was fully handled by a header.
        #handleHeadersAndMaybeReturnEarly(ctx) {
            if (ctx.hx.refresh === 'true') {
                this._loc.reload();
                return true;
            }
            if (ctx.hx.redirect) {
                this._loc.href = ctx.hx.redirect;
                return true;
            }
            if (ctx.hx.location) {
                let path = ctx.hx.location, opts = {};
                let parsed = HCON.parse(path);
                if (path[0] === '{' || parsed.path != null) {
                    opts = parsed;
                    path = opts.path;
                    delete opts.path;
                }
                if (opts.push == null && opts.replace == null) opts.push = 'true';
                this.ajax('GET', path, opts);
                return true;
            }
        }
        #initTimeout(ctx) {
            let timeout = ctx.request.timeout != null ? this.parseInterval(ctx.request.timeout) : this.config.defaultTimeout;
            if (timeout) ctx.requestTimeout = setTimeout(()=>ctx.request?.abort?.(), timeout);
        }
        #determineSyncStrategy(elt) {
            let hxSync = this.#attributeValue(elt, "hx-sync");
            if (!hxSync) return "queue first";
            let strategy = hxSync.split(":").pop().trim();
            return /^(drop|abort|replace|queue)/.test(strategy) ? strategy : "queue first";
        }
        #getRequestQueue(elt) {
            let hxSync = this.#attributeValue(elt, "hx-sync");
            let syncElt = elt;
            if (hxSync) {
                let selector = hxSync.includes(":") ? hxSync.slice(0, hxSync.lastIndexOf(":")).trim() : /^(drop|abort|replace|queue)/.test(hxSync) ? null : hxSync;
                if (selector) syncElt = this.#findOrWarn(elt, selector, "hx-sync") || elt;
            }
            return this.#htmxState(syncElt).rq ||= new RequestQueue();
        }
        #isModifierKeyClick(evt) {
            return evt.type === 'click' && (evt.ctrlKey || evt.metaKey || evt.shiftKey) && !!evt.currentTarget?.closest?.('a[href]');
        }
        #shouldCancel(evt) {
            let elt = evt.currentTarget;
            let isSubmit = evt.type === 'submit' && elt?.tagName === 'FORM';
            if (isSubmit) return true;
            let isClick = evt.type === 'click' && evt.button === 0;
            if (!isClick) return false;
            let btn = elt?.closest?.('button, input[type="submit"], input[type="image"]');
            let form = btn?.form || btn?.closest('form');
            let isSubmitButton = btn && !btn.disabled && form && (btn.type === 'submit' || btn.type === 'image' || !btn.type && btn.tagName === 'BUTTON');
            if (isSubmitButton) return true;
            let link = elt?.closest?.('a');
            if (!link || !link.href) return false;
            let href = link.getAttribute('href');
            let isFragmentOnly = href && href.startsWith('#') && href.length > 1;
            return !isFragmentOnly;
        }
        #initializeTriggers(elt, initialHandler = elt._htmx.eventHandler) {
            let hxTrigger = this.#attributeValue(elt, "hx-trigger");
            let trigger = hxTrigger || (elt.matches("form") ? "submit" : elt.matches("input:not([type=button]):not([type=submit]),select,textarea") ? "change" : "click");
            this.#onTrigger(elt, trigger, initialHandler);
        }
        // Wire up event listeners with full modifier support (once, prevent, stop,
        // delay, throttle, changed, capture, passive, from, filter, etc.)
        #onTrigger(elt, specString, handler) {
            let specs = this.#parseTriggerSpecs(specString);
            this.#htmxProp(elt).triggerSpecs.push(...specs);
            for (let spec of specs){
                spec.listeners = [];
                let [eventName, filter] = this.#extractFilter(spec.name);
                // Resolve from: elements (self listens on elt but filters by event.target in guard)
                let fromElts = [
                    elt
                ];
                if (spec.from === 'outside') fromElts = [
                    document
                ];
                else if (spec.from && spec.from !== 'self') fromElts = this.#findAllExt(elt, spec.from);
                // Inner: runs after delay/throttle resolves
                let inner = (evt)=>{
                    if (spec.halt || spec.prevent) evt.preventDefault();
                    if (spec.halt || spec.stop || spec.consume) evt.stopPropagation();
                    if (spec.once) for (let info of spec.listeners)info.fromElt.removeEventListener(info.eventName, info.handler, info);
                    handler(evt);
                };
                // Wrap inner with delay/throttle if needed
                let timed = inner;
                if (spec.delay) timed = (evt)=>{
                    clearTimeout(spec.timeout);
                    spec.timeout = setTimeout(()=>inner(evt), this.parseInterval(spec.delay));
                };
                else if (spec.throttle) timed = (evt)=>{
                    if (spec.throttled) spec.throttledEvent = evt;
                    else {
                        spec.throttled = true;
                        inner(evt);
                        spec.throttleTimeout = setTimeout(()=>{
                            spec.throttled = false;
                            if (spec.throttledEvent) {
                                let e = spec.throttledEvent;
                                spec.throttledEvent = null;
                                timed(e);
                            }
                        }, this.parseInterval(spec.throttle));
                    }
                };
                // Guarded: pre-timing checks that determine if event should proceed
                spec.handler = (evt)=>{
                    if (spec.from === 'self' && evt.target !== elt) return;
                    if (spec.from === 'outside' && elt.contains(evt.target)) return;
                    if (spec.target && !evt.target?.matches?.(spec.target)) return;
                    if (spec.changed) {
                        let values = spec.values ??= new WeakMap();
                        let changed = false;
                        for (let fromElt of fromElts)if (values.get(fromElt) !== fromElt.value) {
                            changed = true;
                            values.set(fromElt, fromElt.value);
                        }
                        if (!changed) return;
                    }
                    if (filter) {
                        if (this.#shouldCancel(evt)) evt.preventDefault();
                        let evtArgs = {};
                        for(let k in evt)evtArgs[k] = evt[k];
                        if (!this.#executeJavaScript(elt, evtArgs, filter, true, false)) return;
                    }
                    timed(evt);
                };
                // Intersect/revealed: set up observer
                if (eventName === 'intersect' || eventName === 'revealed') {
                    let observerOptions = {
                        rootMargin: spec.rootMargin
                    };
                    if (spec.root) observerOptions.root = this.#findOrWarn(elt, spec.root);
                    if (spec.threshold) observerOptions.threshold = parseFloat(spec.threshold);
                    let isRevealed = eventName === 'revealed';
                    spec.observer = new IntersectionObserver((entries)=>{
                        for(let i = 0; i < entries.length; i++)if (entries[i].isIntersecting) {
                            this.trigger(elt, 'intersect', {}, false);
                            if (isRevealed) spec.observer.disconnect();
                            break;
                        }
                    }, observerOptions);
                    eventName = 'intersect';
                    spec.observer.observe(elt);
                }
                // Every: set up interval
                if (eventName === "every") {
                    let interval = Object.keys(spec).find((k)=>k !== 'name');
                    spec.interval = setInterval(()=>{
                        if (elt.isConnected) this.#trigger(elt, 'every', {}, false);
                        else clearInterval(spec.interval);
                    }, this.parseInterval(interval));
                }
                // Load: fire immediately, no listener needed
                if (eventName === 'load') {
                    spec.handler(new CustomEvent('load'));
                    continue;
                }
                // Register listeners
                for (let fromElt of fromElts){
                    let listenerInfo = {
                        fromElt: fromElt,
                        eventName: eventName,
                        handler: spec.handler,
                        capture: !!spec.capture,
                        passive: !!spec.passive
                    };
                    elt._htmx.listeners.push(listenerInfo);
                    spec.listeners.push(listenerInfo);
                    fromElt.addEventListener(eventName, spec.handler, listenerInfo);
                }
            }
        }
        #extractFilter(str) {
            let match = str.match(/^([^\[]*)\[([^\]]*)]/);
            if (!match) return [
                str,
                null
            ];
            return [
                match[1],
                match[2]
            ];
        }
        #handleTriggerHeader(value, elt) {
            if (value[0] === '{') {
                let triggers = HCON.parse(value);
                for(let name in triggers){
                    let detail = triggers[name];
                    let target = elt;
                    if (detail?.target) target = this.find(detail.target);
                    this.trigger(target, name, typeof detail === 'object' ? detail : {
                        value: detail
                    });
                }
            } else value.split(',').forEach((name)=>this.trigger(elt, name.trim(), {}));
        }
        #apiMethods(thisArg) {
            let bound = {};
            let proto = Object.getPrototypeOf(this);
            for (let name of Object.getOwnPropertyNames(proto))if (name !== 'constructor' && typeof this[name] === 'function') {
                if ([
                    "find",
                    "findAll"
                ].includes(name)) bound[name] = (arg1, arg2)=>{
                    if (arg2 === undefined) return this[name](thisArg, arg1);
                    else return this[name](arg1, arg2);
                };
                else bound[name] = this[name].bind(this);
            }
            return bound;
        }
        #executeJavaScript(thisArg, obj, code, expression = true, isAsync = true, compile = false) {
            let args = {};
            Object.assign(args, this.#apiMethods(thisArg));
            let scope = {};
            let detail = {
                scope: scope,
                code: code
            };
            this.#triggerExtensions(thisArg, "htmx:scope", detail);
            code = detail.code;
            Object.assign(args, scope);
            Object.assign(args, obj);
            let keys = Object.keys(args);
            let values = Object.values(args);
            let FunctionConstructor = isAsync ? this.#AsyncFunction : this.#Function;
            let func = new FunctionConstructor(...keys, expression ? `return (${code})` : code);
            return compile ? ()=>func.call(thisArg, ...values) : func.call(thisArg, ...values);
        }
        /**
         * Initialize htmx attributes on root and all its descendants. When force is true, root
         * and every powered descendant are first torn down and re-wired from their current
         * attributes - use this after mutating hx-* attributes on an already-processed element.
         * @see https://four.htmx.org/reference/methods/htmx-process
         * @param {Element | ShadowRoot} root
         * @param {boolean} [force]
         */ process(root, force) {
            if (!root?.isConnected) return;
            if (!(root instanceof Element)) {
                for (let elt of root.children || [])this.process(elt, force);
                return;
            }
            if (force) this.#cleanup(root, true);
            if (this.#ignore(root)) return;
            if (!this.#trigger(root, "htmx:before:process")) return;
            let hxOnNodes = [
                root
            ];
            let iter = this.#hxOnQuery.evaluate(root);
            let node = null;
            while(node = iter.iterateNext())hxOnNodes.push(node);
            for (let hxOnNode of hxOnNodes)if (!this.#ignore(hxOnNode) && this.#trigger(hxOnNode, "htmx:before:on:init", {}, true)) this.#handleHxOnAttributes(hxOnNode);
            for (let elt of this.#queryEltAndDescendants(root, this.#actionSelector))this.#initializeElement(elt);
            for (let elt of this.#queryEltAndDescendants(root, this.#boostSelector))this.#maybeBoost(elt);
            this.#trigger(root, "htmx:after:process");
        }
        #maybeBoost(elt) {
            let hxBoost = this.#attributeValue(elt, "hx-boost");
            if (hxBoost && hxBoost !== "false" && this.#shouldBoost(elt) && this.#trigger(elt, "htmx:before:init", {}, true)) {
                let htmxProp = this.#htmxProp(elt);
                htmxProp.initialized = true;
                htmxProp.eventHandler = this.#createHtmxEventHandler(elt);
                htmxProp.boosted = hxBoost;
                let eventName = elt.matches('a') ? 'click' : 'submit';
                elt._htmx.listeners.push({
                    fromElt: elt,
                    eventName: eventName,
                    handler: elt._htmx.eventHandler
                });
                elt.addEventListener(eventName, elt._htmx.eventHandler);
                this.#trigger(elt, "htmx:after:init", {}, true);
            }
        }
        #shouldBoost(elt) {
            if (this.#shouldInitialize(elt)) {
                if (elt.tagName === "A") {
                    if (elt.target === '' || elt.target === '_self') return !elt.hasAttribute('download') && !elt.getAttribute('href')?.startsWith?.("#") && this.#isSameOrigin(elt.href);
                } else if (elt.tagName === "FORM") return elt.method !== 'dialog' && this.#isSameOrigin(elt.action);
            }
        }
        #isSameOrigin(url) {
            try {
                // URL constructor handles both relative and absolute URLs
                const parsed = new URL(url, window.location.href);
                return parsed.origin === window.location.origin;
            } catch (e) {
                // If URL parsing fails, assume not same-origin
                return false;
            }
        }
        #shouldInitialize(elt) {
            return !elt._htmx?.initialized && !this.#ignore(elt);
        }
        /**
         * Remove listeners, timers, and observers from elt and all its powered descendants.
         * When force is true, also delete their htmx state so a re-process fully re-initializes them.
         * @param {Element} elt
         * @param {boolean} [force]
         */ #cleanup(elt, force) {
            let elts = [
                elt,
                ...elt.querySelectorAll?.('[data-htmx-powered]') ?? []
            ];
            for (let e of elts){
                if (!e._htmx) continue;
                this.#trigger(e, "htmx:before:cleanup");
                for (let spec of e._htmx.triggerSpecs || []){
                    if (spec.interval) clearInterval(spec.interval);
                    if (spec.timeout) clearTimeout(spec.timeout);
                    if (spec.throttleTimeout) clearTimeout(spec.throttleTimeout);
                    spec.observer?.disconnect();
                }
                for (let info of e._htmx.listeners || [])info.fromElt.removeEventListener(info.eventName, info.handler, info);
                e.removeAttribute('data-htmx-powered');
                this.#trigger(e, "htmx:after:cleanup");
                if (force) delete e._htmx;
            }
        }
        #handlePreservedElements(fragment) {
            let pantry = document.createElement('div');
            pantry.hidden = true;
            document.body.insertAdjacentElement('afterend', pantry);
            let newPreservedElts = fragment.querySelectorAll?.(this.#prefixSelector('[hx-preserve]')) || [];
            for (let preservedElt of newPreservedElts){
                let currentElt = document.getElementById(preservedElt.id);
                if (currentElt) this.#moveBefore(pantry, currentElt, null);
            }
            return pantry;
        }
        #restorePreservedElements(pantry) {
            for (let preservedElt of [
                ...pantry.children
            ]){
                let newElt = document.getElementById(preservedElt.id);
                if (newElt) {
                    this.#moveBefore(newElt.parentNode, preservedElt, newElt);
                    this.#cleanup(newElt);
                    newElt.remove();
                }
            }
            pantry.remove();
        }
        #parseHTML(resp) {
            let trusted = this.#ttPolicy.createHTML(resp);
            return Document.parseHTMLUnsafe?.(trusted) || new DOMParser().parseFromString(trusted, 'text/html');
        }
        #makeFragment(text) {
            // Convert <hx-*> tags (e.g. <hx-partial>, <hx-oob>) to <template hx type="*">
            let response = text.replace(/<hx-([a-z]+)(\s+|>)/gi, '<template hx type="$1"$2').replace(/<\/hx-[a-z]+>/gi, '</template>');
            let title = '';
            response = response.replace(/<head(\s[^>]*)?>[\s\S]*?<\/head>/i, (m)=>(title = this.#parseHTML(m).title, ''));
            let startTag = response.match(/<([a-z][^\/>\x20\t\r\n\f]*)/i)?.[1]?.toLowerCase();
            let doc, fragment;
            if (startTag === 'html' || startTag === 'body') {
                doc = this.#parseHTML(response);
                fragment = document.createDocumentFragment();
                fragment.append(doc.body);
            } else {
                doc = this.#parseHTML(`<template>${response}</template>`);
                fragment = doc.querySelector('template').content;
            }
            if (!title) {
                let titleElt = fragment.querySelector('title:not(svg title)');
                if (titleElt) {
                    title = titleElt.textContent;
                    titleElt.remove();
                }
            }
            this.#processScripts(fragment);
            return {
                fragment: fragment,
                title: title
            };
        }
        #createOOBTask(tasks, elt, oobValue, sourceElement) {
            let targetSelector = elt.id ? '#' + CSS.escape(elt.id) : null;
            if (oobValue !== 'true' && oobValue && !oobValue.includes(' ')) [oobValue, targetSelector = targetSelector] = oobValue.split(/:(.*)/);
            if (oobValue === 'true' || !oobValue) oobValue = 'outerHTML';
            let swapSpec = this.#parseSwapSpec(oobValue);
            targetSelector = swapSpec.target || targetSelector;
            swapSpec.strip ??= !swapSpec.style.startsWith('outer');
            if (!targetSelector) return;
            let targets = [
                ...document.querySelectorAll(targetSelector)
            ];
            for (let target of targets){
                let fragment = document.createDocumentFragment();
                fragment.append(elt.cloneNode(true));
                tasks.push({
                    type: 'oob',
                    fragment: fragment,
                    target: target,
                    swapSpec: swapSpec,
                    sourceElement: sourceElement
                });
            }
            elt.remove();
        }
        #processOOB(fragment, sourceElement, selectOOB) {
            let tasks = [];
            // Process hx-select-oob first (select elements from response)
            if (selectOOB) for (let spec of selectOOB.split(',')){
                let [selector, oobValue = 'true'] = spec.split(/:(.*)/);
                for (let elt of fragment.querySelectorAll(selector))this.#createOOBTask(tasks, elt, oobValue, sourceElement);
            }
            // Process elements with hx-swap-oob attribute
            for (let oobElt of fragment.querySelectorAll(this.#prefixSelector('[hx-swap-oob]'))){
                let oobAttr = this.#attrName(oobElt, 'hx-swap-oob');
                let oobValue = oobElt.getAttribute(oobAttr);
                oobElt.removeAttribute(oobAttr);
                this.#createOOBTask(tasks, oobElt, oobValue, sourceElement);
            }
            return tasks;
        }
        #insertNodes(parent, before, fragment) {
            if (before) before.before(...fragment.childNodes);
            else parent.append(...fragment.childNodes);
        }
        #parseSwapSpec(swapStr) {
            swapStr = swapStr.trim();
            let style = this.config.defaultSwap;
            if (swapStr && !/^\S*:/.test(swapStr)) {
                let m = swapStr.match(/^(\S+)\s*(.*)$/);
                style = m[1];
                swapStr = m[2];
            }
            return {
                style: this.#normalizeSwapStyle(style),
                ...HCON.parse(swapStr)
            };
        }
        #processPartials(fragment, ctx) {
            let tasks = [];
            for (let templateElt of fragment.querySelectorAll('template[hx]')){
                let type = templateElt.getAttribute('type');
                if (type === 'partial') {
                    let targetSelector = this.#attr(templateElt, 'hx-target') || (templateElt.id ? '#' + CSS.escape(templateElt.id) : null);
                    if (targetSelector) {
                        this.#processScripts(templateElt.content);
                        let swapSpec = this.#parseSwapSpec(this.#attr(templateElt, 'hx-swap') || this.config.defaultSwap);
                        let targets = this.#findAllExt(ctx.sourceElement, targetSelector);
                        for (let target of targets.length ? targets : [
                            null
                        ])tasks.push({
                            type: 'partial',
                            fragment: templateElt.content.cloneNode(true),
                            target: target,
                            swapSpec: swapSpec,
                            sourceElement: ctx.sourceElement
                        });
                    }
                } else this.#triggerExtensions(templateElt, 'htmx:process:' + type, {
                    ctx: ctx,
                    tasks: tasks
                });
                templateElt.remove();
            }
            return tasks;
        }
        #setFocus(elt, options, start, end) {
            try {
                if (start != null && elt.setSelectionRange) elt.setSelectionRange(start, end);
                elt.focus(options);
            } catch (e) {
            // setSelectionRange or Web component focus may fail so ignore
            }
        }
        #handleAutoFocus(elt) {
            let autofocus = this.#queryEltAndDescendants(elt, '[autofocus]')[0];
            if (autofocus) this.#setFocus(autofocus);
        }
        #handleScroll(swapSpec, target) {
            if (swapSpec.scroll) {
                let scrollTarget = swapSpec.scrollTarget ? this.#findExt(swapSpec.scrollTarget) : target;
                if (scrollTarget) {
                    if (swapSpec.scroll === 'top') scrollTarget.scrollTop = 0;
                    else if (swapSpec.scroll === 'bottom') scrollTarget.scrollTop = scrollTarget.scrollHeight;
                }
            }
            if (swapSpec.show === 'top' || swapSpec.show === 'bottom') {
                let showTarget = swapSpec.showTarget ? this.#findExt(swapSpec.showTarget) : target;
                showTarget?.scrollIntoView?.(swapSpec.show === 'top');
            }
        }
        #handleAnchorScroll(ctx) {
            if (ctx.request?.anchor) document.getElementById(ctx.request.anchor)?.scrollIntoView({
                block: 'start',
                behavior: 'auto'
            });
        }
        #processScripts(container) {
            let scripts = this.#queryEltAndDescendants(container, 'script');
            for (let oldScript of scripts){
                let newScript = document.createElement('script');
                for (let attr of oldScript.attributes)newScript.setAttribute(attr.name, attr.value);
                if (this.config.inlineScriptNonce) newScript.nonce = this.config.inlineScriptNonce;
                newScript.textContent = this.#ttPolicy.createScript(oldScript.textContent);
                oldScript.replaceWith(newScript);
            }
        }
        //============================================================================================
        // Public JS API
        //============================================================================================
        initialize() {
            if (this.config.history && !this.#historyInitialized) {
                this.#historyInitialized = true;
                if (!history.state) history.replaceState({
                    htmx: true
                }, '', location.href);
                if (window.navigation && !/firefox/i.test(navigator.userAgent)) navigation.addEventListener('navigate', (event)=>{
                    if (event.navigationType === 'traverse' && event.canIntercept && !event.hashChange) event.intercept({
                        handler: ()=>this.#restoreHistory()
                    });
                });
                else window.addEventListener('popstate', (event)=>this.#restoreHistory(event.state));
            }
            this.process(document.body);
        }
        async swap(ctx) {
            try {
                this.#handleHistoryUpdate(ctx);
                let { fragment: fragment, title: title } = this.#makeFragment(ctx.text);
                ctx.title = title;
                let tasks = [];
                // Process OOB and partials
                let oobTasks = this.#processOOB(fragment, ctx.sourceElement, ctx.selectOOB);
                let partialTasks = this.#processPartials(fragment, ctx);
                tasks.push(...oobTasks, ...partialTasks);
                // Determine if empty swap should be prevented
                // partials always prevent; oob prevents by default unless config.allowEmptySwapAfterOOB is true
                let hasPartials = partialTasks.length || oobTasks.length && !this.config.allowEmptySwapAfterOOB;
                // Process main swap
                let mainSwap = this.#processMainSwap(ctx, fragment, hasPartials);
                if (mainSwap) tasks.unshift(mainSwap);
                if (!this.#trigger(ctx.sourceElement, "htmx:before:swap", {
                    ctx: ctx,
                    tasks: tasks
                })) return;
                let swapPromises = [];
                let transitionTasks = [];
                for (let task of tasks)if (task.swapSpec?.transition ?? mainSwap?.transition ?? ctx.transition) transitionTasks.push(task);
                else swapPromises.push(this.#insertContent(task));
                // submit all transition tasks in the transition queue w/no CSS transitions
                if (transitionTasks.length > 0) {
                    let tasksWrapper = async ()=>{
                        for (let task of transitionTasks)await this.#insertContent(task, false);
                    };
                    swapPromises.push(this.#submitTransitionTask(tasksWrapper, ctx));
                }
                await Promise.all(swapPromises);
                if (!ctx.sourceElement?.isConnected && mainSwap?.target?.isConnected) ctx.sourceElement = mainSwap.target;
                this.#trigger(ctx.sourceElement, "htmx:after:swap", {
                    ctx: ctx
                });
                if (ctx.title && !mainSwap?.swapSpec?.ignoreTitle) document.title = ctx.title;
                this.#handleAnchorScroll(ctx);
            } finally{
                this.#trigger(ctx.sourceElement, "htmx:finally:swap", {
                    ctx: ctx
                });
            }
        }
        #processMainSwap(ctx, fragment, hasPartials) {
            // Create main task if needed
            let swapSpec = this.#parseSwapSpec(ctx.swap || this.config.defaultSwap);
            // skip main swap if fragment is empty after partial/oob removal
            // swapEmpty modifier can override; default: skip if hasPartials
            if (swapSpec.style === 'delete' || // delete always runs regardless of content
            fragment.childElementCount > 0 || // or fragment has elements
            fragment.textContent.trim() || // or fragment has text
            (swapSpec.swapEmpty ?? !hasPartials)) {
                if (ctx.select) {
                    let selected = fragment.querySelectorAll(ctx.select);
                    fragment = document.createDocumentFragment();
                    fragment.append(...selected);
                }
                if (this.#isBoosted(ctx.sourceElement)) swapSpec.show ||= 'top';
                let mainSwap = {
                    type: 'main',
                    fragment: fragment,
                    target: this.#resolveTarget(ctx.sourceElement || document.body, swapSpec.target || ctx.target),
                    swapSpec: swapSpec,
                    sourceElement: ctx.sourceElement,
                    transition: ctx.transition && swapSpec.transition !== false
                };
                return mainSwap;
            }
        }
        async #insertContent(task, cssTransition = true) {
            let { target: target, swapSpec: swapSpec, fragment: fragment } = task;
            if (typeof target === 'string') target = document.querySelector(target);
            if (!target) return;
            if (typeof swapSpec === 'string') swapSpec = this.#parseSwapSpec(swapSpec);
            let swapStyle = swapSpec.style;
            if (swapStyle === 'none') return;
            // Body fragment: strip wrapper unless outer* swap on document.body
            if (fragment.firstElementChild?.tagName === 'BODY') {
                const keepBody = target === document.body && swapStyle.startsWith('outer');
                if (keepBody && swapStyle === 'outerHTML') swapStyle = 'outerSync';
                swapSpec.strip ??= !keepBody;
            }
            if (swapSpec.strip && fragment.firstElementChild) {
                fragment = document.createDocumentFragment();
                fragment.append(...(task.fragment.firstElementChild.content || task.fragment.firstElementChild).childNodes);
            }
            this.#addClass(target, "htmx-swapping");
            if (cssTransition && task.swapSpec?.swap) await this.timeout(task.swapSpec?.swap);
            if (swapStyle === 'delete') {
                if (target.parentNode) {
                    this.#cleanup(target);
                    target.parentNode.removeChild(target);
                }
                return;
            }
            // innerHTML/outerHTML swaps backup focus and handle CSS transitions
            let focusInfo;
            let settleTasks = [];
            let settleDelay = swapSpec.settle ?? this.config.defaultSettleDelay;
            let parentNode = target.parentNode;
            if (swapStyle === 'innerHTML' || swapStyle === 'outerHTML' && parentNode) {
                let activeElt = document.activeElement;
                if (activeElt?.id) {
                    let start, end;
                    try {
                        start = activeElt.selectionStart;
                        end = activeElt.selectionEnd;
                    } catch (e) {}
                    focusInfo = {
                        elt: activeElt,
                        start: start,
                        end: end
                    };
                }
                settleTasks = cssTransition && settleDelay ? this.#startCSSTransitions(fragment, target) : [];
            }
            let pantry = this.#handlePreservedElements(fragment);
            let newContent = [
                ...fragment.childNodes
            ];
            try {
                if (swapStyle === 'innerHTML') {
                    for (const child of target.children)this.#cleanup(child);
                    target.replaceChildren(...fragment.childNodes);
                } else if (swapStyle === 'textContent') {
                    for (const child of target.querySelectorAll('[data-htmx-powered]'))this.#cleanup(child);
                    target.textContent = fragment.textContent;
                } else if (swapStyle === 'outerHTML') {
                    if (parentNode) {
                        this.#insertNodes(parentNode, target, fragment);
                        this.#cleanup(target);
                        parentNode.removeChild(target);
                        target = newContent[0] || parentNode;
                    }
                } else if (swapStyle === 'outerSync') {
                    this.#copyAttributes(target, fragment.firstElementChild);
                    for (const child of target.children)this.#cleanup(child);
                    target.replaceChildren(...fragment.firstElementChild.childNodes);
                    newContent = [
                        target
                    ];
                } else if (swapStyle === 'innerMorph') {
                    this.#morph(target, fragment, true);
                    newContent = [
                        ...target.childNodes
                    ];
                } else if (swapStyle === 'outerMorph') {
                    this.#morph(target, fragment, false);
                    newContent.push(target);
                } else if (swapStyle === 'beforebegin') {
                    if (parentNode) this.#insertNodes(parentNode, target, fragment);
                } else if (swapStyle === 'afterbegin') this.#insertNodes(target, target.firstChild, fragment);
                else if (swapStyle === 'beforeend') this.#insertNodes(target, null, fragment);
                else if (swapStyle === 'afterend') {
                    if (parentNode) this.#insertNodes(parentNode, target.nextSibling, fragment);
                } else {
                    let methods = this.#extMethods.get('handle_swap') || [];
                    let handled = false;
                    for (const method of methods){
                        let result = method(swapStyle, target, fragment, swapSpec);
                        if (result) {
                            handled = true;
                            if (Array.isArray(result)) newContent = result;
                            break;
                        }
                    }
                    if (!handled) throw new Error(`Unknown swap style: ${swapStyle}`);
                }
            } finally{
                this.#removeClass(target, "htmx-swapping");
            }
            task.target = target;
            this.#restorePreservedElements(pantry);
            if (focusInfo && !focusInfo.elt.matches(':focus')) {
                let newElt = document.getElementById(focusInfo.elt.id);
                if (newElt) {
                    let focusOptions = {
                        preventScroll: swapSpec.focusScroll !== undefined ? !swapSpec.focusScroll : !this.config.defaultFocusScroll
                    };
                    this.#setFocus(newElt, focusOptions, focusInfo.start, focusInfo.end);
                }
            }
            this.#trigger(target, "htmx:before:settle", {
                task: task,
                newContent: newContent,
                settleTasks: settleTasks
            });
            for (const elt of newContent)this.#addClass(elt, "htmx-added");
            if (cssTransition && settleTasks.length > 0) {
                this.#addClass(target, "htmx-settling");
                await this.timeout(settleDelay);
                // invoke settle tasks
                for (let settleTask of settleTasks)settleTask();
                this.#removeClass(target, "htmx-settling");
            }
            this.#trigger(target, "htmx:after:settle", {
                task: task,
                newContent: newContent,
                settleTasks: settleTasks
            });
            for (const elt of newContent){
                this.#removeClass(elt, "htmx-added");
                this.process(elt);
                this.#handleAutoFocus(elt);
            }
            this.#handleScroll(swapSpec, target);
        }
        #trigger(on, eventName, detail = {}, bubbles = true) {
            // Convention: events with detail.error log at error level, detail.warn at warn level,
            // otherwise at event level (gated by config.logAll). One emit per event.
            if (detail.error) {
                let prefix = `htmx: ${eventName}: ${detail.error.message ?? detail.error}`;
                if (detail.error instanceof Error) console.error(prefix, detail.error, {
                    elt: on,
                    detail: detail
                });
                else console.error(prefix, {
                    elt: on,
                    detail: detail
                });
            } else if (detail.warn) console.warn(`htmx: ${eventName}: ${detail.warn}`, {
                elt: on,
                detail: detail
            });
            else if (this.config.logAll) console.log(`htmx: ${eventName}`, {
                elt: on,
                detail: detail
            });
            on = this.#normalizeElement(on);
            this.#triggerExtensions(on, eventName, detail);
            return this.trigger(on, this.#maybeAdjustMetaCharacter(eventName), detail, bubbles);
        }
        #triggerExtensions(elt, eventName, detail = {}) {
            let methods = this.#extMethods.get(eventName.replace(/:/g, '_'));
            if (methods) {
                detail.cancelled = false;
                for (const fn of methods)if (fn(elt, detail) === false || detail.cancelled) {
                    detail.cancelled = true;
                    return false;
                }
            }
            return true;
        }
        timeout(time) {
            time = this.parseInterval(time);
            if (time > 0) return new Promise((resolve)=>setTimeout(resolve, time));
        }
        onLoad(callback) {
            this.on(this.#maybeAdjustMetaCharacter("htmx:after:process"), (evt)=>{
                callback(evt.target);
            });
        }
        on(eventOrElt, eventOrCallback, callback) {
            let event;
            let elt = document;
            if (callback === undefined) {
                event = eventOrElt;
                callback = eventOrCallback;
            } else {
                elt = this.#normalizeElement(eventOrElt);
                event = eventOrCallback;
            }
            elt.addEventListener(event, callback);
            return callback;
        }
        find(selectorOrElt, selector) {
            return this.#findExt(selectorOrElt, selector);
        }
        findAll(selectorOrElt, selector) {
            return this.#findAllExt(selectorOrElt, selector);
        }
        parseInterval(str) {
            if (typeof str === 'number') return str;
            let m = {
                ms: 1,
                s: 1000,
                m: 60000
            };
            let [, n, u] = str?.match(/^([\d.]+)(ms|s|m)?$/) || [];
            let v = parseFloat(n) * (m[u] || 1);
            return isNaN(v) ? undefined : v;
        }
        trigger(on, eventName, detail = {}, bubbles = true) {
            on = this.#normalizeElement(on);
            let evt = new CustomEvent(eventName, {
                detail: detail,
                cancelable: true,
                bubbles: bubbles,
                composed: true
            });
            let target = on?.isConnected ? on : document;
            let result = !detail.cancelled && target.dispatchEvent(evt);
            return result;
        }
        ajax(verb, path, options) {
            // Normalize options to object
            if (!options || options instanceof Element || typeof options === 'string') options = {
                target: options
            };
            let sourceElt = typeof options.source === 'string' ? document.querySelector(options.source) : options.source;
            // If source selector was provided but didn't match, reject
            if (typeof options.source === 'string' && !sourceElt) return Promise.reject(new Error('Source not found'));
            // Resolve explicit target if provided; otherwise #createRequestContext
            // will resolve from hx-target on the source element
            if (options.target) {
                let target = this.#resolveTarget(document.body, options.target);
                if (!target) return Promise.reject(new Error('Target not found'));
                sourceElt ||= target;
            }
            sourceElt ||= document.body;
            let ctx = this.#createRequestContext(sourceElt, options.event || {});
            Object.assign(ctx, options);
            if (options.target) ctx.target = this.#resolveTarget(document.body, options.target);
            Object.assign(ctx.request, {
                action: path,
                method: verb.toUpperCase()
            });
            if (options.headers) Object.assign(ctx.request.headers, options.headers);
            return this.#handleTriggerEvent(ctx);
        }
        //============================================================================================
        // History Support
        //============================================================================================
        #pushUrlIntoHistory(path) {
            if (!this.config.history) return;
            if (!history.state) history.replaceState({
                htmx: true
            }, '', location.href);
            history.pushState({
                htmx: true
            }, '', path);
            this.#trigger(document, "htmx:after:history:push", {
                path: path
            });
        }
        #replaceUrlInHistory(path) {
            if (!this.config.history) return;
            history.replaceState({
                htmx: true
            }, '', path);
            this.#trigger(document, "htmx:after:history:replace", {
                path: path
            });
        }
        async #restoreHistory(state, path) {
            await this.timeout(1);
            state ??= history.state;
            if (!state?.htmx) return;
            this.#historyAbort?.abort();
            path = path || location.pathname + location.search;
            let historyElt = document.querySelector(this.#prefixSelector('[hx-history-elt]')) || document.body;
            if (this.#trigger(document, "htmx:before:history:restore", {
                path: path,
                cacheMiss: true
            })) {
                if (this.config.history === "reload") this._loc.reload();
                else {
                    this.#historyAbort = new AbortController();
                    return this.ajax('GET', path, {
                        target: historyElt,
                        swap: 'outerSync',
                        select: historyElt !== document.body ? this.#prefixSelector('[hx-history-elt]') : undefined,
                        request: {
                            headers: {
                                'HX-History-Restore-Request': 'true'
                            },
                            signal: this.#historyAbort.signal
                        }
                    });
                }
            }
        }
        #resolveHistoryAction(ctx) {
            let { sourceElement: sourceElement, push: push, replace: replace, hx: hx, response: response } = ctx;
            // allow response headers to override history action
            if (hx?.pushurl || hx?.replaceurl) {
                push = hx.pushurl;
                replace = hx.replaceurl;
            }
            // if this is a boosted element, default to pushing
            if (push == null && replace == null && this.#isBoosted(sourceElement)) push = 'true';
            // normalize "false" to null
            if (push === 'false' || push === false) push = null;
            if (replace === 'false' || replace === false) replace = null;
            if (!push && !replace) return null;
            let path = push || replace;
            // if the path is simply "true" normalize to the current path
            if (path === 'true') {
                let finalUrl = response?.raw?.url || ctx.request.action;
                let url = new URL(finalUrl, location.href);
                path = url.pathname + url.search + (ctx.request.anchor ? '#' + ctx.request.anchor : '');
            }
            let type = push ? 'push' : 'replace';
            return {
                type: type,
                path: path
            };
        }
        #handleHistoryUpdate(ctx) {
            if (!this.config.history) return;
            let action = this.#resolveHistoryAction(ctx);
            if (!action) return;
            let historyDetail = {
                history: action,
                sourceElement: ctx.sourceElement,
                response: ctx.response
            };
            if (!this.#trigger(document, "htmx:before:history:update", historyDetail)) return;
            if (action.type === 'push') this.#pushUrlIntoHistory(action.path);
            else this.#replaceUrlInHistory(action.path);
            this.#trigger(document, "htmx:after:history:update", historyDetail);
        }
        // hx-on:<event> binds to <event> directly
        // hx-on::<event> is shorthand for hx-on:htmx:<event> (htmx events)
        #handleHxOnAttributes(node) {
            if (node._htmx?.onInitialized) return;
            let hxOnNames = this.#prefixes("hx-on");
            let mc = this.config.metaCharacter || ':';
            let handler = (code)=>async (evt)=>{
                    try {
                        await this.#executeJavaScript(node, {
                            event: evt
                        }, `with(event?.detail||{}){${code}}`, false);
                    } catch (e) {
                        if (typeof e !== 'symbol') this.#trigger(node, 'htmx:error', {
                            error: e
                        });
                    }
                };
            for (let attr of node.getAttributeNames()){
                let prefix = hxOnNames.find((p)=>attr.startsWith(p));
                if (!prefix) continue;
                this.#htmxProp(node).onInitialized = true;
                let rest = attr.substring(prefix.length);
                let value = node.getAttribute(attr);
                // hx-on="click once -> doA(); blur -> doB()"
                if (!rest) {
                    for (let part of value.split(/;(?=[^;]*->)/)){
                        let idx = part.indexOf('->');
                        if (idx !== -1) this.#onTrigger(node, part.substring(0, idx).trim(), handler(part.substring(idx + 2).trim()));
                    }
                    continue;
                }
                // hx-on:click="code" or hx-on::before:request="code"
                if (rest[0] !== mc) continue;
                let eventName = rest.substring(1);
                if (eventName.startsWith(mc)) eventName = 'htmx' + mc + eventName.substring(1);
                this.#onTrigger(node, eventName, handler(value));
            }
        }
        #showIndicators(elt) {
            let hxIndicator = this.#attributeValue(elt, "hx-indicator");
            let indicatorElements;
            if (!hxIndicator) {
                if (elt === document.body) return [];
                indicatorElements = [
                    elt
                ];
            } else indicatorElements = this.#findAllExt(elt, hxIndicator, "hx-indicator");
            for (const indicator of indicatorElements){
                let s = this.#htmxState(indicator);
                s.rc = (s.rc || 0) + 1;
                this.#addClass(indicator, this.config.requestClass);
            }
            return indicatorElements;
        }
        #hideIndicators(indicatorElements) {
            for (let indicator of indicatorElements){
                let s = this.#htmxState(indicator);
                if (s.rc && --s.rc <= 0) {
                    this.#removeClass(indicator, this.config.requestClass);
                    delete s.rc;
                }
            }
        }
        #disableElements(elt) {
            let hxDisable = this.#attributeValue(elt, "hx-disable");
            let disabledElements = [];
            if (hxDisable) {
                disabledElements = this.#findAllExt(elt, hxDisable, "hx-disable");
                for (let indicator of disabledElements){
                    let s = this.#htmxState(indicator);
                    s.dc = (s.dc || 0) + 1;
                    indicator.disabled = true;
                }
            }
            return disabledElements;
        }
        #enableElements(disabledElements) {
            for (const indicator of disabledElements){
                let s = this.#htmxState(indicator);
                if (s.dc && --s.dc <= 0) {
                    indicator.disabled = false;
                    delete s.dc;
                }
            }
        }
        #collectFormData(elt, form, submitter, validate, isGet) {
            if (validate && form && !form.reportValidity()) return;
            let formData = form ? new FormData(form) : new FormData();
            let included = form ? new Set(form.elements) : new Set();
            if (!form) {
                if (validate && elt.reportValidity && !elt.reportValidity()) return;
                this.#addInputValues(elt, included, formData, isGet);
            }
            if (submitter && submitter.name) {
                formData.append(submitter.name, submitter.value);
                included.add(submitter);
            }
            let hxInclude = this.#attributeValue(elt, "hx-include");
            if (hxInclude) for (let node of this.#findAllExt(elt, hxInclude)){
                if (validate && node.reportValidity && !node.reportValidity()) return;
                this.#addInputValues(node, included, formData);
            }
            return formData;
        }
        #addInputValues(elt, included, formData, isGet) {
            let tag = elt.tagName;
            let inputs = [];
            if (tag === 'BUTTON' || tag.includes('-')) inputs = [
                elt
            ]; // send own value only, never collect children
            else if ([
                'INPUT',
                'SELECT',
                'TEXTAREA',
                'FIELDSET'
            ].includes(tag) || !isGet) inputs = this.#queryEltAndDescendants(elt, '[name]:not(button)');
            // GET on non-form-control containers (div, etc.) sends nothing; use hx-include for explicit inclusion
            for (let input of inputs){
                let name = input.name || input.getAttribute?.('name');
                if (!name || input.matches(':disabled') || included.has(input)) continue;
                included.add(input);
                let type = input.type;
                if (type === 'checkbox' || type === 'radio' || input.tagName !== 'INPUT' && 'checked' in input) // Only add if checked
                {
                    if (input.checked) formData.append(name, input.value);
                } else if (type === 'file') // Add all selected files
                for (let file of input.files)formData.append(name, file);
                else if (type === 'select-multiple') // Add all selected options
                for (let option of input.selectedOptions)formData.append(name, option.value);
                else if (Array.isArray(input.value)) // Add all array values (e.g. custom elements)
                for (let v of input.value)formData.append(name, v);
                else formData.append(name, input.value);
            }
        }
        #getAttributeObject(elt, attrName, callback, scope = {}) {
            let hxAttr = this.#attributeValue(elt, attrName);
            if (!hxAttr) return null;
            let javascriptContent = this.#extractJavascriptContent(hxAttr);
            if (javascriptContent) {
                // Wrap in braces if not already wrapped (for htmx 2.x compatibility)
                if (javascriptContent.indexOf('{') !== 0) javascriptContent = '{' + javascriptContent + '}';
                // Return promise for async evaluation
                return this.#executeJavaScript(elt, scope, javascriptContent, true).then((obj)=>{
                    callback(obj);
                });
            } else // Synchronous path - return the parsed object directly
            callback(HCON.parse(hxAttr));
        }
        #stringHyperscriptStyleSelector(selector) {
            let s = selector.trim();
            return s.startsWith('<') && s.endsWith('/>') ? s.slice(1, -2) : s;
        }
        #findAllExt(eltOrSelector, maybeSelector, thisAttr, global) {
            let selector = maybeSelector ?? eltOrSelector;
            let elt = maybeSelector ? this.#normalizeElement(eltOrSelector) || document.body : document;
            if (selector.startsWith('global ')) return this.#findAllExt(elt, selector.slice(7), thisAttr, true);
            let parts = selector ? HCON.split(selector) : [];
            let result = [];
            let unprocessedParts = [];
            for (const part of parts){
                let selector = this.#stringHyperscriptStyleSelector(part);
                let item;
                if (selector.startsWith('closest ')) item = elt.closest(selector.slice(8));
                else if (selector.startsWith('find ')) item = elt.querySelector(selector.slice(5));
                else if (selector.startsWith('findAll ')) result.push(...elt.querySelectorAll(selector.slice(8)));
                else if (selector === 'next' || selector === 'nextElementSibling') item = elt.nextElementSibling;
                else if (selector.startsWith('next ')) item = this.#scanForwardQuery(elt, selector.slice(5), !!global);
                else if (selector === 'previous' || selector === 'previousElementSibling') item = elt.previousElementSibling;
                else if (selector.startsWith('previous ')) item = this.#scanBackwardsQuery(elt, selector.slice(9), !!global);
                else if (selector === 'document') item = document;
                else if (selector === 'window') item = window;
                else if (selector === 'body') item = document.body;
                else if (selector === 'host') item = elt.getRootNode().host;
                else if (selector === 'this') {
                    if (thisAttr) {
                        result.push(...this.#findThisElements(elt, thisAttr));
                        continue;
                    }
                    item = elt;
                } else unprocessedParts.push(selector);
                if (item) result.push(item);
            }
            if (unprocessedParts.length > 0) {
                let standardSelector = unprocessedParts.join(',');
                let rootNode = this.#getRootNode(elt, !!global);
                result.push(...rootNode.querySelectorAll(standardSelector));
            }
            return [
                ...new Set(result)
            ];
        }
        #scanForwardQuery(start, match, global) {
            return this.#scanUntilComparison(this.#getRootNode(start, global).querySelectorAll(match), start, Node.DOCUMENT_POSITION_PRECEDING);
        }
        #scanBackwardsQuery(start, match, global) {
            let results = [
                ...this.#getRootNode(start, global).querySelectorAll(match)
            ].reverse();
            return this.#scanUntilComparison(results, start, Node.DOCUMENT_POSITION_FOLLOWING);
        }
        #scanUntilComparison(results, start, comparison) {
            for (const elt of results){
                if (elt.compareDocumentPosition(start) === comparison) return elt;
            }
        }
        #getRootNode(elt, global) {
            if (elt.isConnected && elt.getRootNode) return elt.getRootNode?.({
                composed: global
            });
            else return document;
        }
        #findOrWarn(elt, selector, thisAttr) {
            let result = this.#findAllExt(elt, selector, thisAttr)[0];
            if (!result) console.warn(`htmx: '${selector}' on ${thisAttr} did not match any element`, {
                elt: elt,
                selector: selector,
                attr: thisAttr
            });
            return result;
        }
        #findExt(eltOrSelector, selector, thisAttr) {
            return this.#findAllExt(eltOrSelector, selector, thisAttr)[0];
        }
        #extractJavascriptContent(string) {
            if (string != null) {
                if (string.startsWith("js:")) return string.substring(3);
                else if (string.startsWith("javascript:")) return string.substring(11);
            }
        }
        #initializeAbortListener(elt) {
            let htmxProp = this.#htmxProp(elt);
            if (htmxProp.abortInitialized) return;
            htmxProp.abortInitialized = true;
            let handler = ()=>{
                let requestQueue = this.#getRequestQueue(elt);
                requestQueue.abort();
            };
            elt.addEventListener("htmx:abort", handler);
            htmxProp.listeners.push({
                fromElt: elt,
                eventName: "htmx:abort",
                handler: handler
            });
        }
        #morph(oldNode, fragment, innerHTML) {
            let { persistentIds: persistentIds, idMap: idMap } = this.#createIdMaps(oldNode, fragment);
            let pantry = document.createElement("div");
            pantry.hidden = true;
            document.body.after(pantry);
            let ctx = {
                target: oldNode,
                idMap: idMap,
                persistentIds: persistentIds,
                pantry: pantry,
                futureMatches: new WeakSet()
            };
            if (innerHTML) this.#morphChildren(ctx, oldNode, fragment);
            else this.#morphChildren(ctx, oldNode.parentNode, fragment, oldNode, oldNode.nextSibling);
            this.#cleanup(pantry);
            pantry.remove();
        }
        #morphChildren(ctx, oldParent, newParent, insertionPoint = null, endPoint = null) {
            if (oldParent instanceof HTMLTemplateElement && newParent instanceof HTMLTemplateElement) {
                oldParent = oldParent.content;
                newParent = newParent.content;
            }
            insertionPoint ||= oldParent.firstChild;
            let newChild = newParent.firstChild;
            while(newChild){
                let matchedNode;
                if (insertionPoint && insertionPoint != endPoint) {
                    matchedNode = this.#findBestMatch(ctx, newChild, insertionPoint, endPoint);
                    if (matchedNode) {
                        if (matchedNode !== insertionPoint) {
                            let cursor = insertionPoint;
                            while(cursor && cursor !== matchedNode){
                                let tempNode = cursor;
                                cursor = cursor.nextSibling;
                                // remove nodes unless they match upcoming content in which case move them to end for later use
                                if (tempNode instanceof Element && (ctx.idMap.has(tempNode) || this.#matchesUpcomingSibling(ctx, tempNode, newChild))) this.#moveBefore(oldParent, tempNode, endPoint);
                                else this.#removeNode(ctx, tempNode);
                            }
                        }
                    }
                }
                if (!matchedNode && newChild instanceof Element && ctx.persistentIds.has(newChild.id)) {
                    let escapedId = CSS.escape(newChild.id);
                    matchedNode = ctx.target.id === newChild.id && ctx.target || ctx.target.querySelector(`[id="${escapedId}"]`) || ctx.pantry.querySelector(`[id="${escapedId}"]`);
                    let element = matchedNode;
                    while(element = element.parentNode){
                        let idSet = ctx.idMap.get(element);
                        if (idSet) {
                            idSet.delete(matchedNode.id);
                            if (!idSet.size) ctx.idMap.delete(element);
                        }
                    }
                    this.#moveBefore(oldParent, matchedNode, insertionPoint);
                }
                if (matchedNode) {
                    this.#morphNode(matchedNode, newChild, ctx);
                    insertionPoint = matchedNode.nextSibling;
                    newChild = newChild.nextSibling;
                    continue;
                }
                let nextNewChild = newChild.nextSibling;
                if (ctx.idMap.has(newChild)) {
                    let placeholder = document.createElement(newChild.tagName);
                    oldParent.insertBefore(placeholder, insertionPoint);
                    this.#morphNode(placeholder, newChild, ctx);
                    this.process(placeholder);
                    insertionPoint = placeholder.nextSibling;
                } else {
                    oldParent.insertBefore(newChild, insertionPoint);
                    insertionPoint = newChild.nextSibling;
                }
                newChild = nextNewChild;
            }
            while(insertionPoint && insertionPoint != endPoint){
                let tempNode = insertionPoint;
                insertionPoint = insertionPoint.nextSibling;
                this.#removeNode(ctx, tempNode);
            }
        }
        #matchesUpcomingSibling(ctx, oldElt, startNode) {
            if (ctx.futureMatches.has(oldElt)) return true;
            for(let sibling = startNode.nextSibling, i = 0; sibling && i < this.config.morphScanLimit; sibling = sibling.nextSibling, i++)if (sibling instanceof Element && oldElt.isEqualNode(sibling)) {
                ctx.futureMatches.add(oldElt);
                return true;
            }
            return false;
        }
        #findBestMatch(ctx, node, startPoint, endPoint) {
            // text nodes match positionally (patch in place via #morphNode), 3 = TEXT_NODE
            if (node.nodeType === 3) return startPoint?.nodeType === 3 ? startPoint : null;
            if (!(node instanceof Element)) return null;
            let softMatch = null, displaceMatchCount = 0, scanLimit = this.config.morphScanLimit;
            let newSet = ctx.idMap.get(node), nodeMatchCount = newSet?.size || 0;
            // If node has a non-persistent ID, insert instead of soft matching
            if (node.id && !newSet) return null;
            let cursor = startPoint;
            while(cursor && cursor != endPoint){
                let oldSet = ctx.idMap.get(cursor);
                if (this.#internalAPI.isSoftMatch(cursor, node)) {
                    // Hard match: matching IDs found in both nodes
                    if (oldSet && newSet && [
                        ...oldSet
                    ].some((id)=>newSet.has(id))) return cursor;
                    if (!oldSet) {
                        // Exact match: nodes are identical
                        if (scanLimit > 0 && cursor.isEqualNode(node)) return cursor;
                        // Soft match: same tag/type, save as fallback
                        if (!softMatch) softMatch = cursor;
                    }
                }
                // Stop if too many ID elements would be displaced
                displaceMatchCount += oldSet?.size || 0;
                if (displaceMatchCount > nodeMatchCount) break;
                // Don't move elements containing a focused typeable input
                if (document.activeElement?.selectionStart != null && cursor.contains(document.activeElement)) break;
                // Stop scanning if limit reached and no IDs to match
                if (--scanLimit < 1 && nodeMatchCount === 0) break;
                cursor = cursor.nextSibling;
            }
            // Only return fallback softMatch if it does not match upcoming content
            if (softMatch && this.#matchesUpcomingSibling(ctx, softMatch, node)) return null;
            return softMatch;
        }
        #isSoftMatch(oldNode, newNode) {
            if (!(oldNode instanceof Element) || oldNode.tagName !== newNode.tagName) return false;
            // Script tags must be identical to match - never patch a script with different content
            if (oldNode.tagName === 'SCRIPT' && !oldNode.isEqualNode(newNode)) return false;
            return !oldNode.id || oldNode.id === newNode.id;
        }
        #removeNode(ctx, node) {
            if (ctx.idMap.has(node)) this.#moveBefore(ctx.pantry, node, null);
            else {
                this.#cleanup(node);
                node.remove();
            }
        }
        #moveBefore(parentNode, element, after) {
            if (parentNode.moveBefore) try {
                parentNode.moveBefore(element, after);
                return;
            } catch (e) {
            // ignore and insertBefore instead
            }
            parentNode.insertBefore(element, after);
        }
        #morphNode(oldNode, newNode, ctx) {
            if (oldNode.nodeType === 3) {
                if (oldNode.nodeValue !== newNode.nodeValue) oldNode.nodeValue = newNode.nodeValue;
                return;
            }
            if (this.config.morphSkip && oldNode.matches?.(this.config.morphSkip)) return;
            // Trigger extension hook - if returns false, skip morphing this node
            if (!this.#triggerExtensions(oldNode, "htmx:before:morph:node", {
                oldNode: oldNode,
                newNode: newNode
            })) return;
            this.#copyAttributes(oldNode, newNode);
            if (oldNode instanceof HTMLTextAreaElement && document.activeElement !== oldNode && oldNode.defaultValue != newNode.defaultValue) oldNode.value = newNode.value;
            let skipChildren = this.config.morphSkipChildren && oldNode.matches?.(this.config.morphSkipChildren);
            // isEqualNode does not detect template content diff so always morph templates
            if (!skipChildren && (!oldNode.isEqualNode(newNode) || newNode.tagName === 'TEMPLATE' || newNode.querySelector?.('template'))) this.#morphChildren(ctx, oldNode, newNode);
        }
        #copyAttributes(destination, source) {
            let attributesToIgnore = this.config.morphIgnore || [];
            let needsReinit = false;
            let isHxAttr = (name)=>this.#prefixes('hx-').some((p)=>name.startsWith(p));
            for (const attr of source.attributes)if (!attributesToIgnore.some((p)=>attr.name.startsWith(p)) && destination.getAttribute(attr.name) !== attr.value) {
                if (isHxAttr(attr.name)) needsReinit = true;
                if (!this.#triggerExtensions(destination, 'htmx:before:morph:attr', {
                    attrName: attr.name,
                    newValue: attr.value
                })) continue;
                destination.setAttribute(attr.name, attr.value);
                if (attr.name === "value" && destination instanceof HTMLInputElement && destination.type !== "file" && document.activeElement !== destination) destination.value = attr.value;
            }
            for(let i = destination.attributes.length - 1; i >= 0; i--){
                let attr = destination.attributes[i];
                if (attr && !source.hasAttribute(attr.name) && !attributesToIgnore.some((p)=>attr.name.startsWith(p))) {
                    if (isHxAttr(attr.name)) needsReinit = true;
                    if (!this.#triggerExtensions(destination, 'htmx:before:morph:attr', {
                        attrName: attr.name,
                        newValue: null
                    })) continue;
                    destination.removeAttribute(attr.name);
                }
            }
            if (needsReinit) this.#cleanup(destination, true);
        }
        #populateIdMapWithTree(idMap, persistentIds, root, elements) {
            for (const elt of elements)if (persistentIds.has(elt.id)) {
                let current = elt;
                while(current && current !== root){
                    let idSet = idMap.get(current);
                    if (idSet == null) {
                        idSet = new Set();
                        idMap.set(current, idSet);
                    }
                    idSet.add(elt.id);
                    current = current.parentElement;
                }
            }
        }
        #createIdMaps(oldNode, newContent) {
            let oldIdElements = this.#queryEltAndDescendants(oldNode, "[id]");
            let newIdElements = newContent.querySelectorAll("[id]");
            let persistentIds = this.#createPersistentIds(oldIdElements, newIdElements);
            let idMap = new Map();
            this.#populateIdMapWithTree(idMap, persistentIds, oldNode.parentElement, oldIdElements);
            this.#populateIdMapWithTree(idMap, persistentIds, newContent, newIdElements);
            return {
                persistentIds: persistentIds,
                idMap: idMap
            };
        }
        #createPersistentIds(oldIdElements, newIdElements) {
            let duplicateIds = new Set(), oldIdTagNameMap = new Map();
            for (const { id: id, tagName: tagName } of oldIdElements){
                if (oldIdTagNameMap.has(id)) duplicateIds.add(id);
                else if (id) oldIdTagNameMap.set(id, tagName);
            }
            let persistentIds = new Set();
            for (const { id: id, tagName: tagName } of newIdElements){
                if (persistentIds.has(id)) duplicateIds.add(id);
                else if (oldIdTagNameMap.get(id) === tagName) persistentIds.add(id);
            }
            for (const id of duplicateIds)persistentIds.delete(id);
            return persistentIds;
        }
        #handleStatusCodes(ctx) {
            let status = ctx.response.raw.status;
            let noSwapStrings = this.config.noSwap.map((x)=>x + "");
            let str = status + "";
            for (let pattern of [
                str,
                str.slice(0, 2) + 'x',
                str[0] + 'xx'
            ]){
                if (noSwapStrings.includes(pattern)) {
                    ctx.swap = "none";
                    return;
                }
                let statusValue = this.#attributeValue(ctx.sourceElement, "hx-status:" + pattern);
                if (statusValue) {
                    HCON.merge(statusValue, ctx);
                    return;
                }
            }
        }
        #submitTransitionTask(task, ctx) {
            return new Promise((resolve)=>{
                this.#transitionQueue ||= [];
                this.#transitionQueue.push({
                    task: task,
                    resolve: resolve,
                    ctx: ctx
                });
                if (!this.#processingTransition) this.#processTransitionQueue();
            });
        }
        async #processTransitionQueue() {
            if (this.#transitionQueue.length === 0 || this.#processingTransition) return;
            this.#processingTransition = true;
            let { task: task, resolve: resolve, ctx: ctx } = this.#transitionQueue.shift();
            try {
                if (document.startViewTransition) {
                    let detail = {
                        task: task,
                        ctx: ctx
                    };
                    this.#trigger(ctx.sourceElement, "htmx:before:viewTransition", detail);
                    await document.startViewTransition(detail.task).finished;
                    this.#trigger(ctx.sourceElement, "htmx:after:viewTransition", detail);
                } else await task();
            } catch (e) {
            // Transitions can be skipped/aborted - this is normal
            } finally{
                this.#processingTransition = false;
                resolve();
                this.#processTransitionQueue();
            }
        }
        #startCSSTransitions(fragment, root) {
            let idElements = root.querySelectorAll("[id]");
            let existingElementsById = Object.fromEntries([
                ...idElements
            ].map((e)=>[
                    e.id,
                    e
                ]));
            let newElementsWithIds = fragment.querySelectorAll("[id]");
            let restoreTasks = [];
            for (let elt of newElementsWithIds){
                let existing = existingElementsById[elt.id];
                if (existing?.tagName === elt.tagName) {
                    let clone = elt.cloneNode(false); // shallow clone node
                    this.#copyAttributes(elt, existing);
                    restoreTasks.push(()=>{
                        this.#copyAttributes(elt, clone);
                    });
                }
            }
            return restoreTasks;
        }
        #addClass(elt, cls) {
            elt?.classList?.add?.(cls);
        }
        #removeClass(elt, cls) {
            elt?.classList?.remove?.(cls);
            if (elt?.classList?.length === 0) elt.removeAttribute('class');
        }
        #normalizeElement(cssOrElement) {
            if (typeof cssOrElement === "string") return this.find(cssOrElement);
            else return cssOrElement;
        }
        #maybeAdjustMetaCharacter(string) {
            if (this.config.metaCharacter) return string.replace(/:/g, this.config.metaCharacter);
            else return string;
        }
    }
    return new Htmx();
})();
if (typeof window !== "undefined") window.htmx = $c2f84a84ccd9d6f1$var$htmx;
var $c2f84a84ccd9d6f1$export$2e2bcd8739ae039 = $c2f84a84ccd9d6f1$var$htmx;


// Import vendor modules.

// ----------------------------------------------------------------------------------- //
// ----------------------------------------------------------------------------------- //
(0, $0712aa0f43f6aa4b$export$2e2bcd8739ae039).directive("meta-enter-submit", $ea22c87a6fd0f9f3$var$MetaEnterSubmitDirective);
// ----------------------------------------------------------------------------------- //
// ----------------------------------------------------------------------------------- //
/**
* I allow a form to be submitted with the meta-enter keyboard combo.
*/ function $ea22c87a6fd0f9f3$var$MetaEnterSubmitDirective(element, metadata, framework) {
    init();
    // ---
    // LIFE-CYCLE METHODS.
    // ---
    /**
  * I setup the directive.
  */ function init() {
        framework.cleanup(destroy);
        element.addEventListener("keydown", handleKeydown);
    }
    /**
  * I tear down the directive.
  */ function destroy() {
        element.removeEventListener("keydown", handleKeydown);
    }
    // ---
    // PRIVATE METHODS.
    // ---
    /**
  * I handle the keydown event.
  */ function handleKeydown(event) {
        if (event.key === "Enter" && (event.metaKey || event.ctrlKey)) {
            var button = metadata.expression ? element.form.querySelector(metadata.expression) : null;
            event.preventDefault();
            element.form.requestSubmit(button);
        }
    }
}


// Import vendor modules.

// ----------------------------------------------------------------------------------- //
// ----------------------------------------------------------------------------------- //
(0, $0712aa0f43f6aa4b$export$2e2bcd8739ae039).directive("scroll-to", $a1fcb25dc94fe66b$var$ScrollToDirective);
// ----------------------------------------------------------------------------------- //
// ----------------------------------------------------------------------------------- //
function $a1fcb25dc94fe66b$var$ScrollToDirective(element, metadata, framework) {
    var target = metadata.expression ? document.querySelector(metadata.expression) : element;
    if (target) target.scrollIntoView();
}







var $54cc287316f3384f$exports = {};

var $acc239d2f5eb9e51$exports = {};
// Import vendor modules.

// ----------------------------------------------------------------------------------- //
// ----------------------------------------------------------------------------------- //
(0, $0712aa0f43f6aa4b$export$2e2bcd8739ae039).data("podt7m_Nav", $acc239d2f5eb9e51$var$Nav);
(0, $0712aa0f43f6aa4b$export$2e2bcd8739ae039).data("podt7m_Theme", $acc239d2f5eb9e51$var$Theme);
// ----------------------------------------------------------------------------------- //
// ----------------------------------------------------------------------------------- //
function $acc239d2f5eb9e51$var$Nav() {
    return {
        close: close,
        isOpen: isOpen,
        open: open,
        toggleMenu: toggleMenu
    };
    // ---
    // LIFE-CYCLE METHODS.
    // ---
    // ---
    // PUBLIC METHODS.
    // ---
    function close() {
        this.$refs.menu.classList.remove("open");
    }
    function open() {
        this.$refs.menu.classList.add("open");
    }
    function toggleMenu() {
        if (this.isOpen()) this.close();
        else this.open();
    }
    // ---
    // PRIVATE METHODS.
    // ---
    /**
  * I determine if the menu is currently toggled open.
  */ function isOpen() {
        return this.$refs.menu.classList.contains("open");
    }
}
// ----------------------------------------------------------------------------------- //
// ----------------------------------------------------------------------------------- //
function $acc239d2f5eb9e51$var$Theme() {
    return {
        setTheme: setTheme
    };
    // ---
    // PUBLIC METHODS.
    // ---
    /**
  * I persist the theme preference for the site.
  */ function setTheme(event) {
        if (!window.localStorage || !window.matchMedia) return;
        var target = event.currentTarget;
        var theme = target.dataset.theme;
        var prefersDark = window.matchMedia("( prefers-color-scheme: dark )").matches;
        var prefersLight = !prefersDark;
        document.documentElement.setAttribute("data-theme", theme);
        // When the user toggles the theme, we want to, if possible, UNSET the persisted
        // value so that we can keep the theme in alignment with the system preferences.
        // So, if the user is toggling the theme back to one that matches the current
        // system preferences, then we want REMOVE the storage item so that any system-
        // level changes will be reflected implicitly in the future.
        // --
        // Caution: Some browsers throw an error when accessing the local storage API even
        // when it exists.
        try {
            if (theme === "light" && prefersLight || theme === "dark" && prefersDark) localStorage.removeItem("theme");
            else localStorage.setItem("theme", theme);
        } catch (error) {
            console.warn("Local storage access error", error);
        }
    }
}






var $50795c83a57d98c3$exports = {};
// Import vendor modules.

// Import application modules.
// Regular expression patterns for testing content-type response headers.
var $3c90b13b6519bc54$var$RE_CONTENT_TYPE_JSON = new RegExp("^application/(json|x-json|[\\w.-]+\\+json)\\b", "i");
var $3c90b13b6519bc54$var$RE_CONTENT_TYPE_TEXT = new RegExp("^text/", "i");
// Static strings.
var $3c90b13b6519bc54$var$UNEXPECTED_ERROR_MESSAGE = "An unexpected error occurred while processing your request.";
class $3c90b13b6519bc54$export$40f4c0b52fedfe21 extends Error {
    /**
  * I initialize the API client error.
  */ constructor(config){
        var type = config.type ?? "ServerError";
        var domainType = config.domainType ?? "";
        var status = config.status ?? 0;
        var message = domainType ? `${domainType} (${status})` : `${type} (${status})`;
        super(message, {
            cause: config.cause
        });
        this.type = type;
        this.domainType = domainType;
        this.name = "ApiClientError";
        this.userMessage = config.userMessage || $3c90b13b6519bc54$var$UNEXPECTED_ERROR_MESSAGE;
        this.status = status;
        this.attempts = 1;
    }
}
class $3c90b13b6519bc54$export$dc890958d2b428da {
    /**
  * I make the API request with the given configuration options. Note that some options
  * are ignored / overwritten based on the type of request.
  *
  * GUARANTEE: All errors produced by this method will be instances of ApiClientError;
  * and will have a consistent structure even if they are low-level networking errors.
  */ async makeRequest(config) {
        // All of the fetch preamble runs in its own try/catch so that we can clearly
        // delineate the client-errors (ie, bad config) from the fetch-errors. Client
        // errors cannot be retried until the developer fixes the calling context.
        try {
            // Extract options, with defaults, from config.
            var headers = config.headers || undefined;
            var method = config.method || null;
            var url = config.url || "";
            var params = config.params ?? Object.create(null);
            var form = config.form ?? null;
            var json = config.json ?? null;
            var body = config.body ?? null;
            var signal = config.signal ?? null;
            // The fetch* variables are the values that we'll actually use to generate
            // the fetch() call. We're going to assign these based on the configuration
            // data that was passed-in.
            var fetchHeaders = new Headers(headers);
            var fetchContentType = fetchHeaders.get("content-type");
            var fetchMethod = null;
            var fetchUrl = this.buildUrl(url, params);
            var fetchBody = null;
            var fetchSignal = signal;
            if (form) {
                // NOTE: For form data posts, we want the browser to build the Content-
                // Type for us so that it puts in both the "multipart/form-data" plus the
                // correct, auto-generated field delimiter.
                fetchHeaders.delete("content-type");
                // ColdFusion will only parse the form data if the method is POST.
                fetchMethod = "post";
                fetchBody = this.buildFormData(form);
            } else if (json) {
                fetchHeaders.set("content-type", fetchContentType || "application/json");
                fetchMethod = method || "post";
                fetchBody = JSON.stringify(json);
            } else if (body) {
                // When a body is going to be posted, we're going to allow fetch to infer
                // the content-type based on the payload.
                fetchMethod = method || "post";
                fetchBody = body;
            } else fetchMethod = method || "get";
            var fetchRequest = new window.Request(fetchUrl, {
                headers: fetchHeaders,
                method: fetchMethod.toUpperCase(),
                body: fetchBody,
                signal: fetchSignal
            });
        } catch (error) {
            throw new $3c90b13b6519bc54$export$40f4c0b52fedfe21({
                type: "ClientError",
                cause: error
            });
        }
        // Now that we've made it through the config parsing and request setup phase, we
        // can perform a try/catch for the fetch and body reading. This reads the body as
        // an opaque blob - casting the blob to the appropriate type happens in the next
        // phase.
        try {
            var fetchResponse = await window.fetch(fetchRequest);
            var fetchBlob = await fetchResponse.blob();
        } catch (error) {
            var type = fetchSignal !== null && fetchSignal !== void 0 && fetchSignal.aborted ? "AbortError" : "TransportError";
            throw new $3c90b13b6519bc54$export$40f4c0b52fedfe21({
                type: type,
                cause: error
            });
        }
        // Now that we've made it through the network request and body consumption phase,
        // we need to cast the opaque blob into the appropriate data type. At this point,
        // the response content is fully loaded in memory; so any error that occurs here
        // is strictly a parsing error and not a transport error.
        try {
            var contentType = fetchResponse.headers.get("content-type") ?? "";
            var data = await this.parseResponseBody(contentType, fetchBlob);
        } catch (error) {
            throw new $3c90b13b6519bc54$export$40f4c0b52fedfe21({
                type: "ParseError",
                status: fetchResponse.status,
                cause: error
            });
        }
        if (fetchResponse.ok) return data;
        // The request came back with a non-2xx status code; but may still contain an
        // error structure that is defined by our business domain.
        // --
        // If the error data is an Object (which it should be if the server responded with
        // a domain-based error), then it should have "type" and "message" properties
        // within it. That said, just because this isn't a transport error, it doesn't
        // mean that this error is actually being returned by our application.
        if (typeof (data === null || data === void 0 ? void 0 : data.type) === "string" && typeof (data === null || data === void 0 ? void 0 : data.message) === "string") throw new $3c90b13b6519bc54$export$40f4c0b52fedfe21({
            type: "DomainError",
            domainType: data.type,
            userMessage: data.message,
            status: fetchResponse.status
        });
        // If the error data has any other shape, it means that an unexpected error
        // occurred on the server (or somewhere in transit). Let's pass that raw data
        // through as the cause, using the default error structure.
        throw new $3c90b13b6519bc54$export$40f4c0b52fedfe21({
            status: fetchResponse.status,
            cause: data
        });
    }
    /**
  * I provide a proxy to the makeRequest() method and add retry mechanics. If the
  * request rejects with a retryable error, a back-off will be applied to retry the
  * request several times before giving up.
  *
  * GUARANTEE: All errors produced by this method will be instances of ApiClientError;
  * and will have a consistent structure even if they are low-level networking errors.
  */ async makeRequestWithRetry(config) {
        // Rather than relying on the maths to do back-off calculations, this collection
        // provides an explicit set of back-off values (in milliseconds). This collection
        // also doubles as the number of attempts that we should execute against the
        // underlying makeRequest() method.
        // --
        // NOTE: Some randomness will be applied to these values as execution time.
        var backoffDurations = [
            200,
            700,
            1000,
            2000,
            4000,
            // 8000,
            // 16000,
            0 // Indicates that the last timeout should be recorded as an error.
        ];
        // We're going to record the number of attempts into any error that bubbles-up.
        var attempts = 0;
        for (var retryDelay of backoffDurations){
            attempts++;
            try {
                return await this.makeRequest(config);
            } catch (error) {
                // NOTE: In some cases, we would want to inspect the HTTP METHOD in order
                // to see if it is retryable (and perhaps only allow GET requests to be
                // retried). However, since this API Client has a separate method designed
                // specifically for retries, we are going to assume that the calling
                // context understands when it IS OK and IS NOT OK to retry. Therefore, we
                // are only going to look at the returned error as a means to to determine
                // if retry is the best next step.
                if (!retryDelay || !this.isRetryableError(error)) {
                    error.attempts = attempts;
                    throw error;
                }
                console.warn(`API request failed, retrying in ${retryDelay}ms.`);
                await this.blockAndWait(this.applyJitter(retryDelay), config === null || config === void 0 ? void 0 : config.signal);
            }
        }
    }
    // ---
    // PRIVATE METHODS.
    // ---
    /**
  * I apply a +/- 20% offset to the current value (a small attempt to prevent the
  * stampeding herd problem).
  */ applyJitter(value) {
        // Generate a +/- 20% delta from the original value.
        var percentJitter = (20 - Math.floor(Math.random() * 40)) / 100;
        var jitter = value * percentJitter;
        return Math.floor(value + jitter);
    }
    /**
  * I return a Promise that is resolved after the given timeout. The internal timer can
  * be canceled with an optional AbortSignal.
  *
  * Note: if the underlying wait is aborted via the signal, the returned Promise will
  * resolve immediately. This should NOT be a problem for the calling context because
  * the subsequent retry-fetch will short-circuit and throw an error due to the reuse of
  * the already-aborted signal.
  */ blockAndWait(durationInMilliseconds, signal) {
        var promise = new Promise((resolve)=>{
            // When the calling context triggers an abort, we need to listen for it so
            // that we can turn around and clear the internal timer.
            // --
            // NOTE: We're creating a proxy callback for our resolve function in order
            // to remove this event-listener once the timer executes. This way, our
            // event-handler never gets invoked if there's nothing for it to actually
            // do. Also note that the "abort" event will only ever get emitted once,
            // regardless of how many times the calling context tries to invoke
            // .abort() on its AbortController.
            signal === null || signal === void 0 || signal.addEventListener("abort", handleAbort);
            // Setup our internal timer that we can clear-on-abort.
            var internalTimer = setTimeout(internalResolve, durationInMilliseconds);
            // -- Internal methods. -- //
            function internalResolve() {
                signal === null || signal === void 0 || signal.removeEventListener("abort", handleAbort);
                resolve(durationInMilliseconds);
            }
            function handleAbort() {
                clearTimeout(internalTimer);
                resolve(-1);
            }
        });
        return promise;
    }
    /**
  * I build a FormData instance from the given object.
  *
  * NOTE: At this time, only simple values (ie, no files) are supported.
  */ buildFormData(formFields) {
        var formData = new FormData();
        Object.entries(formFields).forEach(([key, value])=>{
            formData.append(key, value);
        });
        return formData;
    }
    /**
  * I build the URL for the fetch request by merging any arbitrary search parameters
  * into the already formed URL. Parameter collisions give precedence to the passed-in
  * params object.
  */ buildUrl(url, params) {
        if (!url) throw new Error("Url is empty");
        var fetchUrl = new URL(url, window.location.href);
        for (var [key, value] of Object.entries(params))fetchUrl.searchParams.set(key, value);
        return fetchUrl;
    }
    /**
  * I try to determine if the given request-error object indicates that the original
  * request can be retried.
  */ isRetryableError(error) {
        // If the configuration is bad, retrying would only yield the same failure. The
        // developer has to fix the bug in the calling context.
        if (error.type === "ClientError") return false;
        // If the error was triggered by an explicit Abort, we don't want to retry it -
        // it was terminated early on purpose by the calling context.
        if (error.type === "AbortError") return false;
        return error.status === 0 || // Various network failures.
        error.status === 408 || // Request timeout.
        error.status === 429 || // Too many requests (ie, rate limiting).
        error.status >= 500 // Basically all unexpected server errors.
        ;
    }
    /**
  * I cast the given response binary into the appropriate data type based on the HTTP
  * response content-type header. Any parsing error that occurs is allowed to bubble up
  * to the calling context.
  */ async parseResponseBody(contentType, blob) {
        if ($3c90b13b6519bc54$var$RE_CONTENT_TYPE_JSON.test(contentType)) {
            var text = await blob.text();
            if (!text) return null;
            return JSON.parse(text);
        }
        if ($3c90b13b6519bc54$var$RE_CONTENT_TYPE_TEXT.test(contentType)) return await blob.text();
        if (!blob.size) return null;
        return blob;
    }
}


var $c57c2604a6387eb4$export$407ca81eb46778dd = new (0, $3c90b13b6519bc54$export$dc890958d2b428da)();


// ----------------------------------------------------------------------------------- //
// ----------------------------------------------------------------------------------- //
(0, $0712aa0f43f6aa4b$export$2e2bcd8739ae039).data("z8a31z_BlogPost", $50795c83a57d98c3$var$BlogPost);
(0, $0712aa0f43f6aa4b$export$2e2bcd8739ae039).data("z8a31z_Title", $50795c83a57d98c3$var$Title);
(0, $0712aa0f43f6aa4b$export$2e2bcd8739ae039).data("z8a31z_RelatedBlogPosts", $50795c83a57d98c3$var$RelatedBlogPosts);
// ----------------------------------------------------------------------------------- //
// ----------------------------------------------------------------------------------- //
function $50795c83a57d98c3$var$BlogPost() {
    return {
        init: init,
        applySyntaxHighlighting: applySyntaxHighlighting
    };
    // ---
    // LIFE-CYCLE METHODS.
    // ---
    function init() {
        this.applySyntaxHighlighting();
    }
    // ---
    // PRIVATE METHODS.
    // ---
    async function applySyntaxHighlighting() {
        var codeNodes = document.querySelectorAll("#blog-post pre code");
        var languageBlocks = [];
        codeNodes.forEach((node, i)=>{
            var parts = (node.getAttribute("class") ?? "").split("-");
            var prefix = parts.shift();
            if (prefix !== "language") return;
            var language = parts.join("-");
            if (!language) return;
            var code = node.textContent;
            languageBlocks.push({
                node: node,
                language: language,
                code: code
            });
        });
        if (!languageBlocks.length) return;
        var blocks = languageBlocks.map((element)=>{
            return {
                language: element.language,
                code: element.code
            };
        });
        var payload = JSON.stringify(blocks);
        var startedAt = Date.now();
        var startedVisibility = document.visibilityState;
        try {
            var response = await (0, $c57c2604a6387eb4$export$407ca81eb46778dd).makeRequestWithRetry({
                method: "post",
                url: "/index.cfm?event=api.blog.highlight",
                form: {
                    blocks: payload
                }
            });
        } catch (error) {
            var _window$Bugsnag;
            // Note: no AbortSignal is used today; but if we add one in the future, this
            // will prevent the aborted request from being logged.
            if (error.type === "AbortError") return;
            // If the tab loaded in the background, there's a good chance it will fail due
            // to the way the browser prioritizes and manages background activity. We
            // don't need to log those failures as they are out of our control.
            if (startedVisibility === "hidden") return;
            console.warn("Failed to apply syntax highlighting to page.");
            console.error(error);
            (_window$Bugsnag = window.Bugsnag) === null || _window$Bugsnag === void 0 || _window$Bugsnag.notify(error, (event)=>{
                var _error$cause, _error$cause2, _navigator$connection;
                event.context = "syntax-highlighting";
                event.addMetadata("ApiClient", {
                    type: error.type,
                    domainType: error.domainType,
                    status: error.status,
                    causeName: (_error$cause = error.cause) === null || _error$cause === void 0 ? void 0 : _error$cause.name,
                    causeMessage: (_error$cause2 = error.cause) === null || _error$cause2 === void 0 ? void 0 : _error$cause2.message
                });
                event.addMetadata("Diagnostics", {
                    attempts: error.attempts,
                    elapsedMs: Date.now() - startedAt,
                    pageAgeMs: Math.round(performance.now()),
                    startedVisibility: startedVisibility,
                    failedVisibility: document.visibilityState,
                    onLine: navigator.onLine,
                    webdriver: navigator.webdriver,
                    effectiveType: (_navigator$connection = navigator.connection) === null || _navigator$connection === void 0 ? void 0 : _navigator$connection.effectiveType,
                    blockCount: blocks.length,
                    payloadLength: payload.length
                });
            });
            return;
        }
        for (var [i, html] of response.results.entries())languageBlocks[i].node.innerHTML = html;
    }
}
// ----------------------------------------------------------------------------------- //
// ----------------------------------------------------------------------------------- //
function $50795c83a57d98c3$var$Title() {
    return {
        highlight: highlight
    };
    // ---
    // PUBLIC METHODS.
    // ---
    /**
  * I select the whole title value.
  */ function highlight() {
        var range = document.createRange();
        range.selectNode(this.$el);
        var selection = window.getSelection();
        selection.removeAllRanges();
        selection.addRange(range);
    }
}
// ----------------------------------------------------------------------------------- //
// ----------------------------------------------------------------------------------- //
function $50795c83a57d98c3$var$RelatedBlogPosts() {
    return {
        expand: expand
    };
    // ---
    // PUBLIC METHODS.
    // ---
    /**
  * I expand the list of related blog posts (this removes the ability to collapse since
  * this doesn't need to be a two-way action).
  */ function expand() {
        this.$refs.actions.classList.add("m-related-posts__actions--hidden");
        this.$refs.list.classList.remove("m-related-posts__list--truncated");
        this.$refs.list.querySelector("a").focus();
    }
}








var $bb09fe56fed95d82$exports = {};
// Import vendor modules.

// ----------------------------------------------------------------------------------- //
// ----------------------------------------------------------------------------------- //
(0, $0712aa0f43f6aa4b$export$2e2bcd8739ae039).data("t83aic_CommentContent", $bb09fe56fed95d82$var$CommentContent);
// ----------------------------------------------------------------------------------- //
// ----------------------------------------------------------------------------------- //
function $bb09fe56fed95d82$var$CommentContent() {
    return {
        init: init
    };
    // ---
    // LIFE-CYCLE METHODS.
    // ---
    /**
  * I initialize the component.
  */ function init() {
        $bb09fe56fed95d82$var$initFencedCodeBlocks(this.$el);
        $bb09fe56fed95d82$var$initStyleModifiers(this.$el);
    }
}
// ----------------------------------------------------------------------------------- //
// ----------------------------------------------------------------------------------- //
function $bb09fe56fed95d82$var$initFencedCodeBlocks(input) {
    // Figure out which whitespace characters we need to use when adjusting our
    // textarea value.
    var newline = getLineDelimiter();
    var tabber = "\t"; // You could also use spaces here, if that's your thing.
    input.addEventListener("keydown", function(event) {
        if (isRelevantKeyEvent(event) && isSelectionInCodeBlock(input)) {
            applyKeyEventToCodeBlock(input, event);
            // Since we're programmatically applying the key to the contextual
            // code-block, we don't want the default browser behavior to take
            // place - we are going to manually apply the key to the input state.
            event.preventDefault();
        }
    }, false);
    // --------------------------------------------------------------------------- //
    // --------------------------------------------------------------------------- //
    // I apply the given keyboard event to the given input.
    // --
    // NOTE: At this point, the calling context has already determined that the event
    // is relevant and needs to be applied.
    function applyKeyEventToCodeBlock(input, event) {
        var state = getInputState(input);
        // Each method here takes the input state and return a new one. We can then
        // take the new state and re-apply it to the input.
        if (isTabEvent(event)) state = insertTabAtSelection(state);
        else if (isShiftTabEvent(event)) state = insertShiftTabAtSelection(state);
        else if (isEnterEvent(event)) state = insertEnterAtSelection(state);
        else if (isShiftEnterEvent(event)) state = insertShiftEnterAtSelection(state);
        setInputState(input, state);
    }
    // I find the index of the end-line that contains the given offset.
    function findEndOfLine(value, offset) {
        return value.indexOf(newline, offset);
    }
    // I find the index of the line-start that contains the given offset.
    function findStartOfLine(value, offset) {
        var delimiter = /[\r\n]/i;
        // Starting at the current offset, let's start walking backwards through the
        // value until we either run out of characters; or, we hit a character that
        // represents some line delimiter.
        for(var i = offset - 1; i >= 0; i--){
            if (delimiter.test(value.charAt(i))) return i + 1;
        }
        return 0;
    }
    // I get the current selection state of the given input.
    function getInputState(input) {
        return {
            value: input.value,
            start: input.selectionStart,
            end: input.selectionEnd
        };
    }
    // I calculate and return the newline implementation for the current browser.
    // Different operating systems and browsers implement a "newline" with different
    // character combinations.
    function getLineDelimiter() {
        var fragment = document.createElement("textarea");
        fragment.value = "\r\n";
        return fragment.value;
    }
    // I apply an ENTER key change to the given input state. This will add a newline
    // at the given selection point, starting the subsequent line at the same
    // indentation as the preceding line.
    function insertEnterAtSelection(state) {
        var value = state.value;
        var start = state.start;
        var leadingTabs = value.slice(findStartOfLine(value, start), start).match(new RegExp("^(?:" + tabber + ")+", "i"));
        var tabCount = leadingTabs ? leadingTabs[0].length / tabber.length : 0;
        var preDelta = value.slice(0, start);
        var postDelta = value.slice(start);
        var delta = newline + repeat(tabber, tabCount);
        return {
            value: preDelta + delta + postDelta,
            start: start + delta.length,
            end: start + delta.length
        };
    }
    // I apply a TAB key change to the given input state. This will increase the
    // indentation of the lines contained within the given selection.
    function insertTabAtSelection(state) {
        var value = state.value;
        var start = state.start;
        var end = state.end;
        // If the selection has length zero, then we're simply inserting a tab
        // character at the current location. However, if the selection crosses
        // multiple characters, then we're going to adjust the indentation of
        // the lines affected by the selection.
        var deltaStart = start === end ? start : findStartOfLine(value, start);
        var deltaEnd = end;
        var deltaValue = value.slice(deltaStart, deltaEnd);
        var preDelta = value.slice(0, deltaStart);
        var postDelta = value.slice(deltaEnd);
        // Insert a tabber at the start of the delta, plus any contained newline.
        var replacement = deltaValue.replace(/^/gm, tabber);
        var newValue = preDelta + replacement + postDelta;
        var newStart = start + tabber.length;
        var newEnd = end + (replacement.length - deltaValue.length);
        return {
            value: newValue,
            start: newStart,
            end: newEnd
        };
    }
    // I apply a SHIFT+ENTER key change to the given input state. This will add a
    // newline after the line of the current selection start, starting the new line
    // as the same indentation as the preceding line.
    function insertShiftEnterAtSelection(state) {
        var value = state.value;
        var start = state.start;
        var leadingTabs = value.slice(findStartOfLine(value, start), start).match(new RegExp("^(?:" + tabber + ")+", "i"));
        var tabCount = leadingTabs ? leadingTabs[0].length / tabber.length : 0;
        var deltaStart = findEndOfLine(value, start);
        var preDelta = value.slice(0, deltaStart);
        var postDelta = value.slice(deltaStart);
        var delta = newline + repeat(tabber, tabCount);
        return {
            value: preDelta + delta + postDelta,
            start: deltaStart + delta.length,
            end: deltaStart + delta.length
        };
    }
    // I apply a SHIFT+TAB key change to the given input state. This will decrease
    // the indentation of the lines contained within the given selection.
    function insertShiftTabAtSelection(state) {
        var value = state.value;
        var start = state.start;
        var end = state.end;
        var deltaStart = findStartOfLine(value, start);
        var deltaEnd = end;
        var deltaValue = value.slice(deltaStart, deltaEnd);
        var deltaHasLeadingTab = deltaValue.indexOf(tabber) === 0;
        var preDelta = value.slice(0, deltaStart);
        var postDelta = value.slice(deltaEnd);
        var replacement = deltaValue.replace(new RegExp("^" + tabber, "gm"), "");
        var newValue = preDelta + replacement + postDelta;
        var newStart = deltaHasLeadingTab ? start - tabber.length : start;
        var newEnd = end - (deltaValue.length - replacement.length);
        return {
            value: newValue,
            start: newStart,
            end: newEnd
        };
    }
    // I determine if the given keyboard event represents the ENTER key.
    function isEnterEvent(event) {
        return event.key.toLowerCase() === "enter" && !event.shiftKey && !event.metaKey // Was messing with other feature.
        ;
    }
    // I determine if the given value is odd.
    function isOdd(value) {
        return value % 2 === 1;
    }
    // I determine if the given keyboard event is one of the events that we might
    // want to manage for use in a fenced code-block.
    function isRelevantKeyEvent(event) {
        return isTabEvent(event) || isShiftTabEvent(event) || isEnterEvent(event) || isShiftEnterEvent(event);
    }
    // I determine if the given input has a selection that is entirely contained
    // within a fenced code-block. This can be a multi-character selection or a
    // simple caret selection.
    function isSelectionInCodeBlock(input) {
        var state = getInputState(input);
        var selectedValue = state.value.slice(state.start, state.end);
        // If there is a code-fence contained within the selection, then the
        // selection crosses a code-block boundary and we don't want to mess with it.
        if (selectedValue.indexOf("```") >= 0) return false;
        // Get the number of code-fences that come before the start of the selection.
        var preSelectedValue = state.value.slice(0, state.start);
        var codeFences = preSelectedValue.match(/```/g);
        // If there are no fences before the selection then we know that we're not in
        // the middle of a fenced code-block.
        if (codeFences === null) return false;
        // If there are fences before the selection, an odd number will indicate that
        // we're inside a fenced code-block that has not yet been closed.
        return isOdd(codeFences.length);
    }
    // I determine if the given keyboard event represents the SHIFT+ENTER key.
    function isShiftEnterEvent(event) {
        return event.key.toLowerCase() === "enter" && event.shiftKey && !event.metaKey // Was messing with other feature.
        ;
    }
    // I determine if the given keyboard event represents the SHIFT+TAB key.
    function isShiftTabEvent(event) {
        return event.key.toLowerCase() === "tab" && event.shiftKey;
    }
    // I determine if the given keyboard event represents the TAB key (ensuring that
    // the SHIFT key is NOT also depressed).
    function isTabEvent(event) {
        return event.key.toLowerCase() === "tab" && !event.shiftKey;
    }
    // I repeat the given string the given number of times.
    function repeat(value, count) {
        return new Array(count + 1).join(value);
    }
    // I apply the given selection state to the given input.
    function setInputState(input, state) {
        // If the value hasn't actually changed, just return out. There's no need to
        // alter the selection settings if nothing changed in the value.
        if (input.value === state.value) return;
        input.value = state.value;
        input.selectionStart = state.start;
        input.selectionEnd = state.end;
        // Now that we've modified the input value, we need to emit an input event so that
        // the form knows to request a preview. I don't love this coupling, but it feels
        // like the correct semantic move.
        input.dispatchEvent(new InputEvent("input", {
            bubbles: true,
            composed: true,
            inputType: "insertText"
        }));
    }
}
// ----------------------------------------------------------------------------------- //
// ----------------------------------------------------------------------------------- //
function $bb09fe56fed95d82$var$initStyleModifiers(input) {
    input.addEventListener("keydown", function(event) {
        if (!isRelevantKeyEvent(event)) return;
        var state = getInputState();
        // Since the modifier characters are meaningful on their own (in prose), we
        // only want to wire the style modifiers up if there's a current selection.
        // Otherwise, let the user keep typing as-is.
        if (state.start === state.end) return;
        applyKeyEventToContent(event, state);
        event.preventDefault();
    }, false);
    // --------------------------------------------------------------------------- //
    // --------------------------------------------------------------------------- //
    // I apply the given event to the content, wrapping the selected text in a modifier.
    function applyKeyEventToContent(event, state) {
        if (isBoldEvent(event)) {
            var modifierStart = "**";
            var modifierEnd = "**";
        } else if (isItalicEvent(event)) {
            var modifierStart = "_";
            var modifierEnd = "_";
        } else if (isBracketEvent(event)) {
            var modifierStart = "[";
            var modifierEnd = "]";
        } else if (isParensEvent(event)) {
            var modifierStart = "(";
            var modifierEnd = ")";
        } else throw new Error("Unexpected Modifier");
        var prefix = state.value.slice(0, state.start);
        var infix = state.value.slice(state.start, state.end);
        var postfix = state.value.slice(state.end);
        var newValue = `${prefix}${modifierStart}${infix}${modifierEnd}${postfix}`;
        var newStart = state.start + modifierStart.length;
        var newEnd = state.end + modifierStart.length;
        setInputState({
            value: newValue,
            start: newStart,
            end: newEnd
        });
    }
    // I get the current selection state of the current input.
    function getInputState() {
        return {
            value: input.value,
            start: input.selectionStart,
            end: input.selectionEnd
        };
    }
    // I determine if the given keyboard event represents the BOLD (**) wrapper.
    function isBoldEvent(event) {
        return event.key === "*";
    }
    // I determine if the given keyboard event represents the [] wrapper.
    function isBracketEvent(event) {
        return event.key === "[";
    }
    // I determine if the given keyboard event represents the ITALIC (_) wrapper.
    function isItalicEvent(event) {
        return event.key === "_";
    }
    // I determine if the given keyboard event represents the () wrapper.
    function isParensEvent(event) {
        return event.key === "(";
    }
    // I determine if the given keyboard event is one of the events that we might want to
    // manage with our style updates.
    function isRelevantKeyEvent(event) {
        // At the very least, the bracket keys map to browser navigation when modified. As
        // such, we want to skip over any event that has a modifier other than Shift,
        // which is required for some of the events.
        if (event.metaKey || event.ctrlKey || event.altKey) return false;
        return isBoldEvent(event) || isItalicEvent(event) || isBracketEvent(event) || isParensEvent(event);
    }
    // I apply the given selection state to the given input.
    function setInputState(state) {
        input.value = state.value;
        input.selectionStart = state.start;
        input.selectionEnd = state.end;
        // Now that we've modified the input value, we need to emit an input event so that
        // the form knows to request a preview. I don't love this coupling, but it feels
        // like the correct semantic move.
        input.dispatchEvent(new InputEvent("input", {
            bubbles: true,
            composed: true,
            inputType: "insertText"
        }));
    }
}


var $df8b018263b44deb$exports = {};
// Import vendor modules.


// ----------------------------------------------------------------------------------- //
// ----------------------------------------------------------------------------------- //
(0, $0712aa0f43f6aa4b$export$2e2bcd8739ae039).data("r08qml_CommentForm", $df8b018263b44deb$var$CommentForm);
// ----------------------------------------------------------------------------------- //
// ----------------------------------------------------------------------------------- //
function $df8b018263b44deb$var$CommentForm() {
    return {
        previewTimer: null,
        author: null,
        comment: null,
        commentPreview: null,
        init: init,
        destroy: destroy,
        insertEmoji: insertEmoji,
        requestPreview: requestPreview
    };
    // ---
    // LIFE-CYCLE METHODS.
    // ---
    function init() {
        this.author = this.$el.querySelector("[data-author]") ?? null;
        this.comment = this.$el.querySelector("[data-comment-content]");
    }
    function destroy() {
        clearTimeout(this.previewTimer);
    }
    // ---
    // PUBLIC METHODS.
    // ---
    /**
  * I insert the given emoji (contained within the event) into the comment text.
  */ function insertEmoji(event) {
        var glyph = event.detail.emoji;
        var value = this.comment.value;
        var insertAt = this.comment.selectionEnd;
        var nextSelectionAt = insertAt + glyph.length;
        this.comment.value = value.slice(0, insertAt) + glyph + value.slice(insertAt);
        this.comment.selectionStart = nextSelectionAt;
        this.comment.selectionEnd = nextSelectionAt;
        this.comment.focus();
        this.requestPreview(event);
    }
    /**
  * I request a preview of the current comment markup.
  */ function requestPreview(event) {
        clearTimeout(this.previewTimer);
        this.previewTimer = setTimeout(async ()=>{
            var _this$author;
            // Passing the email through (if it exists) for error log insight.
            var authorEmail = ((_this$author = this.author) === null || _this$author === void 0 ? void 0 : _this$author.value) ?? "";
            var content = this.comment.value;
            await (0, $c2f84a84ccd9d6f1$export$2e2bcd8739ae039).ajax("POST", "/blog/comment/preview.htm", {
                select: ".m-comment-preview",
                target: "[data-comment-preview]",
                swap: "innerHTML",
                values: {
                    authorEmail: authorEmail,
                    content: content
                }
            });
        }, 300);
    }
}


var $ed16be351a69bf34$exports = {};
// Import vendor modules.

// ----------------------------------------------------------------------------------- //
// ----------------------------------------------------------------------------------- //
(0, $0712aa0f43f6aa4b$export$2e2bcd8739ae039).data("h5aqil_Emojis", $ed16be351a69bf34$var$Emojis);
// ----------------------------------------------------------------------------------- //
// ----------------------------------------------------------------------------------- //
function $ed16be351a69bf34$var$Emojis() {
    return {
        emitEmoji: emitEmoji
    };
    // ---
    // PUBLIC METHODS.
    // ---
    /**
  * I emit the emoji event associated with the target button.
  */ function emitEmoji(emoji) {
        this.$dispatch("emoji", {
            emoji: emoji
        });
    }
}






$54cc287316f3384f$exports = {
    "_shared": {
        "layout": {
            "column": {
                "less": {}
            },
            "standard": {
                "js": $acc239d2f5eb9e51$exports,
                "less": {}
            }
        }
    },
    "activity": {
        "recent": {
            "recent": {
                "less": {}
            }
        }
    },
    "blog": {
        "recent": {
            "recent": {
                "less": {}
            }
        },
        "tag": {
            "tag": {
                "less": {}
            }
        },
        "view": {
            "view": {
                "js": $50795c83a57d98c3$exports,
                "less": {}
            }
        },
        "_shared": {
            "tag": {
                "wantMorePosts": {
                    "less": {}
                }
            }
        },
        "comment": {
            "create": {
                "create": {
                    "less": {}
                }
            },
            "edit": {
                "edit": {
                    "less": {}
                }
            },
            "pending": {
                "pending": {
                    "less": {}
                }
            },
            "preview": {
                "preview": {
                    "less": {}
                }
            },
            "_shared": {
                "js": {
                    "commentContent": {
                        "js": $bb09fe56fed95d82$exports
                    },
                    "commentForm": {
                        "js": $df8b018263b44deb$exports
                    }
                },
                "tag": {
                    "emojis": {
                        "js": $ed16be351a69bf34$exports,
                        "less": {}
                    },
                    "formEtiquette": {
                        "less": {}
                    }
                }
            }
        }
    },
    "people": {
        "view": {
            "view": {
                "less": {}
            }
        }
    },
    "shortUrl": {
        "create": {
            "create": {
                "less": {}
            }
        }
    }
};


// ----------------------------------------------------------------------------------- //
// ----------------------------------------------------------------------------------- //
// Configure HTMX for the application.
(0, $c2f84a84ccd9d6f1$export$2e2bcd8739ae039).config.history = false;
// Note: the indicator CSS is being driven by <meta> tags now, and has to be, since the
// CSS injection is done during the HTMX initialization prior to this file being run. I'm
// leaving it here so that I don't try to collocate the configuration in the future.
// --
// htmx.config.includeIndicatorCSS = false;
window.Alpine = (0, $0712aa0f43f6aa4b$export$2e2bcd8739ae039);
// Note: Alpine.data() components must be registered before Alpine is started.
(0, $0712aa0f43f6aa4b$export$2e2bcd8739ae039).start();


//# sourceMappingURL=site.33576c67.js.map
